module.exports = {
  PleaseChooseJob: 'โปรดเลือกรายการจอง',
  NoSearchingInfo: 'ไม่มีการป้อนข้อมูลการสอบถาม',
  NoRecordMeetTheConditions: 'ไม่มีประวัติการสอบถามตรงตามข้อกำหนด',
  Error: 'เกิดข้อผิดพลาด',
  Locked: 'ล็อคแล้ว',
  UnKnownStatus: 'ไม่ทราบสถานะ',
  CloseDetailWindow: 'ปิดหน้าต่างรายละเอียด',
  AdvancedSearch: 'การสอบถามขั้นสูง',
  NoCustomersFoundPleaseRefreshCache: 'ลูกค้าไม่มีอยู่ลองรีเซ็ตแคช!',
  SelectedMonthHasBeenClosed: 'เดือนที่เลือกปัจจุบันถูกปิด',
  AccountClosedSuccessfully: 'ปิดบัญชีสำเร็จ',
  PleaseSelectClosingRecord: 'โปรดเลือกบันทึกการปิดบัญชี',
  ClosingRecordHasBeenApproved: 'บันทึกการปิดบัญชีได้รับการตรวจสอบแล้วและไม่สามารถยกเลิกได้',
  CancelTheClosingRecord: 'แน่ใจนะว่าต้องการยกเลิกบันทึกการปิดบัญชี',
  AccountClosingRecordCanceled: 'ยกเลิกการปิดบัญชี',
  CannotBeCancelledAfterApproval: 'บันทึกการปิดหลังจากการตรวจสอบไม่สามารถยกเลิกได้ แน่ใจหรือไม่?',
  ClosingDateAfterCancelingTheApproval: 'วันที่ปิดสามารถยกเลิกได้หลังจากยกเลิกการตรวจสอบ แน่ใจหรือไม่?',
  BillingType: 'ประเภทของใบแจ้งหนี้',
  ByTicket: 'ปมตั๋ว',
  InvitationListTip: 'ลูกค้าได้ส่งอาหารเสริมและเชิญคู่อีกครั้งหน้าอาหารเสริมของลูกค้าจะถูกปลดล็อคและอนุญาตให้ส่งอีกครั้งหลังจากการแก้ไข! จะดำเนินการต่อหรือไม่',
  PleaseClickFirst: 'กรุณาคลิกที่ "ยืนยันคู่" ก่อน',
  PleaseSelectTheFeeYouNeedToPush: 'โปรดเลือกค่าธรรมเนียมที่คุณต้องการซิงค์',
  PleaseSelectTheFeeYouNeedToCopy: 'โปรดเลือกค่าธรรมเนียมที่คุณต้องการคัดลอก',
  PleaseSeparateMultipleEmailAddressesWithCommas: 'ที่อยู่อีเมลหลายกล่องโปรดคั่นด้วยเครื่องหมายจุลภาค',
  PleaseSupplementOtherMailboxes: 'กรุณาเติมกล่องจดหมายอื่น',
  ContactAndEmailAreNotMaintained: 'ผู้ติดต่อและกล่องจดหมายที่ไม่ได้รับการบำรุงรักษา',
  PleaseSelectTheMaintainedContactAndMailbox: 'โปรดเลือกผู้ติดต่อที่ดูแลรักษาและกล่องจดหมาย',
  SelectMailbox: 'เลือกกล่องจดหมาย',
  InvoiceUuidCannotBeBlank: 'ใบแจ้งหนี้ uuid ไม่สามารถว่างเปล่าได้',
  TheSettlementUnitIDCannotBeEmpty: 'รหัสหน่วยการตั้งถิ่นฐานต้องไม่ว่างเปล่า!',
  PleaseEnterYourEmailAddress: 'กรุณากรอกกล่องจดหมาย',
  Monthly: 'ปมเดือน',
  PleaseSelectTheDataYouWantToExport: 'กรุณาเลือกข้อมูลที่ต้องการส่งออก',
  NoData: 'ไม่มีข้อมูล',
  PleaseSelectJob: 'โปรดตรวจสอบธุรกิจ',
  ThisJobIsNotWorkingCanNotBeEdited: 'แบบฟอร์มนี้ไม่ใช่สถานะการทำงานเชิงบวกและไม่สามารถแก้ไขได้',
  CanNotEditJob: 'ไม่สามารถแก้ไขธุรกิจของ {0} ได้!',
  TheSameSalesAndOperationsConfirmThatYouWantToSave: 'ขายและดำเนินการเหมือนกัน,ยืนยันอยากประหยัด?',
  SolicitationTypeIsNotTheSameAsSubBillDoYouWantToSaveIt: 'ประเภทของแพ็คเกจแตกต่างจาก Small Ticket คุณต้องการบันทึกหรือไม่?',
  WHNoRepeatedContinue: 'หมายเลขเข้าตำแหน่งซ้ำกัน จะดำเนินการต่อหรือไม่',
  Prompt: 'เคล็ดลับ',
  MblNoRepeatedContinue: 'หมายเลข MBL ซ้ำกัน, ยืนยันการบันทึก?',
  MblNoRepeatedNotCurrentCompanyContinue: 'หมายเลขเดียวที่คุณป้อนไม่ได้เป็นของสาขาปฏิบัติการหรือแผนกของธุรกิจปัจจุบันโปรดยืนยันว่าจะดำเนินการต่อ',
  MblNoRepeatedNotCurrentCompanyContinueAll: 'MBL ที่คุณป้อนซ้ำและไม่ได้อยู่ในสาขาการดำเนินงานหรือแผนกของธุรกิจปัจจุบันโปรดยืนยันว่าจะดำเนินการต่อ',
  MblNoSiRepeatedContinue: 'หมายเลขหลักซ้ำกัน,ยืนยันการเก็บหรือไม่',
  MblNoRepeatedNotSave: 'MB/L ไม่ 【{0}】 ทำซ้ำไม่อนุญาตให้บันทึก',
  AlreadyAssociatedWithOtherBranches: 'พันธมิตรสาขาอื่น ๆ ที่มีอยู่แล้ว 【{0}】 โปรดเลือกพันธมิตรอื่น ๆ สำหรับพันธมิตร!',
  CustomerRefNoRepeatedContinue: 'หมายเลขอ้างอิงธุรกิจซ้ำกัน, ยืนยันการบันทึก?',
  HblNoRepeatedContinue: 'หมายเลข HBL ซ้ำกัน คุณยืนยันการบันทึกหรือไม่?',
  SoNoRepeatedContinue: 'เลข SoNo ซ้ำกัน ยืนยันการบันทึกหรือไม่',
  HAWBRepeatedContinue: 'ไม่อนุญาตให้ทำซ้ำหมายเลขย่อย HAWB',
  HBLRepeatedContinue: 'ไม่อนุญาตให้ทำซ้ำกับเลขย่อย HBL',
  IATACodeRepeat: 'รหัส IATA ไม่สามารถทำซ้ำได้',
  AirCodeRepeat: 'สายการบินไม่สามารถทำซ้ำได้',
  AuthenticationFailed: 'การตรวจสอบล้มเหลว!',
  SaveSuccessfully: 'บันทึกความสำเร็จ',
  InvoiceNoLength: 'หมายเลขใบแจ้งหนี้ยาวมากโปรดตรวจสอบ',
  Success: 'ความสำเร็จ',
  ShutOutSuccessfully: 'การผ่านด่านศุลกากรสำเร็จ',
  CancellationSuccessfully: 'ความสำเร็จของโมฆะ',
  CancelShutOutSuccessfully: 'การยกเลิกพิธีการศุลกากรสำเร็จ',
  ThisTemplateCouldNotBeResolvedPleaseContactCS: 'ไม่สามารถวิเคราะห์เทมเพลตนี้ได้ โปรดติดต่อฝ่ายบริการลูกค้า',
  CurrentBranchIsNotSelectedCannotAddNewBookings: 'ไม่สามารถเพิ่มรายการสั่งซื้อได้โดยไม่ต้องเลือกสาขาปัจจุบัน',
  CompanySelectedIsHQCannotAddNewBookings: 'บริษัทเลือกเป็นสํานักงานใหญ่และไม่สามารถเพิ่มใบสั่งซื้อได้',
  TheLastOfTheNewStateHasBeenRestored: 'คืนสถานะใหม่เป็นครั้งที่แล้ว',
  CancelMotify: 'ยกเลิกการแก้ไขปัจจุบันหรือไม่',
  Info: 'ข้อมูล',
  NoBusinessCanBeSplit: 'ไม่มีธุรกิจให้แตกแยก',
  SplittingErrorContainerInformationIsEmpty: 'แยกผิดข้อมูลบรรจุว่างเปล่า',
  IsNotOperationStatus: 'ไม่ใช่สถานะการดำเนินงานที่เป็นบวก',
  SureDelete: 'แน่ใจที่จะลบ?',
  DeleteSuccessfully: 'ลบสำเร็จ',
  CustomerIssuing: 'ไม่มีติ๊กที่ลูกค้า HBL สั่งซื้อด้วยตนเองโปรดไปที่หน้า HBL เพื่อทำเครื่องหมาย',
  CustomerIssuingTips: 'สถานะการสั่งจ่าย: อยู่ระหว่างการรวบรวม / หัก ไฟล์ประเภท "Customer Outlet Order" จะดำเนินการต่อหรือไม่?',
  DirectBusiness: 'เดี่ยวตรง',
  SplittingBusiness: 'แยกแผ่น',
  NoPermissionToEditTheJob: 'ท่านไม่มีสิทธิ์แก้ไขแคชเชียร์เช็ค',
  HaveBusinessHasBeenSubmittedCannotBeShutOut: 'บันทึกที่เลือกรวมถึงมีธุรกิจตรวจสอบทางการเงินโปรดตรวจสอบ',
  HaveBusinessHasBeenShutOuted: 'บันทึกที่เลือกรวมถึงมีธุรกิจถอนศุลกากรโปรดตรวจสอบ',
  HaveBusinessHasBeenCancellation: 'บันทึกที่เลือกรวมถึงมีธุรกิจเป็นโมฆะขอให้ตรวจสอบ',
  PleaseRemoveThisTicketFromMblThenShutOutBatch: 'กรุณาย้ายตั๋วขนาดเล็กที่เลือกออกจากตั๋วหลักและขอคืนตั๋ว',
  PleaseRemoveAllTicketsFromMblThenShutOutBatch: 'กรุณาย้ายตั๋วขนาดเล็กทั้งหมดออกจากตั๋วหลักที่เลือกแล้วถอนตั๋วออก',
  HasChargeToShutOutTip: 'จะมีการดำเนินการถอนค่าธรรมเนียมสำหรับธุรกิจที่มีค่าธรรมเนียม ยืนยันหรือไม่',
  NoneChargeToShutOutTip: 'ก็จะมีการผ่อนปรนกิจการที่ไม่มีค่าธรรมเนียม ยืนยันหรือไม่',
  BusinessHasBeenSubmittedCannotBeShutOut: 'ธุรกิจได้ยื่นตรวจสอบทางการเงินแล้วไม่สามารถขอศุลกากรได้',
  NoPermissionToCancelTheShutOut: 'คุณไม่มีสิทธิ์ยกเลิกด่านศุลกากร',
  ConfirmToCancelTheShutOut: 'ยืนยันการยกเลิกพิธีการศุลกากร?',
  Warning: 'คำเตือน',
  NoChargeToShutOut: 'ยกเลิกค่าธรรมเนียม',
  HasChargeToShutOut: 'มีการยกเลิกค่าธรรมเนียม',
  PleaseConfirmTheShutOut: 'กรุณายืนยันการยกเลิก?',
  SendStatusChangeNotification: 'แจ้งการเปลี่ยนแปลงสถานะ',
  StatusChangeNotification: 'แจ้งการเปลี่ยนแปลงสถานะ (Insider)',
  OptionIsChecked: 'หากเลือกตัวเลือกนี้ จะมีการแจ้งเตือนการเปลี่ยนแปลง SOP ทั้งภายในและภายนอก',
  OnlyBeUsedForChangingCosts: 'สามารถเปลี่ยนแปลงได้เฉพาะค่าธรรมเนียมเท่านั้น',
  DoNotMakeAnyChanges: 'ไม่สามารถเปลี่ยนแปลงได้ (ค่าธรรมเนียมทั้งหมดจะถูกลบ)',
  IfDoNotClearTheConfirmationFeeDoNotAllowFreeShutOut: 'ค่าธรรมเนียมที่ได้รับการยืนยันไม่สามารถยกเลิกได้โดยไม่มีค่าธรรมเนียม',
  PleaseRemoveThisTicketFromMblThenShutOut: 'กรุณาย้ายตั๋วขนาดเล็กนี้ออกจากตั๋วหลักและขาออก',
  PleaseRemoveAllTicketsFromMblThenShutOut: 'กรุณาย้ายตั๋วขนาดเล็กทั้งหมดออกจากตั๋วหลักนี้และออกจากด่านศุลกากร',
  TicketsMustBeVoted: 'บัตรขนาดเล็กจะต้องเข้าร่วมบัตรหลัก',
  NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance: 'ค่าธรรมเนียมที่ต้องชำระไม่สามารถส่งล่วงหน้าได้หากไม่มีการตรวจสอบทั้งหมด',
  CommitSuccessfully: 'ส่งเรียบร้อยแล้ว',
  LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL: 'ตั๋วขนาดเล็กแบบ LCL ไม่สามารถยื่นแยกต่างหากได้ กรุณายื่นตั๋วหลัก',
  GenerateExpensesBasedOnCurrentSellingPriceAndBuyingPrice: 'ค่าใช้จ่ายจะถูกสร้างขึ้นตามราคาขายปัจจุบันราคาซื้อ?',
  PlatformCodeNotFound: 'ค่าธรรมเนียมการขนส่งทางอากาศที่มีรหัสแพลตฟอร์ม A / F ไม่พบในรายการค่าธรรมเนียม',
  Withdraw: 'การถอนเงิน',
  AlreadyReturn: 'ส่งคืนแล้ว',
  AlreadyWithdraw: 'ถอนตัวแล้ว',
  ReturnAction: 'การดำเนินการส่งคืน',
  IsConfirm: 'ไม่ว่าจะเป็นการยืนยัน',
  Return: 'ส่งคืน',
  BatchReturnSucceeded: 'การส่งคืนจำนวนมากสำเร็จ: {0}',
  BatchReturnPreSubmitCheck: 'โดยสามารถคืนได้เฉพาะสลิปที่มีสถานะเป็นธุรกิจล่วงหน้าเท่านั้น',
  BatchReturnSubmitCheck: 'อนุญาตให้ถอนได้เฉพาะสลิปที่สถานะการประกอบกิจการยื่นไว้เท่านั้น',
  BusinessIsNotCommittedAndCannotBeWithdrawn: 'สถานะธุรกิจที่ไม่ใช่ 【ส่งแล้ว】 ไม่สามารถเรียกคืนได้',
  BusinessIsNotPreCommittedAndCannotBeReturn: 'ธุรกิจไม่มีสถานะ 【ส่งล่วงหน้า】 และไม่สามารถส่งคืนได้',
  BatchUnlockLockedBillsOfAccountsReceivable: 'สามารถปลดล็อกรายการที่มีการล็อคค่าธรรมเนียมที่เรียกเก็บได้เฉพาะในกลุ่มเท่านั้น!',
  lowBalanceTips: 'คุณระบุยอดคงเหลือของใบประกาศศุลกากรไม่เพียงพอไม่สามารถระบุการอัปโหลดไฟล์ใบประกาศศุลกากรเป็นกลุ่มทั้งหมดได้ <br />1) เลือกที่จะอัปโหลดไฟล์ต่อไปยังประวัติไฟล์ แต่ไม่ระบุข้อมูลใบประกาศศุลกากร <br />2) เลือกเติมเงินแล้วอัปโหลดไฟล์อีกครั้งโดยค่าเริ่มต้นจะไม่อัปโหลดไฟล์และไม่แยกแยะประกาศศุลกากร',
  lowBalanceTips1: 'อัปโหลดไฟล์ต่อไป',
  lowBalanceTips2: 'อัพโหลดหลังจากเติมเงิน',
  BatchUnlockLockingBillsOfAccountsReceivable: 'ล็อคเฉพาะรายการที่ปลดล็อคค่าธรรมเนียมที่เรียกเก็บเป็นชุดเท่านั้น!',
  BatchUnlockLockingBillsOfAccountsPayable: 'สามารถล็อครายการที่ต้องชำระค่าธรรมเนียมได้จำนวนมากเท่านั้น!',
  BatchUnlockLockedBillsOfAccountsPayable: 'สามารถปลดล็อกรายการที่ต้องชำระค่าธรรมเนียมได้จำนวนมากเท่านั้น!',
  UnlockChargeStatus: 'ยืนยันการปลดล็อคสถานะค่าธรรมเนียม {0} หรือไม่?',
  LockingChargeStatus: 'ยืนยันสถานะค่าธรรมเนียม {0} ถูกล็อคหรือไม่',
  SuccessfullyUnlockedFeesInBatch: 'ปลดล็อคเป็นกลุ่ม {0} ค่าธรรมเนียมสำเร็จ: {1}',
  SuccessfullylockingedFeesInBatch: 'ล็อคแบทช์ {0} ค่าธรรมเนียมสำเร็จ: {1}',
  ThereAreFeesReceivableNotInvoicedPrint: 'มีค่าธรรมเนียมลูกหนี้ที่ยังไม่ได้ออกใบแจ้งหนี้ คุณแน่ใจหรือไม่ว่าคุณต้องการพิมพ์?',
  ThereAreFeesReceivableNotInvoicedSubmit: 'มีค่าธรรมเนียมลูกหนี้ที่ยังไม่ได้ออกใบแจ้งหนี้ คุณแน่ใจหรือไม่ว่าต้องการส่ง?',
  VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: 'ธุรกิจสั่งซื้อนี้จะยื่นการตรวจสอบทางการเงินก่อนที่จะส่งโปรดยืนยันว่าเอกสารที่เกี่ยวข้องได้อัปโหลดระบบแล้วจะดำเนินการต่อหรือไม่',
  SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: 'ธุรกิจคำสั่งนี้จะถูกส่งไปยังผู้บังคับบัญชาเพื่อตรวจสอบก่อนที่จะส่งโปรดตรวจสอบว่าเอกสารที่เกี่ยวข้องได้อัปโหลดระบบแล้วจะดำเนินการต่อหรือไม่',
  PleaseInputTheSalesInformationAndPrints: 'กรุณากรอกข้อมูลพนักงานขายเพื่อพิมพ์อีกครั้ง!',
  PleaseInputTheSalesInformationAndSubmit: 'กรุณากรอกข้อมูลพนักงานขายเพื่อส่งอีกครั้ง!',
  FollowingTheSingleDidNotEnterTheSalesInformation: 'คำสั่งต่อไปนี้ไม่ได้ป้อนข้อมูลพนักงานขาย',
  PleaseEnterAndPrint: 'กรุณาพิมพ์หลังจากที่คุณป้อน!',
  PleaseSelectAWaterBillRecord: 'โปรดเลือกบันทึกรายการน้ำ',
  PleaseEnterAndSubmit: 'กรุณากรอกข้อมูลก่อนส่ง!',
  WithCostsAbroadWithoutValidBillingNumberYouCannotPrintAnAnalysisOfProfitTable: 'มีค่าใช้จ่ายต่างประเทศที่ไม่มีหมายเลขบิลที่ถูกต้องไม่สามารถพิมพ์ตารางวิเคราะห์กำไร!',
  WithCostsAbroadWithoutValidBillingNumberCannotBeSubmitted: 'มีค่าใช้จ่ายในต่างประเทศที่ไม่มีหมายเลขบิลที่ถูกต้องและไม่สามารถส่งได้!',
  BulkSubmissionOfWrittenSubmissionsOnlyList: 'สามารถส่งรายการที่ส่งมาแล้วล่วงหน้าเป็นกลุ่มเท่านั้น!',
  BulkSubmissionOfWrittenPreSubmissionsOnlyList: 'สามารถส่งรายการสถานะการทำงานเป็นบวกล่วงหน้าได้เป็นจำนวนมากเท่านั้น!',
  MakeSureToSubmitAListOftheNFinancialAuditPlease1: 'ยืนยันว่าจะนำเรื่องนี้',
  MakeSureToSubmitAListOftheNFinancialAuditPlease12: 'สลิปตั๋วถูกส่งไปตรวจสอบทางการเงินหรือไม่',
  BatchSubmittedSuccessfully: 'ส่งเป็นกลุ่มสำเร็จ',
  BatchSubmittedPreSuccessfully: 'ประสบความสำเร็จในการส่งข้อมูลล่วงหน้าจำนวนมาก',
  TheSelectedDocumentInconsistentNatureOfTheBooking: 'ลักษณะราคาประมาณของเอกสารที่เลือกไม่สอดคล้องกัน',
  TheSelectedDocumentIsNotTheSameVoyage: 'เอกสารที่เลือกไม่ใช่เที่ยวบิน/ชื่อเรือเดียวกัน',
  SelectTheData: 'กรุณาเลือกข้อมูล',
  NoSelectedDataOrAreNotOperationalStatus: 'ข้อมูลไม่ได้เลือกหรือไม่ได้เป็นบวก',
  TheSelectedServicesIncludeLockedServices: 'มีธุรกิจที่ถูกล็อคในธุรกิจที่ถูกเลือก',
  SureYouWantToRemoveTheCharge: 'แน่ใจนะว่าคุณต้องการลบค่าธรรมเนียม?',
  NoCostToRemove: 'ไม่มีค่าธรรมเนียมที่จะลบ',
  NoBusinessOrIsNotOperationalState: 'ไม่เลือกทำธุรกิจ หรือสถานะไม่เป็นบวก',
  MakeSureToDelegateTheBusiness: 'มั่นใจจะไว้วางใจให้ธุรกิจตั๋ว?',
  ErrorReadingInformation: 'เกิดข้อผิดพลาดในการอ่านข้อมูล',
  OrderTypeChangeTip: 'หลังจากเปลี่ยนประเภทการสั่งซื้อแล้ว ข้อมูลที่กรอกไปแล้วบางส่วนจะถูกล้างออก คุณจะยืนยันการสั่งซื้อหรือไม่',
  BusinessDateCanNotNull: 'วันที่ทำธุรกิจไม่สามารถว่างได้',
  TheReceivingPartyDoesNotMaintainTheCurrentCompanyInformationAmongPartners: 'ผู้รับไม่ได้เก็บรักษาข้อมูล บริษัท ปัจจุบันในคู่ค้า',
  ElectronicEntrustmentHasBeenSentForThisBusinessSendAgain: 'ธุรกิจปากกาได้ส่งมอบอำนาจทางอิเล็กทรอนิกส์ไปแล้วจะส่งอีกหรือไม่',
  DidNotFindTheCorrespondingTemplateTypeBOOKINGAndTemplateNameOceanExportBookingContinueToAuthorize: 'ไม่พบประเภทเทมเพลต 【BOOKING】 และชื่อเทมเพลต 【หนังสือมอบอำนาจการขนส่งสินค้าทางทะเลเพื่อการส่งออก】 ที่ตรงกัน คุณต้องการมอบหมายงานต่อไปหรือไม่?',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: 'สาขาที่ตัวแทนการจองห้องพักในปัจจุบันเป็นเจ้าของไม่ได้รักษาพันธมิตรที่สอดคล้องกับ บริษัท นี้ในหุ้นส่วน',
  TheBranchCompanyOfCurrentForwardingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: 'สาขาที่ตัวแทนจัดส่งปัจจุบันสังกัดอยู่ไม่รักษาพันธมิตรที่เป็นคู่สัญญากับบริษัทนี้ในหุ้นส่วน',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnershipSI: 'สาขาของตัวแทนท่าเรือปลายทางในปัจจุบันไม่ได้รักษาพันธมิตรที่สอดคล้องกับ บริษัท นี้ในหุ้นส่วน',
  TheBranchCompanyOfUnExchangeAgent: 'สาขาที่ตัวแทนแลกเปลี่ยนเงินตราปัจจุบันสังกัดอยู่ไม่ได้ดูแลคู่ค้าที่เป็นคู่สัญญากับบริษัทนี้ในหุ้นส่วน',
  TheBranchCompanyOfUnOurCompany: 'สาขาของบริษัทขนส่งในปัจจุบันไม่ได้ดูแลรักษาคู่ค้าของบริษัทนี้ในหุ้นส่วน',
  TheOppositeSideHasScceptedNoNeedToReCommission: 'อีกฝ่ายยอมรับแล้ว ไม่ต้องมอบหมายอีก',
  SuccessfullySent: 'ส่งเรียบร้อยแล้ว',
  NoSendingGoodsInfo: 'ไม่มีข้อมูลเกี่ยวกับสินค้าที่ต้องส่ง',
  NoAssociatedBusiness: 'ไม่มีธุรกิจที่เกี่ยวข้อง!',
  NoAssociatedContainerInfo: 'ไม่มีข้อมูลการบรรจุหีบห่อที่จะส่งได้',
  PleaseEnterFleetInformatio: 'กรุณากรอกข้อมูลยานพาหนะ',
  ThisBoxIsNotAllowedToBeDeleted: 'กรณีนี้ไม่อนุญาตให้ลบ',
  FailedToQueryTheAssociatedBusiness: 'ไม่มีการสอบถามไปยังธุรกิจที่เกี่ยวข้อง',
  RepeatedWarehouseNo: 'หมายเลขรายการซ้ำ',
  NoStorageInfo: 'ไม่มีข้อมูลการเข้าคลัง',
  TheJobIsIncorrectPleaseRefreshThePageOrContactTheAdministrator: 'แผ่นงานไม่ถูกต้องโปรดรีเฟรชหน้าหรือติดต่อผู้ดูแลระบบ!',
  ConsignationCompanyCannotBeNull: 'หน่วยที่ได้รับมอบหมายไม่สามารถว่างได้',
  FLCLTypeCannotBeNull: 'ประเภทการสะกดทั้งหมดจะต้องไม่ว่างเปล่า',
  POLCannotBeNull: 'พอร์ตการจัดส่งสินค้าไม่สามารถว่างเปล่าได้',
  IfThereIsATransferTheTransferPortCannotBeNull: 'หากมีการส่งต่อท่าเรือไม่สามารถว่างได้',
  PortOfDischargeCannotBeNull: 'ท่าเรือขนถ่ายสินค้าต้องไม่ว่างเปล่า',
  PortOfDestinationCannotBeNull: 'ท่าเรือปลายทางไม่สามารถว่างได้',
  SalesCannotBeNull: 'ยอดขายต้องไม่ว่างเปล่า',
  SalesBranchCompanyIsNullPleaseReSelectSales: 'สาขาการขายว่างเปล่าโปรดเลือกการขายใหม่!',
  SalesDepartmentIsNullPleaseReSelectSales: 'กรุณาเลือกฝ่ายขาย!',
  DateOfDepartureCannotBeLaterThanDateOfArrival: 'วันที่ออกเดินทางต้องไม่เกินวันที่มาถึง',
  NominatedAgentCannotBeNull: 'ตัวแทนจัดส่งที่ระบุไม่สามารถว่างเปล่า!',
  FLCLTypeCannotBeNull2: 'ประเภทของการจับต้องไม่ว่างเปล่า!',
  ItemNoCannotBeNull: 'หมายเลขสินค้าต้องไม่ว่างเปล่า!',
  EQSizeCannotBeNull: 'ประเภทกล่องไม่สามารถว่างเปล่า!',
  EQSizeCannotBeNull2: 'มีอย่างน้อยหนึ่งกล่อง!',
  DearYouCanOnlySelectYourOwnCustomers: 'โปร คุณเลือกได้แค่ลูกค้าของคุณเอง',
  DepartmentCannotBeNull: 'ดิวิชั่นจะว่างเปล่าไม่ได้',
  CyCutoffDateCannotBeLaterThanDepartureDate: 'กำหนดเส้นตายไม่เกินวันออกเดินทาง',
  BargeCutoffDateCannotBeLaterThanCyCutoffDate: 'กำหนดเวลาเรือขนส่งต้องไม่เกินกำหนด!',
  ContainerSealInfoHasBeenEnteredCannotBeDeleted: 'ป้อนข้อมูลการปิดผนึกกล่องที่เกี่ยวข้องและไม่สามารถลบออกได้',
  RelevantInstallationInfoHasBeenEnteredCannotBeDeleted: 'ป้อนข้อมูลบอร์ดที่เกี่ยวข้องและไม่สามารถลบได้',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated: 'มีการเปลี่ยนแปลงน้ำหนักการเรียกเก็บเงิน จะมีการรีเฟรชค่าธรรมเนียมเดิมตามน้ำหนักการเรียกเก็บเงินหรือไม่ ส่วนค่าใช้จ่ายที่ได้ทำบิล ออกใบแจ้งหนี้แล้วจะไม่ต่ออายุ',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated2: 'มีการเปลี่ยนแปลงน้ำหนักการเรียกเก็บเงิน จะมีการรีเฟรชค่าธรรมเนียมเดิมตามน้ำหนักการเรียกเก็บเงินหรือไม่ ค่าธรรมเนียมในการทำใบแจ้งหนี้การชำระเงินใบสมัครตัดบัญชีจะไม่ปรับปรุง',
  CurrencyChangeConfirm: 'สกุลเงินราคาซื้อ/ขายมีการเปลี่ยนแปลง อัปเดตค่าใช้จ่ายเดิมหรือไม่? ค่าใช้จ่ายที่ทำใบแจ้งหนี้ ออกใบแจ้งหนี้ ขอชำระเงิน หรือตัดบัญชีแล้วจะไม่ได้รับการอัปเดต',
  PriceUpdateConfirm: 'ราคาซื้อ/ราคาขายเปลี่ยนแปลงแล้ว ยืนยันว่าต้องการอัปเดตค่าใช้จ่ายที่คำนวณตามน้ำหนักคิดค่าใช้จ่ายต่อหน่วยสำหรับราคาซื้อและราคาขายหรือไม่? ค่าใช้จ่ายที่ได้ทำบิล ออกเสร็จ สมัครชำระเงิน และยกเลิกหนี้แล้วจะไม่ถูกอัปเดต',
  PriceTypeChangeConfirm: 'ประเภทราคาซื้อ/ขายมีการเปลี่ยนแปลง อัปเดตค่าใช้จ่ายเดิมหรือไม่? ค่าใช้จ่ายที่ทำใบแจ้งหนี้ ออกใบแจ้งหนี้ ขอชำระเงิน หรือตัดบัญชีแล้วจะไม่ได้รับการอัปเดต',
  TheChargedWeightHasBeenChanged: 'มีการเปลี่ยนแปลงน้ำหนักการเรียกเก็บเงิน จะมีการรีเฟรชค่าธรรมเนียมเดิมตามน้ำหนักการเรียกเก็บเงินหรือไม่',
  WeightChangeToRefreshCostBasedOnWeightPrice: 'น้ำหนักมีการเปลี่ยนแปลง รีเฟรชค่าธรรมเนียมเดิมตามราคาน้ำหนักหรือไม่? ค่าใช้จ่ายของการทำใบแจ้งหนี้การชำระเงินใบสมัครตัดบัญชีใบตราส่งสินค้าที่เกี่ยวข้องจะไม่ได้รับการต่ออายุ',
  WeightChangeToRefreshCostBasedOnWeightTonPrice: 'น้ำหนักมีการเปลี่ยนแปลง รีเฟรชค่าใช้จ่ายเดิมตามราคาน้ำหนัก (ตัน) หรือไม่? ค่าใช้จ่ายของการทำใบแจ้งหนี้การชำระเงินใบสมัครตัดบัญชีใบตราส่งสินค้าที่เกี่ยวข้องจะไม่ได้รับการต่ออายุ',
  CubageChangeToRefreshCostBasedOnCubagePrice: 'ปริมาตรมีการเปลี่ยนแปลง คุณต้องการรีเฟรชค่าธรรมเนียมเดิมตามราคาปริมาตรหรือไม่? ค่าใช้จ่ายของการทำใบแจ้งหนี้การชำระเงินใบสมัครตัดบัญชีใบตราส่งสินค้าที่เกี่ยวข้องจะไม่ได้รับการต่ออายุ',
  InsideQuantityChangeToRefreshCostBasedOnCubagePrice: 'จำนวนชิ้นเล็ก ๆ มีการเปลี่ยนแปลง คุณต้องการรีเฟรชค่าธรรมเนียมเดิมตามราคาของชิ้นเล็ก ๆ หรือไม่? ค่าใช้จ่ายของการทำใบแจ้งหนี้การชำระเงินใบสมัครตัดบัญชีใบตราส่งสินค้าที่เกี่ยวข้องจะไม่ได้รับการต่ออายุ',
  ChangeToRefreshCostBasedOnCubagePrice: 'จำนวนชิ้นเล็กน้ำหนักรวมปริมาตรน้ำหนักการเรียกเก็บเงินที่มีการเปลี่ยนแปลงรีเฟรชเดิมตามจำนวนชิ้นเล็กราคาน้ำหนักราคาปริมาตรราคาน้ำหนักการเรียกเก็บเงินเป็นหน่วยค่าใช้จ่ายหรือไม่ ค่าใช้จ่ายของการทำใบแจ้งหนี้การชำระเงินใบสมัครตัดบัญชีใบตราส่งสินค้าที่เกี่ยวข้องจะไม่ได้รับการต่ออายุ',
  DistributedSuccessfully: 'การจัดส่งที่ประสบความสำเร็จ',
  BusinessReferenceNoReduplicated: 'หมายเลขอ้างอิงธุรกิจ ซ้ำ',
  BookingAgentCannotBeNull: 'ตัวแทนการจองห้องพักไม่สามารถว่างได้',
  DateOfDepartureCannotBeNull: 'วันที่ออกเดินทางไม่สามารถว่างได้',
  TheMainInterfaceDoesNotExist: 'ไม่มีอินเตอร์เฟซหลัก',
  FeesHaveBeenUsedForThisUnit: 'มีการใช้ค่าใช้จ่ายไปยังหน่วยแล้วโปรดปรับหน่วยของค่าใช้จ่ายที่เกี่ยวข้องก่อนแล้วจึงลบ!',
  TheChargingUnitIsUsedByAnExistingChargePlan: 'แผนการเรียกเก็บเงินได้ถูกใช้ไปยังหน่วยเรียกเก็บเงินนี้แล้ว โปรดปรับหน่วยของแผนการเรียกเก็บเงินที่เกี่ยวข้องก่อนแล้วจึงลบ',
  TheMasterBillBusinessNumberHasNotBeenGeneratedPleaseSaveTheTheMasterBillFirst: 'หมายเลขธุรกิจหลัก LCL ยังไม่ได้สร้างขึ้นโปรดบันทึกตั๋วหลักก่อน',
  TheSubBillHasBeenConsolidatedAndCannotBeRemoved: 'ตั๋วขนาดเล็กนี้ถูกสะกดกล่องแล้วและไม่สามารถเคลื่อนย้ายออกได้',
  PleaseSelectSubBills: 'กรุณาเลือกตั๋วขนาดเล็ก',
  PleaseSaveTheChangedDataOrExitTheEditStateAndThenCloseTheModule: 'โปรดบันทึกข้อมูลที่เปลี่ยนแปลงก่อนหรือออกจากสถานะการแก้ไขแล้วปิดโมดูล',
  MblNoIsNull: 'MB/L ไม่ ว่างเปล่า',
  SONoIsNull: 'S / O ไม่มี ว่างเปล่า',
  NoVesselVoyageInformation: 'ไม่มีข้อมูลการเดินทางชื่อเรือ',
  ObtainSuccessfully: 'ประสบความสำเร็จ',
  PleaseSelectCopyType: 'โปรดเลือกประเภทการถอดความ',
  NoTargetShippingCompanyFoundHerePleaseRefreshTheCache: 'ไม่พบ บริษัท เรือนี้โปรดรีเฟรชแคช!',
  BlIsConfirmed: 'ใบตราส่งได้รับการยืนยันแล้ว',
  ThisHblIsCombinedAndCannotBeEdited1: 'ตั๋ว HBL ถูกรวมเข้ากับ',
  ThisHblIsCombinedAndCannotBeEdited2: 'ไม่สามารถแก้ไขได้',
  ToOrederBlCannotBeTelexReleased: 'ถึง ORDER ไม่สามารถปล่อยกระแสไฟฟ้าได้',
  PleaseInputBlSerialNumberFirst: 'กรุณาใส่หมายเลขประกอบการ B / L ก่อน!',
  PleaseSelectTheListToBeMergedInto: 'โปรดเลือกรายการที่คุณต้องการรวม!',
  PleaseInputBussinessNo: 'กรุณาใส่หมายเลขธุรกิจ!',
  NoSelectedContainerInformation: 'ไม่มีข้อมูลกล่องถูกเลือก',
  PleaseSelectData: 'กรุณาเลือกข้อมูล',
  OnlySelectOneData: 'เลือกข้อมูลได้เพียงหนึ่งรายการเท่านั้น',
  Count: 'จำนวนโหวต',
  AreYouSureYouWantToRemoveTheSubBill: 'ยืนยันจะย้ายออกเสียงข้างน้อยหรือไม่',
  RemovedSuccesfully: 'ลบสำเร็จ',
  NoSubBillsToSplit: 'ไม่มีสลากเล็กแบ่งน้อย',
  SoNoCannotBeNull: 'หมายเลขปิด (S/O) ไม่สามารถว่างได้',
  CancelTheCurrentQuery: 'ยกเลิกการสอบถามปัจจุบัน?',
  SelectTheOrderYouWantToJoin: 'โปรดเลือกรายการสั่งซื้อเพื่อเข้าร่วม',
  HasJoinIntoMbl: 'เข้าร่วมในบัตรหลักแล้ว',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue: 'ชื่อเรือของตั๋วโดยสารขนาดเล็กที่เลือกใหม่, เที่ยวบิน, ผู้ให้บริการ, ตัวแทนการจอง, ตัวแทนท่าเรือปลายทาง, ETD、ETA、 ข้อมูลคลังสินค้าไม่สอดคล้องกับตั๋วหลัก ระบบจะแก้ไขสลากเล็ก จะดำเนินการต่อหรือไม่',
  ContainerNoDoesNotComplyWithTheNumberingRules: 'หมายเลขกล่องไม่เป็นไปตามหลักเกณฑ์ของหมายเลข',
  SealNoHasBeenChanged: 'ซีลถูกเปลี่ยน',
  PleaseSelectTheDesiredPrintVgm: 'โปรดเลือก VGM ที่คุณต้องการพิมพ์',
  DeleteTheVgmInformation: 'คุณต้องการลบข้อมูล VGM นี้หรือไม่?',
  PleaseEnterEnglish: 'กรุณากรอกภาษาอังกฤษ',
  PleaseEnterTheShippingCompanyInformation: 'มีค่าใช้จ่ายในการขนส่งโปรดป้อนข้อมูล บริษัท ขนส่ง!',
  SameJobtruckOrderNo: 'ประตูสู่ประตูบรรจุหมายเลขการจัดส่งสินค้าซ้ำกันโปรดแก้ไข!',
  SureYouRemoveThisNData1: 'ตัดสินใจลบสิ่งนี้',
  SureYouRemoveThisNData2: 'แถบข้อมูล?',
  AreYouSureYouWantToSendACarOrder: 'คุณแน่ใจนะว่าต้องการส่งใบส่งรถ?',
  AreYouSureYouWantToModifyACarOrder: 'คุณแน่ใจหรือว่าต้องการเปลี่ยนใบส่งรถ?',
  AreYouSureYouWantToRevokeACarOrder: 'คุณแน่ใจหรือว่าต้องการถอนใบสั่งซื้อ',
  ThisCarOrderIsSended: 'เมื่อใบส่งสินค้าสำเร็จแล้ว ไม่สามารถส่งได้อีก แต่สามารถแก้ไขได้โดยการเปลี่ยนใบสั่งเท่านั้น',
  ThisCarOrderCanOnlyBeModifiedAfterSending: 'หลังจากส่งใบสั่งแล้วจึงสามารถดําเนินการแก้ไขใบสั่งได้',
  ThisCarOrderIsSendedNoAddUsage: 'หลังจากส่งรถหนึ่งใบสําเร็จแล้ว ไม่อนุญาตให้เพิ่มตู้อีก',
  ThisCarOrderCanOnlyBeRevokedIsUnApproved: 'สามารถเบิกถอนได้เฉพาะสถานะของใบสั่งที่ยังไม่ได้รับ',
  ThisCarOrderIsChanged: 'เคล็ดลับ: มีการเปลี่ยนแปลงข้อมูลการตอบกลับ',
  DeleteFailed: 'การลบล้มเหลว',
  Failure: 'ล้มเหลว',
  DispatchSuccess: 'ปายแผ่นสำเร็จ',
  ModifiedTruckOrderSuccess: 'เปลี่ยนใบสั่งสำเร็จ',
  RevokeTruckOrderSuccess: 'การถอนเงินสำเร็จแล้ว',
  DispatchFailed: 'พายแผ่นมีความผิดปกติ',
  ModefiedTruckOrderFaild: 'มีความผิดปกติในการแก้ไขใบสั่ง',
  RevokeTruckOrderFaild: 'การถอนเงินมีความผิดปกติ',
  VgmWeightingMethod: 'วิธีชั่งน้ำหนัก VGM',
  LdpWarn: 'สำหรับสินค้าแช่แข็งต้องกรอกอย่างน้อยหนึ่งบรรทัดพร้อมกัน',
  WxpWarn: 'สำหรับสินค้าอันตรายต้องกรอกอย่างน้อยหนึ่งบรรทัดพร้อมกัน',
  Transfer: 'เปลี่ยนเรือของเอเจนต์',
  ReasonForDeletion: 'เหตุผลในการลบ',
  ReasonForDeletionNotEmpty: 'ต้องระบุเหตุผลในการลบ',
  VesselRegex: 'ตัวอักษรภาษาอังกฤษและตัวเลขเท่านั้น ไม่เกิน 35 ตัวอักษร',
  BlNumberRegex: 'ตัวเลขเท่านั้น',
  DanClass: 'ต้องอยู่ระหว่าง 1 ถึง 9.9',
  CubageRegex: 'ช่วงค่าต้องอยู่ระหว่าง 0.001 ถึง 2000.999',
  RowPrefix: 'เลขที่ใบขนสินค้า{0}',
  UpdateVesselVoyNo: 'Sửa tên tàu và chuyến',
  UpdateVesselVoyNoError: 'Không thể sửa tên tàu chuyến cho manifest chưa gửi',
  InputVesselVoyNo: 'Vui lòng nhập tên tàu chuyến đã cập nhật',
  ShipNotRegistered: 'Tàu chưa đăng ký',
  LoadManifest: 'Tải manifest',
  ModificationFailed2: 'Đổi phân bố thất bại',
  ModifiedSuccessfully: 'Đổi phân bố thành công',
  NoDelete: 'Không có dữ liệu để gửi xóa manifest',
  SendFailed: 'ส่งล้มเหลว',
  SaveFailed: 'บันทึกล้มเหลว',
  ViewWarehouseEntryPhotos: 'ดูรูป Position ขาเข้า',
  DistributeFailedNoFoundRelatedStorageRecord: 'การจัดส่งสินค้าล้มเหลว ไม่พบบันทึกคลังสินค้าที่สอดคล้องกัน!',
  SureYouWantToCancelTheBindingToTheStorageData: 'ยืนยันต้องการปลดล็อกข้อมูลคลังหรือไม่',
  QueryFailed: 'การสอบถามล้มเหลว',
  SelectDeclarations: 'กรุณาเลือกใบศุลกากร',
  SelectCustomsInformation: 'โปรดเลือกข้อมูลการประกาศศุลกากร',
  SelectCustomsRecord: 'โปรดเลือกบันทึกการประกาศศุลกากร',
  TheNumberOfTenBitCodeYouEnteredIsNotEnough: 'อ่า คุณใส่หลักสิบหลักไม่พอ',
  OperatingCompanyCannotBeNull: 'หน่วยปฏิบัติการจะว่างเปล่าไม่ได้',
  DateOfCustomsDeclarationCannotBeNull: 'วันที่ประกาศศุลกากรไม่สามารถว่างได้',
  PleaseSelectStatusOfCustomsDeclaration: 'โปรดเลือกสถานะประกาศศุลกากร',
  CargoDetailsWEIGHTBannotBeNull: 'รายละเอียดของสินค้า - WEIGHT ไม่สามารถว่างเปล่าได้',
  CargoDetailsAMOUNTBannotBeNull: 'รายละเอียดของสินค้า - AMOUNT ต้องไม่ว่างเปล่า',
  CargoDetailsCustomsDutyRateBannotBeNull: 'รายละเอียดของสินค้า - อัตราภาษีศุลกากรไม่สามารถว่างเปล่า',
  CargoDetailsCustomsDutiesBannotBeNull: 'รายละเอียดของสินค้า - ภาษีศุลกากรไม่สามารถว่างเปล่าได้',
  CargoDetailsIncrementRateCannotBeNull: 'รายละเอียดของสินค้า - อัตราภาษีมูลค่าเพิ่มไม่สามารถเว้นว่างได้',
  CargoDetailsIncrementValueDutyBannotBeNull: 'รายละเอียดของสินค้า - ภาษีมูลค่าเพิ่มไม่สามารถเปล่าได้',
  CargoDetailsConsumptionDutyRateBannotBeNull: 'รายละเอียดของสินค้า - อัตราภาษีสรรพสามิตไม่สามารถเว้นว่างได้',
  CargoDetailsConsumptionDutyBannotBeNull: 'รายละเอียดของสินค้า - ภาษีสรรพสามิตไม่สามารถเว้นว่างได้',
  CargoDetailsCurrencyBannotBeNull: 'รายละเอียดของสินค้า - สกุลเงินไม่สามารถว่างเปล่าได้',
  CargoDetailsExchangeBannotBeNull: 'รายละเอียดของสินค้า - อัตราแลกเปลี่ยนไม่สามารถว่างได้',
  CargoDetailsCargoPriceBannotBeNull: 'รายละเอียดของสินค้า - ราคาสินค้าต้องไม่ว่างเปล่า',
  CargoDetailsTaxBannotBeNull: 'รายละเอียดของสินค้า - ภาษีไม่สามารถเว้นว่างได้',
  CargoDetailsTaxRateBannotBeNull: 'รายละเอียดของสินค้า - อัตราภาษีไม่สามารถเว้นว่างได้',
  ImportSuccessful1: 'นำเข้าสำเร็จ',
  ImportSuccessful2: 'แถบ',
  ImportFailed: 'นำเข้าล้มเหลว',
  CargoDetailsIsNotSelected: 'ยังไม่มีการเลือกรายละเอียดของสินค้า',
  PleaseSelectUnRelatedTradeDetailData: 'โปรดเลือกข้อมูลสินค้าที่ไม่เกี่ยวข้อง',
  SelectTheBillingObject: 'เลือกวัตถุของการตั้งถิ่นฐาน',
  NoChargeForTheSettlementOfDomesticObjects: 'ไม่มีค่าธรรมเนียมเป็นวัตถุของการตั้งถิ่นฐานในประเทศ',
  CancelAudit: 'ยกเลิกการตรวจสอบ',
  ChargesAudit: 'การตรวจสอบค่าใช้จ่าย',
  ThereAreFeesCantBeDeletedPleaseRecheck: 'รวมค่าธรรมเนียมที่ไม่สามารถลบได้ โปรดตรวจสอบ',
  TheChargesHaveBeenSettledByFinancialAccountAndCannotBeAmended: 'ค่าธรรมเนียมได้รับการตัดสินทางการเงินและไม่สามารถแก้ไขได้',
  RedChargeOrRedChargedCannotBeEditAdjustAgainPleaseSelectNewAdjustment: 'ค่าช่องแดง หรือโดนค่าช่องแดงไม่สามารถแก้ไขปรับปรุงได้อีกขอให้เลือกเพิ่มการปรับ',
  RedChargeOrRedChargedCannotBeDeletedPleaseReselect: 'ค่าช่องแดง หรือโดนค่าช่องแดงไม่สามารถลบได้ ให้เลือกใหม่',
  PleaseRefresh: 'ค่าธรรมเนียมได้รับการแก้ไขโดยผู้อื่นโปรดรีเฟรช',
  ChargeItemCannotBeNull: 'ชื่อค่าธรรมเนียมไม่สามารถเว้นว่าง!',
  MeasureCannotBeNull: 'หน่วยค่าธรรมเนียมไม่สามารถว่าง!',
  SettlementPartyCannotBeNull: 'วัตถุของการตั้งถิ่นฐานไม่สามารถว่างเปล่า!',
  CurrencyCannotBeNull: 'สกุลเงินไม่สามารถว่างเปล่า!',
  AmountCannotBeNull: 'ปริมาณต้องไม่ว่างเปล่า!',
  UnitRateCannotBeNull: 'ราคาต่อหน่วยไม่สามารถว่างเปล่า!',
  CustomsSeclarationServiceIsNotSelectedInBookingCannotAdd: 'การจองห้องพักไม่มีบริการประกาศศุลกากรและไม่สามารถเพิ่มได้:',
  WaerhouseServiceIsNotSelectedInBookingCannotAdd: 'ไม่มีบริการคลังสินค้าที่ถูกเลือกไว้สำหรับการจองห้องพักและไม่สามารถเพิ่มได้:',
  HaulageServiceIsNotSelectedInBookingCannotAdd: 'การจองห้องพักไม่มีบริการขนส่งที่ถูกทำเครื่องหมายและไม่สามารถเพิ่มได้:',
  ChargeIsNotSelectedOrAllChargesSubmit: 'ไม่มีการเลือกค่าธรรมเนียม หรือยื่นครบถ้วนแล้ว',
  ChargeIsNotSelectedOrNotInTheSubmissionStatus: 'ไม่มีการเลือกค่าธรรมเนียม หรือไม่ใช่สถานะการยื่น',
  OperationSuccessfully: 'ความสำเร็จในการดำเนินงาน',
  PayablesIsNull: 'ค่าธรรมเนียมที่ต้องชำระว่างเปล่า',
  ReceivalbeIsNull: 'ค่าใช้จ่ายของลูกหนี้ว่างเปล่า',
  CopyThePayablesSuccessfullyTotallyOfNItems1: 'สำเนาค่าใช้จ่ายที่ต้องจ่ายสำเร็จสร้างร่วมกัน',
  CopyThePayablesSuccessfullyTotallyOfNItems2: 'ค่าธรรมเนียมปากกา',
  CopyTheReceivablesSuccessfullyTotallyOfNItems1: 'การถอดค่าธรรมเนียมลูกหนี้ประสบความสำเร็จ',
  CopyTheReceivablesSuccessfullyTotallyOfNItems2: 'ค่าธรรมเนียมปากกา',
  NoPayablesCanBeCopiedThereMayBeSameChargeItems: 'ไม่มีค่าธรรมเนียมที่คัดลอกและอาจมีชื่อค่าธรรมเนียมเดียวกัน',
  NoReceivablesCanBeCopiedThereMayBeSameChargeItems: 'ไม่มีค่าธรรมเนียมลูกหนี้ที่สามารถถอดรหัสได้และอาจมีชื่อค่าธรรมเนียมเดียวกัน',
  CopyChargeSuccessfullyTotallyOfNItems1: 'ค่าธรรมเนียมการถอดรหัสสำเร็จสร้างร่วมกัน',
  NoChargeCanBeCopiedThereMayBeSameChargeItems: 'ไม่มีค่าธรรมเนียมในการคัดลอกและอาจมีชื่อค่าธรรมเนียมเดียวกัน',
  TheCurrentlyRelevantBusinessInformationIsNull: 'ข้อมูลธุรกิจที่เกี่ยวข้องในปัจจุบันว่างเปล่า',
  PleaseSelectCharges: 'กรุณาเลือกค่าธรรมเนียม',
  SelectChargesAreInControl: 'ควบคุมค่าธรรมเนียมที่เลือกแล้ว',
  SelectedChargesAreCancelledControlling: 'ค่าธรรมเนียมการเลือกควบคุมถูกยกเลิกแล้ว',
  PleaseGoToTheFCLFreightInquiryModuleToCheckFreightDetails: 'กรุณาไปที่โมดูลสอบถามราคา FCL เพื่อดูรายละเอียดการจัดส่ง!',
  PleaseGoToTheAirFreightInquiryModuleToCheckFreightDetails: 'โปรดไปที่โมดูลสอบถามราคาค่าขนส่งทางอากาศเพื่อตรวจสอบรายละเอียดค่าจัดส่ง!',
  DoYouNeedToInviteOthersToConfirmTheCharges: 'คุณต้องการคำเชิญเพื่อยืนยันค่าใช้จ่ายหรือไม่?',
  TheMailHasBeenSentPleaseNoteAndHaveACheck: 'จดหมายถูกส่งแล้วโปรดทราบการสอบถาม!',
  PleaseSelectReceivableCharges: 'กรุณาเลือกรายการที่เรียกเก็บค่าธรรมเนียม',
  PleaseSelectPayableCharges: 'กรุณาเลือกรายการที่ต้องชำระค่าธรรมเนียม',
  OnlyAuditChargesHaveBeenSubmitted: 'สามารถตรวจสอบได้เฉพาะค่าใช้จ่ายที่ยื่นไปแล้ว',
  NoChargesToAudit: 'ไม่มีค่าธรรมเนียมที่ต้องตรวจสอบ โปรดตรวจสอบผู้ตรวจสอบค่าใช้จ่ายหรือสถานะค่าใช้จ่าย',
  NoChargesToUnAudit: 'ไม่มีค่าธรรมเนียมการยกเลิกการตรวจสอบ โปรดตรวจสอบผู้ทบทวนค่าใช้จ่ายหรือสถานะค่าใช้จ่าย',
  NoChargesToReject: 'ไม่มีค่าธรรมเนียมการยกเลิก โปรดตรวจสอบผู้ทบทวนค่าใช้จ่ายหรือสถานะค่าใช้จ่าย',
  YouAreNotACostSpecifiedByTheReviewerCannotAuditTheCharges: 'โปรดตรวจสอบให้แน่ใจว่าคุณเป็นผู้ตรวจสอบค่าใช้จ่ายทั้งหมด',
  SelectedExpensesIncludeAllWriteOffExpensesWhetherToAddThemToTheBill: 'ค่าใช้จ่ายที่เลือกรวมค่าธรรมเนียมที่ถูกตัดออกทั้งหมดแล้ว จะถูกเพิ่มเข้าไปในบิลหรือไม่',
  AllSelectedFeesWillBeVerifiedPleaseChooseAgain: 'ค่าใช้จ่ายที่เลือกจะถูกหักออกทั้งหมดโปรดเลือกใหม่',
  IncludeFullyWrittenOffCosts: 'ค่าใช้จ่ายที่เลือกประกอบด้วยจำนวนที่ตัดบัญชีแล้ว เพิ่มลงในใบแจ้งหนี้หรือไม่?',
  AuditSuccessfully: 'การตรวจสอบสำเร็จ',
  CancelSuccessfully: 'ยกเลิกสำเร็จ',
  PleaseSelect1ChargeDetail: 'กรุณาเลือกรายละเอียดค่าธรรมเนียม',
  NoPriceToMeetTheQueryCriteria: 'ไม่มีการสอบถามถึงราคาที่ได้รับสิทธิ์',
  Prepaid: 'การชำระเงินล่วงหน้า',
  Collect: 'การชำระเงิน',
  PrePayTheSamePrice: 'ราคาเดียวกันก่อนเก็บเงิน',
  RefreshRateFailed: 'รีเฟรชค่าจัดส่งล้มเหลว!',
  PleaseSelectThePrice: 'กรุณาเลือกราคา!',
  Invalidation: 'ความล้มเหลว',
  Normal: 'ปกติ',
  suspension: 'หยุดบิน',
  NoPickingUp: 'ไม่รับสาย',
  Inquiry: 'สอบถามรายละเอียดเพิ่มเติม',
  Tension: 'ประสาท',
  OverStowage: 'ระเบิดห้องโดยสาร',
  CreateBill: 'แยกบิลตามสกุลเงินค่าธรรมเนียม',
  SplitBill: 'แยกเรียกเก็บเงินตามสกุลเงินต้นฉบับ',
  PleaseBeNotedThatThisRateIsUnderSuspendSailing: 'โปรดทราบว่าค่าจัดส่งอยู่ในสถานะหยุด!',
  PleaseBeNotedThatThisRateIsUnavailableNow: 'โปรดทราบว่าค่าจัดส่งอยู่ในสถานะไม่รับ!',
  PleaseBeNotedThatThisRateIsOnlyForPartOfEQType: 'โปรดทราบค่าจัดส่งสินค้าประเภทกล่องบางส่วนไม่รับ!',
  PleaseBeNotedThatThisRateIsUnderOverbookedStatus: 'โปรดทราบว่าค่าจัดส่งอยู่ในสถานะระเบิด!',
  TheOriginOfSelectedRateIsDifferentFromBookingAgent: 'ตรวจสอบแหล่งที่มาของราคาค่าขนส่งแตกต่างจากตัวแทนจองที่นั่งในใบงาน',
  Unconfirmed: 'ยังไม่ได้รับการยืนยัน',
  Confirmed: 'ได้รับการยืนยันแล้ว',
  Receivable: 'การรับสมัคร',
  Payable: 'การรับมือ',
  Bill: 'การเรียกเก็บเงิน',
  TheBillDoesNotConfirm: 'ยังไม่ยืนยันการเรียกเก็บเงิน',
  SureYouWantToCancel: 'แน่ใจนะว่าต้องการยกเลิก?',
  StateModifiedSuccessfully: 'แก้ไขสถานะสำเร็จ',
  NoInternalCostsToBilling: 'ไม่มีค่าใช้จ่ายภายในประเทศในการเรียกเก็บเงิน',
  NoSettlementUnit: 'ไม่มีหน่วยชำระหนี้',
  CheckoutObjectIsNullNoAdditionalCostsConfirmationSlip: 'วัตถุที่ชำระหนี้ว่างเปล่าและไม่สามารถเพิ่มใบยืนยันการเรียกเก็บเงินได้',
  ClearingUpInvoicingInformationWasNotSuccessfullyRead: 'ไม่สามารถอ่านข้อมูลยอดการเรียกเก็บเงินของ Settlement Object ได้สำเร็จ',
  YouDontHavePermissionToEditBills: 'คุณไม่มีสิทธิ์แก้ไขบิลเจ้าหนี้',
  YouDontHavePermissionToDeleteBills: 'คุณไม่มีสิทธิ์ลบบิลเจ้าหนี้',
  HaveNoPermissionToDeleteBillsCreatedByOtherUsers: 'ไม่มีสิทธิ์ในการลบรายการ ที่ผู้ใช้คนอื่นสร้างไว้',
  NoSelectedBill: 'ไม่มีการเลือกบิล',
  ClearingTheObjectDoesNotExistPleaseTryResettingTheCache: 'วัตถุการตั้งถิ่นฐานไม่มีอยู่โปรดลองรีเซ็ตแคช',
  BillSaveSuccessfully: 'บันทึกบิลสำเร็จ',
  BillingObjectIsNull: 'วัตถุใบเรียกเก็บเงินว่างเปล่า',
  ChargeCannotBeEmpty: 'ค่าใช้จ่ายต้องไม่ว่างเปล่า',
  TaxesAndTaxRatesDoesNotMatchTheData: 'ข้อมูลยอดภาษีและอัตราภาษีไม่ตรงกัน',
  InvoicingHeadCannotBeEmpty: 'ใบแจ้งหนี้ไม่สามารถเว้นว่างได้',
  CurrencyExchangeRateIsNotMaintained1: 'สกุลเงิน',
  CurrencyExchangeRateIsNotMaintained2: 'อัตราแลกเปลี่ยนไม่ได้รับการบำรุงรักษา',
  FeeCurrencyMustBeTheSame: 'สกุลเงินค่าธรรมเนียมจะต้องเหมือนกัน',
  NoForeignFeeBilling: 'ไม่มีค่าใช้จ่ายจากต่างประเทศมาเรียกเก็บเงิน',
  ThisJobIsNotWorkingCanNotBeDeleted: 'รายการนี้ไม่ใช่สถานะการทำงานเชิงบวกและไม่สามารถลบออกได้',
  SureYouWantToDeleteTheBilling: 'กำหนดถอดถอนร่างกฎหมายนี้หรือไม่',
  SureAuditTheBill: 'มั่นใจจะทบทวนร่างกฎหมายฉบับนี้หรือไม่',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeVoided: 'การเรียกเก็บเงินนี้ได้ถูกส่งไปตรวจสอบทางการเงินและไม่สามารถเป็นโมฆะได้',
  ThisOrderHasBeenRevokedNotARepeatedAction: 'รายการนี้เป็นโมฆะและไม่สามารถทำซ้ำได้',
  DomesticBillsCannotBeVoided: 'บิลในประเทศไม่สามารถเป็นโมฆะได้',
  TheBillHasBeenConfirmedAndCannotBeVoided: 'บิลได้รับการยืนยันแล้ว ไม่สามารถเป็นโมฆะได้ <br /> หากต้องการเป็นโมฆะ โปรดยกเลิกการยืนยันก่อน',
  ThisVerificationHasBeenDoneAndCannotBeVoided: 'รายการนี้ได้รับการตรวจสอบแล้วและไม่สามารถเป็นโมฆะได้',
  AccountIsClosedAnyOperationIsNotAllowed: 'มีการปิดบัญชีและไม่อนุญาตให้มีการดำเนินการใดๆ',
  ThisFormIsLockedAndCannotBeVoided: 'รายการนี้ถูกล็อคและไม่สามารถเป็นโมฆะได้',
  ThisFormIsLockedAndBillingGroup: 'รายการนี้มีใบแจ้งยอดบัญชีและไม่สามารถเป็นโมฆะได้',
  ConfirmTheCancellationOfTheBill: 'พิจารณาแล้วเป็นโมฆะร่างกฎหมายนี้หรือไม่',
  ConfirmTheCancellationOfTheBill2: 'ยืนยันการยกเลิกร่างกฎหมายที่เลือกไว้หรือไม่',
  TheBillHasBeenRevoked: 'ร่างกฎหมายเป็นโมฆะ',
  NoSelectSettlement: 'ไม่มีการเลือกวัตถุที่ชำระราคา',
  BillOfExchangeCannotBeEmpty: 'อัตราแลกเปลี่ยนบิลไม่สามารถว่างได้',
  CollectingAdvanceBillingAndGeneralExpensesCannotBeTogether: 'การจ่ายเงินดาวน์และค่าธรรมเนียมทั่วไปไม่สามารถรวมกันเพื่อออกใบเรียกเก็บเงินได้',
  TheBillNumberIsCreatedSuccessfully: 'การสร้างหมายเลขบิลสำเร็จ',
  TheWordCorrespondingNetworkNameOrTheOverseasAgentNetworkManagementCodeHasNotBeenMaintained: 'ชื่อท่ออินเทอร์เน็ตหรือรหัสท่ออินเทอร์เน็ตที่สอดคล้องกับตัวแทนในต่างประเทศยังไม่ได้รับการบำรุงรักษาและไม่สามารถสร้างหมายเลขบิลได้!',
  EnterTheShareProportion: 'โปรดป้อนสัดส่วนการแบ่ง',
  PleaseSelectACurrency: 'กรุณาเลือกสกุลเงิน',
  PleaseEnterTheBillingObject: 'กรุณากรอก Settlement Object',
  PleaseAddCosts: 'โปรดเพิ่มค่าธรรมเนียม',
  TheAmountOfBillCannotBeEqualTo: 'ยอดบิลต้องไม่เท่ากับ 0',
  PleaseEnterTheNameOfTheCosts: 'กรุณากรอกชื่อค่าธรรมเนียม',
  PleaseEnterTheQuantityOfTheCosts: 'กรุณาใส่จำนวนค่าธรรมเนียม',
  PleaseEnterThePriceOfTheCosts: 'กรุณากรอกราคาต่อหน่วย',
  PleaseSelectTheCostToRemove: 'โปรดเลือกค่าธรรมเนียมที่คุณต้องการลบ',
  CollectingInconsistentWithTheTotalAdvance: 'การเก็บเกี่ยวไม่สอดคล้องกับยอดรวมของเงินดาวน์!',
  TheBillHasBeenInvoicedAndCannotBeDeleted: 'มีการเรียกเก็บเงินและไม่สามารถลบได้',
  LoadFailed: 'โหลดล้มเหลว',
  PlatformCodeAlreadyExists: 'รหัสแพลตฟอร์มที่มีอยู่แล้ว!',
  NameCannotBeRepeated: 'ชื่อภาษาจีนหรือชื่อภาษาอังกฤษของวิชาที่เรียกเก็บเงินไม่สามารถทำซ้ำได้!!!',
  ChineseNameCannotBeBlank: 'ชื่อภาษาจีนของวิชาที่เรียกเก็บเงินไม่สามารถว่างเปล่า!!!',
  CannotBeModified: 'มีการใช้ในเชิงธุรกิจและไม่สามารถแก้ไขชื่อได้',
  PleaseSelectAServiceItem: 'กรุณาเลือกรายการบริการ',
  Overseas: 'ต่างประเทศ',
  Domestic: 'ในประเทศ',
  PleaseSelectTheDesiredPrintInformation: 'โปรดเลือกข้อมูลที่ต้องการพิมพ์',
  ThereIsAnErrorReadingWriteOffInformation: 'เกิดข้อผิดพลาดในการอ่านข้อมูลแผ่นหักบัญชี',
  TheBookingDoesNotExistAndCannotBeAdded: 'ไม่มีใบสั่งจองและไม่สามารถเพิ่มได้',
  PleaseEnter: 'โปรดเริ่มการสอบถามหลังจากป้อนอย่างน้อย 2 ตัวอักษร',
  PleaseEnterTheCode: 'กรุณากรอกแบบสอบถามที่คลุมเครือ เช่น รหัส, ชื่อ...',
  PleaseEnterTheCode2: 'กรุณากรอกแบบสอบถามที่คลุมเครือ (อย่างน้อยสองตัวอักขระ) รหัส ชื่อ ฯลฯ ...',
  PleaseEnterTheContent: 'โปรดป้อนเนื้อหา',
  PleaseSelectDataBeforeOperation: 'โปรดเลือกการดำเนินการหลังจากข้อมูล',
  NoPortRecordMeeting: 'บันทึกพอร์ตที่ตรงกับความต้องการไม่ได้เลือกโปรดเลือกใหม่!',
  DeleteTheSelectedRecord: 'ไม่ว่าจะเป็นการลบประวัติที่เลือกไว้',
  DoYouConfirmThatYouWantToDelete: 'คุณยืนยันที่จะลบ?',
  DeletionCancelled: 'ยกเลิกการลบ',
  EditCancelled: 'ยกเลิกการแก้ไข',
  PleaseSelectARecordToEdit: 'โปรดเลือกบันทึกสำหรับการแก้ไข',
  PleaseFillInTheCorrectFiveDigitPortCode: 'กรุณากรอกรหัสพอร์ตห้าหลักที่ถูกต้อง',
  DeleteFail: 'การลบล้มเหลว!',
  DeleteSucceeded: 'ลบสำเร็จ!',
  DisplayRuleCannotBeEmpty: 'แสดงกฎต้องไม่ว่างเปล่า!',
  OperationRequirementsCannotBeEmpty: 'ข้อกำหนดการใช้งานต้องไม่ว่างเปล่า!',
  OperationRequirementsCannotBeGreaterThan: 'ความยาวของความต้องการในการใช้งานต้องไม่เกิน 2048 บิต!',
  NewPortRequestSucceeded: 'เพิ่มพอร์ตความต้องการประสบความสำเร็จ',
  EditPortRequestSucceeded: 'แก้ไขข้อกำหนดท่าเรือสำเร็จ',
  ConfirmDelete: 'ยืนยันการลบ',
  IsItUsedForMAWB: 'ใช้สำหรับ MAWB หรือไม่',
  IsItUsedForHAWB: 'ใช้สำหรับ HAWB หรือไม่',
  AddPortRequirementsAirport: 'เพิ่มข้อกำหนดพอร์ต (ว่างเปล่า)',
  EditPortRequirementsAirport: 'แก้ไขข้อกำหนดพอร์ต (ว่างเปล่า)',
  PleaseSelectARecordToDelete: 'โปรดเลือกระเบียนเพื่อลบ',
  BackPageTip: '【กลับไปยังหน้าก่อนหน้า】 ข้อมูลที่กรอกในหน้ากรมธรรม์จะถูกลบออกหลังจากยืนยันการคืนกรมธรรม์?',
  WarmReminder: 'เคล็ดลับที่อบอุ่น',
  GoBack: 'กลับไปยังหน้าก่อนหน้า',
  ReturnToHomepage: 'กลับไปที่หน้าแรก',
  HomepageNotSupportImport: 'การประกันภัยการขนส่งสินค้า หน้าแรก ไม่รองรับการประกันภัยการนำเข้าโดยตรง',
  PortInformationEditedSuccessfully: 'แก้ไขข้อมูลท่าเรือสำเร็จ',
  AirlineInformationEditedSuccessfully: 'แก้ไขข้อมูลสายการบินสำเร็จ',
  SuccessfullyAddedAirlineInformation: 'เพิ่มข้อมูลสายการบินสำเร็จ',
  SuccessfullyAddedPortInformation: 'เพิ่มข้อมูลท่าเรือสำเร็จ',
  GetBack: 'การรับคืน',
  FailedToInquiryCustomsDeclarationInformation: 'การสอบถามข้อมูลการประกาศศุลกากรล้มเหลว:',
  PleaseSelectARecord: 'โปรดเลือกบันทึก',
  NewDocuments: 'เอกสารใหม่',
  EditDocuments: 'แก้ไขเอกสาร',
  FileTypeCannotBeEmpty: 'ประเภทแฟ้มต้องไม่ว่างเปล่า!',
  FileNumberCannotBeEmpty: 'หมายเลขแฟ้มต้องไม่ว่างเปล่า',
  FileNumberAlreadyExists: 'หมายเลขแฟ้มมีอยู่แล้ว',
  DataEnabledSuccessfully: 'การเปิดใช้งานข้อมูลสำเร็จ',
  DataDisabledSuccessfully: 'ปิดการใช้งานข้อมูลสำเร็จ',
  Error2: 'ข้อผิดพลาด',
  TheDocumentHasBeenSaved: 'เอกสารถูกบันทึกไว้แล้ว',
  TheCustomsBrokerCannotBeEmpty: 'นายหน้าศุลกากรไม่สามารถว่างได้',
  NoInformationCanBeQueried: 'ไม่มีข้อมูลประกาศศุลกากรที่จะสอบถาม',
  ErrorSavingBusinessState: 'บันทึกสถานะธุรกิจผิดพลาด',
  OrderInformationWasSuccessfullyUpdated: 'อัปเดตข้อมูลการสั่งซื้อเรียบร้อยแล้ว',
  NoExternalUpdateInformation: 'ไม่มีข้อมูลอัปเดตภายนอก',
  ExternalInformationWasSuccessfullyUpdated: 'อัพเดทข้อมูลภายนอกสำเร็จ',
  NodeStatusIsNotPreserved: 'ไม่มีการบันทึกสถานะโหนด',
  TheNodeAffinityForTheMailTemplateIsNotMaintained: 'แม่แบบจดหมายที่เกี่ยวข้องโหนดไม่ได้รับการบำรุงรักษา',
  DoNotLocateAnAssociatedPrintTemplateType: 'ไม่พบประเภทของแม่แบบการพิมพ์ที่เกี่ยวข้อง',
  TheEmailWasSentPleaseNoteTheQuery: 'จดหมายถูกส่งแล้วโปรดทราบการสอบถาม!',
  PleaseSelectAFile: 'กรุณาเลือกไฟล์!',
  SureYouWantToDeleteFiles: 'แน่ใจนะว่าคุณต้องการลบไฟล์?',
  EmailAddressCannotBeEmpty: 'ที่อยู่อีเมลไม่สามารถว่างได้',
  UploadSuccess: 'อัปโหลดสำเร็จ:',
  UploadFailed: 'การอัพโหลดล้มเหลว:',
  FileSizeExceedsMBYouCannotUpload: 'ขนาดไฟล์มากกว่า 20 MB ไม่สามารถอัพโหลดได้',
  DoNotSelectedCategory: 'ยังไม่มีการเลือกประเภทแฟ้ม',
  PleaseSelectAJob: 'โปรดเลือกแผ่นงาน',
  PleaseSelectTheSameTypeOfJob: 'กรุณาเลือกประเภทงานเดียวกัน',
  NotStart: 'ยังไม่เริ่ม',
  PleaseSelectABusinessStatus: 'กรุณาเลือกสถานะธุรกิจ',
  PleaseSelectABusinessStatusDetails: 'กรุณาเลือกรายละเอียดสถานะธุรกิจ',
  EditedSuccessfully: 'แก้ไขสำเร็จ',
  PleaseContactTheSuperiorUnlocked: 'แคชเชียร์เช็คถูกล็อคและไม่สามารถพิมพ์ได้เนื่องจากอยู่นอกเหนือการควบคุมเครดิตโปรดติดต่อผู้บังคับบัญชาเพื่อปลดล็อค!',
  CanSuccessfullyPrint: 'พิมพ์เสร็จแล้วหรือยัง?',
  ConfirmToPrint: 'ยืนยันการพิมพ์',
  CorrespondsToThePrintTemplateDoesNotFind: 'ไม่พบแม่แบบการพิมพ์ที่ตรงกัน',
  FailedToGetTheTemplateType: 'การรับประเภทเทมเพลตล้มเหลว!',
  NoSelectedTemplate: 'ยังไม่มีการเลือกแม่แบบ',
  BulkTransshipmentSuccessWhetherYouWantToCloseThePopUpWindow: 'การย้ายเรือจำนวนมากสำเร็จคุณต้องการปิดหน้าต่างป๊อปอัปหรือไม่',
  BulkTranferSuccessWhetherYouWantToCloseThePopUpWindow: 'การโอนเป็นกลุ่มสำเร็จคุณต้องการปิดหน้าต่างป๊อปอัปหรือไม่',
  NoFeesCanBeDeleted: 'ไม่มีค่าธรรมเนียมที่จะลบ',
  NoSelectedCharge: 'ไม่มีค่าธรรมเนียมที่เลือก',
  NoChargeCanBeSaved: 'ไม่มีค่าธรรมเนียมที่สามารถบันทึกได้',
  ChargeNameCannotBeEmpty: 'ชื่อค่าธรรมเนียมไม่สามารถเว้นว่างได้',
  ClearingTheObjectCannotBeNull: 'วัตถุของการตั้งถิ่นฐานไม่สามารถว่างเปล่าได้',
  BusinessNumberIs0: 'เลขธุรกิจคือ 0',
  CustomerIsNULL: 'ลูกค้าว่างเปล่า',
  TheCarrierIsEmpty: 'ผู้ให้บริการว่างเปล่า',
  AgentIsNULL: 'ตัวแทนการจอง / ตัวแทนเปลี่ยนใบสั่งว่างเปล่า',
  AgentIsNULL2: 'ตัวแทนในต่างประเทศ / ตัวแทนปลายทางว่างเปล่า',
  CustomsIsNull: 'ประกาศศุลกากรที่ว่างเปล่า',
  TerminalCompanyIsNull: 'บริษัทท่าเรือว่างเปล่า',
  TheObjectCannotBeUsedAsTheDefaultSettlement: 'ไม่สามารถใช้เป็นวัตถุชำระหนี้โดยปริยายได้',
  AddSuccessfully: 'เพิ่มความสำเร็จ',
  DisplaysTheCostOfUpdatingResults: 'แสดงผลการปรับปรุงค่าธรรมเนียม',
  TotalCost1: 'ทั้งหมด',
  TotalCost2: 'ค่าใช้จ่ายแถบ,',
  Updated1: 'ปรับปรุงแล้ว',
  Updated2: 'บาร์,',
  NotUpdated1: 'และ',
  NotUpdated2: 'แถบไม่ได้รับการปรับปรุง',
  NotMatchingTheCostOfTheProjectCanBeAdded: '<i class="el-icon-info" style="font-size: 16px;"></i><span style="font-size: 14px;margin-left: 5px;"> ไม่มีค่าธรรมเนียม </span> <b style ="font-size: 16px;"> เพิ่มได้</b>',
  ChargeWasSuccessfullyUpdated: 'อัพเดทค่าใช้จ่ายสำเร็จ',
  NotMatchingTheCostOfTheProjectCanBeUpdated: 'ไม่มีรายการค่าธรรมเนียมที่ตรงกันสำหรับอัปเดต',
  NoAddedCharge: 'ไม่มีค่าธรรมเนียมเพิ่ม',
  DefaultValuesAreSavedSuccessfully: 'บันทึกค่าปริยายสำเร็จ',
  ContSigned: '(เซ็นสัญญาแล้ว)',
  ContUnsigned: '(ไม่ได้ลงนาม)',
  InvalidCont: '(สัญญาเป็นโมฆะ)',
  TheSystemHasBeenUpdatedPleaseRefreshThePage: 'ระบบได้รับการปรับปรุงโปรดรีเฟรชหน้า!',
  PleaseInputCosts: 'กรุณากรอกรายการค่าธรรมเนียม',
  SelectTheSurchargeClause: 'โปรดเลือกเงื่อนไขค่าธรรมเนียมเพิ่มเติม',
  HAWBCannotBeNull: 'AMS หมายเลขย่อยไม่สามารถว่าง!',
  HAWBAfrCannotBeNull: 'หมายเลข HB/L ไม่สามารถเว้นว่างได้!',
  HAWBCannotBeRepeated: 'หมายเลขย่อย AMS ไม่สามารถทำซ้ำได้!',
  HAWBAfrCannotBeRepeated: 'หมายเลข HB/L ไม่สามารถทำซ้ำได้!',
  InlandCannotBeNull: 'จุดในประเทศ / คลังสินค้าไม่สามารถว่างเปล่า!',
  rocordNumberCannotBeNull: 'หมายเลขการยื่นศุลกากรของแคนาดาไม่สามารถว่างเปล่า!',
  AreYouSureYouWantToDelete1: 'คุณแน่ใจว่าคุณต้องการลบ',
  SureDeleteHbl: 'ไม่สามารถกู้คืนได้หลังจากการลบใบสั่งแยกยืนยันการลบ?',
  AreYouSureYouWantToDelete2: 'เหรอ',
  PleaseSelectTheAMSNO: 'โปรดเลือกหมายเลข AMS ก่อน',
  PleaseSelectTheHBLNO: 'โปรดเลือกหมายเลข HB/L ก่อน',
  TheMaximumCannotExceedLines: 'สูงสุดไม่เกิน 5 บรรทัด!',
  DisplayColumn: 'ปรับแต่งคอลัมน์การแสดงผล',
  Display: 'มองเห็นได้',
  Name: 'ชื่อคอลัมน์',
  TradeCommissionedUnitCannotBeEmpty: 'เทรดดิ้ง - หน่วยลงทุนไม่สามารถว่างได้',
  TradeSalesSupportCannotBeEmpty: 'การค้า - การสนับสนุนการขายไม่สามารถว่างเปล่า',
  TradingCurrencyCannotBeEmpty: 'การค้า - สกุลเงินที่สั่งซื้อไม่สามารถว่างเปล่าได้',
  TradingExchangeRateCannotBeEmpty: 'เทรดดิ้ง - อัตราแลกเปลี่ยนออเดอร์ต้องไม่ว่างเปล่า',
  TradeServiceFeeDiscountRateCannotBeEmpty: 'การค้า - อัตราค่าบริการส่วนลดไม่สามารถเว้นว่างได้',
  TradeTheAmountOfWriteOffsCannotBeGreaterThanTheAmountOfOrders: 'เทรดดิ้ง - ยอดการสั่งซื้อต้องไม่เกินยอดการสั่งซื้อ',
  TradePaymentNOCannotBeEmpty: 'การค้า - หมายเลขการโอนเงินไม่สามารถว่างเปล่าได้',
  TradePaymentNumberCannotBeGreaterThanBitsInLength: 'การค้า - หมายเลขการชำระเงินต้องไม่เกินความยาว 16 หลัก',
  UnableToDeleteAllCharges: 'ไม่สามารถลบค่าใช้จ่ายทั้งหมดได้',
  PleaseCheckYourNetworkOrRefreshThePage: 'โปร คุณอยู่ในอวกาศที่ไม่มีเครือข่าย โปรดตรวจสอบว่าเครือข่ายปกติหรือรีเฟรชหน้า',
  TheFileIsSentSuccessfully: 'ส่งไฟล์สำเร็จ',
  PleaseSelectAFileToDownloadOrSend: 'โปรดเลือกไฟล์ที่ต้องการดาวน์โหลดหรือส่ง',
  PleaseSelectAFileSynchronization: 'โปรดเลือกไฟล์ที่คุณต้องการซิงค์',
  PleaseSelectAFileCancelSynchronization: 'โปรดเลือกไฟล์ที่ต้องการยกเลิกการซิงค์',
  FailedToModifyAFileType: 'ล้มเหลวในการแก้ไขประเภทแฟ้ม',
  PleaseSelectAFileType: 'กรุณาเลือกประเภทแฟ้ม',
  MBLNOCannotBeDuplicated: 'MB/L NO2 ไม่สามารถทำซ้ำได้!',
  PleaseSelectMBLNo: 'โปรดเลือกหมายเลข MBL ก่อน',
  TotalWeightOfLadingAreInconsistent: 'เสื้อคลุม B / L ไม่สอดคล้องกัน!',
  TOORDERIsUnavailableToRelease: 'ถึง ORDER ไม่สามารถปล่อยกระแสไฟฟ้าได้',
  TheAssociatedPrimaryFormIsNotSelected: 'รายการหลักพันธมิตร ไม่มีตัวเลือก',
  PleaseSelectHBLNo: 'โปรดเลือกหมายเลข HBL ก่อน!',
  PleaseEnterTheBillOfLadingSerialNumber: 'กรุณาใส่หมายเลขประกอบการ B / L ก่อน!',
  PleaseUploadReleaseGuarantee: 'ไม่มีหนังสือค้ำประกันการปล่อยก๊าซที่มีผลบังคับใช้โปรดอัปโหลดก่อน',
  TheRecipientAddressCannotBeEmpty: 'ที่อยู่ผู้รับไม่สามารถว่างได้',
  OperationIsNotReversible: 'การดำเนินการไม่สามารถย้อนกลับได้',
  Uncommitted: 'ยังไม่ได้ส่ง',
  Approved: 'ตรวจสอบแล้ว',
  Submitted: 'ส่งแล้ว',
  Rejected: 'ถูกปฏิเสธ',
  PleaseSelect: 'กรุณาเลือก',
  Uploaded: 'อัปโหลดเสร็จสมบูรณ์',
  Waiting: 'รอการอัปโหลด',
  Uploading: 'อัปโหลดแล้ว',
  Other: 'อื่นๆ',
  First: 'หน้าแรก',
  Pre: 'หน้าก่อนหน้า',
  Page: 'ข้อที่',
  AllPage1: 'ทั้งหมด',
  AllPage2: 'หน้า',
  Next: 'หน้าถัดไป',
  Last: 'หน้าสุดท้าย',
  ShowFromTo1: 'แสดง',
  ShowFromTo2: 'ถึง',
  AllRecord1: 'ทั้งหมด',
  Transactions: 'ปากกา',
  AllRecord2: 'บันทึก',
  Convert: 'พับ',
  YouAreUnableToUseThisFunctionAsWHHasntBeenConfiguredIfNeedPleaseContactCSOnline: 'Pro, คุณไม่ได้กำหนดค่าคลังสินค้าดังนั้นคุณจึงไม่สามารถใช้คุณลักษณะนี้ได้หากต้องการโปรดติดต่อฝ่ายบริการลูกค้าออนไลน์',
  FirstSaveTheBusinessAutomaticLoadingIsInProgress: 'โปรโปรดบันทึกธุรกิจก่อนในการดำเนินการจัดสรรสินค้าอัตโนมัติ',
  FirstSaveTheBusinessAddSpecialGoods: 'โปรโปรดเก็บธุรกิจไว้ก่อนเพิ่มสินค้าอันตราย',
  GeneralTrade: 'การค้าทั่วไป',
  ProcessingWithSuppliedMaterial: 'การประมวลผลวัสดุที่เข้ามา',
  ProcessingTrade: 'ป้อนเข้าปาก',
  SamplesOfAdvertisingProductsA: 'สินค้าตัวอย่าง A',
  Refuse: 'ปฏิเสธ',
  Agree: 'ความยินยอม',
  GoOn: 'ดำเนินการต่อไป',
  SubmitAudit: 'ส่งให้ผู้บังคับบัญชาตรวจสอบ',
  DataValidation: 'อยู่ระหว่างการตรวจสอบข้อมูล',
  DataValidatedWithWarning1: 'การตรวจสอบข้อมูลเสร็จสิ้น แต่มีการเตือนเพื่อดำเนินการต่อ',
  DataValidatedWithWarning2: 'กรุณาคลิก 【ดำเนินการต่อไป】 เพื่อยกเลิก',
  DataValidatedWithWarning3: 'กรุณาคลิก 【การยกเลิก】',
  DataValidatedSuccessfully1: 'ตรวจสอบข้อมูลเรียบร้อยแล้ว,ยืนยัน',
  DataValidatedSuccessfully2: 'กรุณาคลิก 【ยืนยัน】 เพื่อยกเลิก',
  DataValidatedSuccessfully3: 'กรุณาคลิก 【การยกเลิก】',
  DataValidatedFailure1: 'การตรวจสอบข้อมูลล้มเหลว โปรดประมวลผลรายการข้อมูลที่ไม่ผ่านการตรวจสอบก่อน',
  DataValidatedFailure2: '',
  WoChat: 'โวแชต',
  TheSystemHasBeenUpdatedPleaseTurnTheModuleOnAgain: 'ระบบได้รับการปรับปรุงโปรดปิดโมดูลเพื่อเปิดใหม่อีกครั้ง',
  TheSystemHasBeenUpdatedPleaseReLoginOrClearBrowserCache: 'ระบบได้รับการปรับปรุง, กรุณา re-login หรือทำความสะอาดแคชของเบราว์เซอร์.',
  AddAdjustment: 'เพิ่มการปรับ',
  AddCharge: 'เพิ่มค่าธรรมเนียม',
  AddCostCharge: 'เพิ่มค่าธรรมเนียมลูกหนี้',
  AddPayCharge: 'เพิ่มค่าธรรมเนียมที่ต้องชำระ',
  EditAdjustment: 'การปรับเปลี่ยน',
  EditCharge: 'ค่าธรรมเนียมการเปลี่ยนแปลง',
  EditCostCharge: 'แก้ไขค่าธรรมเนียมลูกหนี้',
  EditPayCharge: 'แก้ไขค่าใช้จ่ายที่ต้องชำระ',
  DeleteAdjustment: 'ลบการปรับแต่ง',
  DeleteCostCharge: 'ลบค่าธรรมเนียมที่เรียกเก็บ',
  DeletePayCharge: 'ลบค่าใช้จ่ายที่ต้องชำระ',
  DateOfAdjustmentCannotBeNull: 'วันที่ปรับไม่สามารถว่างได้',
  CurrencyOfAdjustmentCannotBeNull: 'สกุลเงินไม่สามารถว่างเปล่าได้',
  AmountCannotBeZero: 'ปริมาณต้องไม่เป็นศูนย์',
  UnitPriceCannotBeZero: 'ราคาต่อหน่วยต้องไม่เป็นศูนย์',
  AmountCannotBeZero2: 'จำนวนเงินต้องไม่เป็นศูนย์',
  ExchangeCannotBeZero2: 'อัตราแลกเปลี่ยนต้องไม่เป็นศูนย์',
  RemarkTheLengthCannotExceed: 'หมายเหตุ ความยาวไม่เกิน 50',
  InvoiceNoCannotBeNull: 'หมายเลขภาษีไม่สามารถเว้นว่างได้',
  InvoiceNoIsTooLong: 'หมายเลขภาษียาวเกินไป',
  PleaseAddSpecialGoodsFirst: 'โปรดเพิ่มวัตถุอันตรายก่อน',
  UNNoIsEmpty: 'กรุณากรอกหมายเลข UN',
  LoadSpGoodsContainerError: 'เกิดข้อผิดพลาดในการโหลดข้อมูลการบรรจุสินค้าอันตราย',
  AssociatedSpGoodsError: 'ข้อมูลสินค้าอันตรายที่เกี่ยวข้องผิดพลาด',
  NoAssociatedInfo: 'ไม่มีข้อมูลที่เกี่ยวข้อง',
  InnerPackagingTypeIsRequired: 'ประเภทบรรจุภัณฑ์ภายในต้องกรอก',
  InnerPackagingQuantityIsRequired: 'จำนวนชิ้นที่บรรจุภายในต้องกรอก',
  SeaPollutionOnlyEnterYN: 'ค่าฟิลด์มลพิษทางทะเลต้องเป็น Y หรือ N',
  SelectHsCode: 'เลือกหมายเลข HS',
  SelectCargoChineseName: 'เลือกชื่อภาษาจีน',
  DispatchNotYet: 'ใบนำส่งสินค้าไม่สำเร็จ ไม่อนุญาตให้เปลี่ยนใบนำส่งสินค้า',
  AllDataMustBeOperating: 'ข้อมูลทั้งหมดต้องเป็นบวกในการทำงาน',
  TheSelectedDocumentInconsistentNatureOfTheContainerLoadType: 'โปรดเลือกธุรกิจที่สอดคล้องกันทั้งประเภท',
  TheNumberOfChargesLimited: 'ค่าธรรมเนียมสูงสุดต้องไม่เกิน',
  TheNumberOfSelectedDataLimited: 'ข้อมูลที่ถูกเลือกต้องไม่เกิน',
  PleaseInputSearchCondition: 'กรุณากรอกเงื่อนไขในการสอบถาม',
  PlaceOfDeliveryCannotBeNull: 'สถานที่จัดส่งต้องไม่ว่างเปล่า',
  ImportSuccessChargesCount: 'นำเข้าค่าธรรมเนียม {count}bar เรียบร้อยแล้ว',
  CheckChargeDetailBranch: 'สำนักงานสาขาที่ข้อมูลกำลังดำเนินการอยู่นั้นไม่ได้เป็นสาขาปัจจุบันหรือสาขาระดับก่อนหน้า',
  ChangeSelectSales: 'มีการเปลี่ยนยอดขาย จะบันทึกต่อไปหรือไม่',
  NoSelectedCargoDocInformation: 'กรุณาเลือกบันทึก B / L!',
  OverseaCostChargeEmpty: 'ค่าธรรมเนียมลูกหนี้ว่างเปล่า!',
  OverseasBillsCanNotBePrinted: 'บิลต่างประเทศไม่สามารถพิมพ์ได้ (บิลว่างเปล่า ไม่มีการเลือก เป็นโมฆะ ไม่มีสิทธิ์)!',
  CheckHBLReleaseStateBeforePrint: 'ไม่ใส่แผ่นไม่สามารถพิมพ์!',
  NoSelectedWarehouseInInformation: 'ไม่มีการเลือกข้อมูลคลังสินค้าที่ต้องการพิมพ์!',
  NoWarehouseInInformation: 'ข้อมูลคลังสินค้าที่คุณเลือกไม่ถูกต้อง!',
  ConfirmTheShutOut: 'แน่ใจนะว่าต้องการจะเป็นโมฆะธุรกิจตั๋ว? ค่าใช้จ่ายทั้งหมดจะถูกลบออก!',
  SaveSucceed: 'บันทึกความสำเร็จ!',
  SelectOneJob: 'อนุญาตให้ทำการคัดลอกธุรกิจบัตรเดียวเท่านั้น!',
  PleaseInputETD: 'โปรดเลือกช่วงวันที่ออกเดินทาง!',
  SelectJob: 'โปรดเลือกธุรกิจ!',
  DateToday: 'วันนี้',
  PleaseSelectSoNo: 'กรุณาเลือกหมายเลขปิด',
  ChargeOffsetState: 'ค่าใช้จ่ายได้ชงแดงหรือถูกแดง',
  isDeleteAllEDIContainer: 'ไม่ว่าจะเป็นการล้างข้อมูลการบรรจุหีบห่อทั้งหมด',
  ServiceCodeCannotBeNull: 'รหัสบริการไม่สามารถเว้นว่างได้',
  Choose: 'ตรวจสอบแล้ว',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeForceDel: 'การเรียกเก็บเงินนี้ได้ถูกส่งไปตรวจสอบทางการเงินแล้วและไม่สามารถบังคับให้ลบได้',
  ThisVerificationHasBeenDoneAndCannotBeForceDel: 'รายการนี้ได้รับการยกเลิกและไม่สามารถบังคับให้ลบออกได้',
  ThisFormIsLockedAndCannotBeForceDel: 'รายการนี้ถูกล็อคและไม่สามารถบังคับให้ลบได้',
  ConfirmTheForceDelOfTheBill: 'กำหนดบังคับลบร่างกฎหมายนี้หรือไม่',
  ForceDelSuccessfully: 'บังคับให้ลบสำเร็จ',
  IsNotOperationStatusCannotBeShutOut: 'ธุรกิจที่สามารถเพิกถอนสถานะ "ปฏิบัติการในเชิงบวก" ได้เป็นจำนวนมากเท่านั้น',
  IsNotOperationStatusCannotBeCancellation: 'ธุรกิจที่มีสถานะ "ปฏิบัติงานในเชิงบวก" เป็นโมฆะเป็นจำนวนมากเท่านั้น',
  ManifestLink: 'ลิงค์รายการสินค้ามีดังนี้',
  ApplicationAmountCheck: 'ชำระค่าสมัครไม่ตรงกับยอดรวมค่าธรรมเนียม โปรดตรวจสอบ!',
  TipsOnSplittingExpenses: 'ค่าธรรมเนียมการแยกจะต้องไม่เกินจำนวนค่าธรรมเนียมเดิม โปรดแก้ไขค่าธรรมเนียมการแยก!',
  DcCopyCheck: 'ธุรกิจมีบุคลากรเอกสารไม่มีข้อมูลหน่วยงานหรือ บริษัท โปรดเลือกเอกสารใหม่!',
  CsrCopyCheck: 'ธุรกิจนี้มีพนักงานบริการลูกค้าไม่มีข้อมูลแผนกหรือ บริษัท โปรดเลือกฝ่ายบริการลูกค้าอีกครั้ง!',
  SureDeleteThese: 'แน่ใจว่าคุณต้องการลบสิ่งนี้',
  OrdersOfBusiness: 'ธุรกิจตั๋ว?',
  SureCancellationAndDeleteCharge: 'แน่ใจนะว่าต้องการจะเป็นโมฆะธุรกิจ? ค่าธรรมเนียมทั้งหมดจะถูกลบ!',
  SureShutOutAndDeleteCharge: 'แน่ใจนะว่าคุณต้องการถอนตัว? ค่าธรรมเนียมทั้งหมดจะถูกลบ!',
  CheckingConsignation: 'ธุรกิจนี้ไม่สามารถมอบหมายโปรดลองอีกครั้งหลังจากตรวจสอบ!',
  TheSubBillHasBeenConsolidatedAndCannotBeDelete: 'ตั๋วขนาดเล็กนี้ถูกสะกดในกล่องและไม่สามารถลบออกได้',
  SaveFailedMessage: 'บันทึกล้มเหลวโปรดลองอีกครั้งหลังจากรีเฟรช!',
  SettlementAgentCannotBeNull: 'ตัวแทนการตั้งถิ่นฐานไม่สามารถว่าง!',
  SettlementAgentErrorPleaseReSelect: 'ข้อผิดพลาดของตัวแทนการตั้งถิ่นฐานโปรดเลือกใหม่!',
  NowContainer: 'กล่องปัจจุบัน',
  NowContainerCanNotDelete: 'กล่องปัจจุบันถูกครอบครองและไม่สามารถลบได้!',
  NotDelete: 'ลบไม่ได้!',
  PleaseSelectBoxType: 'โปรดเลือกประเภทกล่อง!',
  PleaseEnterUnitPrice: 'กรุณากรอกราคาต่อหน่วย!',
  PleaseSelectCurrency: 'กรุณาเลือกสกุลเงิน!',
  PleaseEnterTheStartDate: 'โปรดป้อนวันที่เช่าเริ่มต้น!',
  PleaseEnterThebuyDate: 'โปรดป้อนวันที่ซื้อกล่อง!',
  PleaseEnterEndDate: 'โปรดป้อนวันที่สิ้นสุด!',
  SuccessfulBoxAdjustment: 'ปรับกล่องสำเร็จ! จำนวนประมวลผล',
  NoBoxesProcessedSuccessfully: 'ไม่มีการจัดการกล่องสำเร็จโปรดตรวจสอบกล่องจริง!',
  OnlyBuyCaseOrderBoxCanBeSold: 'ขายเฉพาะกล่องซื้อกล่องสั่งซื้อโปรดตรวจสอบ!',
  ChoiceCaseSell: 'โปรดเลือกกล่องอื่นที่เป็นเหรียญเดียวกันสำหรับการขาย!',
  PleaseContainerData: 'กรุณากรอกข้อมูลกล่อง!',
  UnifiedCurrency: 'การสั่งซื้อกล่องขายรองรับสกุลเงินเดียวเท่านั้นโปรดขายสกุลเงินกล่องแบบครบวงจร!',
  PleaseCheckTheBoxToBeSold: 'กรุณาเลือกกล่องที่ต้องการขาย!',
  EditedFailMessage: 'การแก้ไขล้มเหลวโปรดลองอีกครั้งหลังจากรีเฟรช!',
  DataValidatedWithPartialPass1: 'การตรวจสอบข้อมูลเสร็จสิ้น แต่มีการเตือนและความล้มเหลวบางส่วนเพื่อดำเนินการต่อ',
  DataValidatedWithPartialPass2: 'กรุณาคลิก 【ดำเนินการต่อไป】 เพื่อยกเลิก',
  DataValidatedWithPartialPass3: 'โปรดคลิก 【การยกเลิก】 หมายเหตุ: การตรวจสอบล้มเหลว โปรดประมวลผลรายการข้อมูลที่ไม่ผ่านการตรวจสอบก่อน',
  AddChangeCharge: 'เพิ่มค่าธรรมเนียมการเปลี่ยนแปลงใบสั่ง',
  ThereAreNoPayableBillsToPrint: 'ไม่มีสลิปการชำระเงินให้พิมพ์',
  ReleaseInformationNotSelected: 'ใส่ข้อมูล ไม่มีตัวเลือก',
  AreYouSureYouWantTo: 'แน่ใจนะว่าต้องการ {0}?',
  NoRecordsAvailable: 'ไม่มีประวัติสำหรับ {0}',
  NoDataToAudit: 'ไม่มีข้อมูลที่สามารถตรวจสอบได้',
  NoSplittingRecordSelected: 'ไม่มีการเลือกบันทึกรายการย่อย',
  NoDataToAudit2: 'ไม่มีข้อมูลที่สามารถ {0} ได้',
  EditChangeCharge: 'ค่าธรรมเนียมการเปลี่ยนแปลงใบสั่ง',
  AddSpecialCharge: 'เพิ่มค่าธรรมเนียมพิเศษ',
  EditSpecialCharge: 'แก้ไขค่าธรรมเนียมพิเศษ',
  AddSpecialUpdate: 'การปรับค่าธรรมเนียมพิเศษ',
  Pstsftba: 'โปรดเลือกค่าธรรมเนียมพิเศษที่ต้องปรับเปลี่ยน!',
  Nsecbe: 'ค่าธรรมเนียมที่ไม่ใช่พิเศษไม่สามารถแก้ไขได้!',
  UpdateWarehouseRecord: 'มีการเปลี่ยนโกดังเก็บสินค้าต่อไปหรือไม่',
  CheckCostAndBusinessMismatching: 'รายการค่าธรรมเนียมที่ถูกเลือกไม่ตรงกับธุรกิจ',
  TicketEntrustedCannotRepetitionDelegate: 'ตั๋วได้รับมอบหมายแล้ว อย่ามอบหมายซ้ำ!',
  NotFindCurrencyRatePleaseMaintain: 'ไม่พบอัตราแลกเปลี่ยนของสกุลเงิน {0} โปรดรักษาอัตราแลกเปลี่ยนที่เกี่ยวข้องในเวลาและบันทึกอีกครั้ง!',
  BillPaymentDeleteTips: 'ลบเฉพาะใบคำขอรับชำระเงินที่ไม่ใช่สถานะการอนุมัติทางการเงินและที่ยังไม่ได้รับการอนุมัติเท่านั้น',
  SettlementAgentNotNull: 'ตัวแทนการตั้งถิ่นฐานไม่สามารถว่าง!',
  PleaseSelectSameSettlementAgent: 'โปรดเลือกการเรียกเก็บเงินของตัวแทนการชำระเงินเดียวกัน!',
  TheHAWBAndMAWBAreInconsistentTheSystemWillModifyTheHAWBContinue: 'New selected small ticket ปลายทาง ตัวแทน ท่าเรือ, ท่าเรือของการโหลด, ท่าเรือปลายทาง, ตัวแทนการจอง, สายการบิน, เที่ยวบิน, ETD, ลักษณะการจอง, เงื่อนไขการจัดส่งแบบ Master Single \# ไม่สอดคล้องกับตั๋วหลัก, ระบบจะแก้ไขตั๋วขนาดเล็ก, จะดำเนินการต่อหรือไม่?',
  AMS_ReturnMessage: 'ข้อมูล AMS Carry-on Trichomes ไม่ตรงกับความเป็นจริงโปรดปรับ! \n',
  AMS_ReturnMessageCanSave: 'ข้อมูล AMS Trichomes ของกระเป๋าเดินทางไม่ตรงกับความเป็นจริงและจะเก็บไว้ต่อหรือไม่? \n',
  AMS_Quantity: '【AMS จำนวนชิ้น {0} {1} จำนวนชิ้นจริง {2}】\n',
  AMS_Weight: '【น้ำหนักรวม AMS {0} {1} น้ำหนักรวม {2}】\n',
  AMS_Cubage: '【ปริมาณ AMS {0} {1} ปริมาณจริง {2}】\n',
  AMS_ContainerNo: 'หมายเลขกล่อง 【{0}】: \#n',
  CheckPortsByConsignation: '【{0}】 ที่คุณได้รับมอบหมายไม่มีการบำรุงรักษาพอร์ต 【{0}】 โปรดตรวจสอบกับแต่ละอื่น ๆ ก่อนที่จะมอบหมาย!',
  CheckPackingByConsignation: '【{0}】 ที่คุณได้รับมอบหมายไม่มีการบำรุงรักษา 【{0}】 แพคเกจโปรดตรวจสอบกับแต่ละอื่น ๆ ก่อนที่จะมอบหมาย!',
  CheckCompanyByConsignation: '【{0}】 ที่คุณได้รับมอบหมายไม่มีข้อมูลที่เกี่ยวข้องเช่นการบำรุงรักษารหัส SCAC ของ 【{0}】 โปรดตรวจสอบกับอีกฝ่ายก่อนที่จะมอบหมาย!',
  CheckCarrier: 'โปรดรักษารหัส SCAC ของ 【{0}】 ก่อนแล้วจึงมอบหมาย!',
  SettleAccountMustBeSame: 'วัตถุของการตั้งถิ่นฐานจะต้องเหมือนกัน',
  ReceivableCannotMorethanPay: 'ค่าใช้จ่ายของลูกหนี้ต้องไม่เกินค่าใช้จ่ายที่ต้องชำระ',
  PleaseSelectJobs: 'กรุณาเลือก Business Slip Records',
  SapCommitCheck: 'SAP ONE / P เสร็จสิ้นแล้วอย่าทำซ้ำ / P',
  SapCancelCommitCheck: 'ค่าธรรมเนียมไม่สามารถถอนสถานะ SAP ได้ โปรดยืนยันสถานะ SAP ของค่าธรรมเนียม',
  escnm: 'ไม่มีการบำรุงรักษาโดยฝ่ายชำระค่าธรรมเนียม',
  SapSynchronizationSuccess: 'ค่าธรรมเนียมการซิงค์ของ SAP ประสบความสำเร็จ',
  SapSynchronizationFault: 'ค่าธรรมเนียมการซิงค์ของ SAP ล้มเหลว',
  SapStatusCanNotAudit: 'ค่าธรรมเนียมไม่สามารถตรวจสอบสถานะ SAP ได้ โปรดยืนยันสถานะ SAP ของค่าธรรมเนียม',
  ChangeOrderSubmissionFailed: 'การส่งแบบฟอร์มการเปลี่ยนแปลงไม่สำเร็จ และยังไม่พบค่าใช้จ่ายที่ต้องแก้ไข!',
  SureYouWantToDeleteFilesTwo: 'แน่ใจหรือว่าคุณต้องการลบไฟล์ {0} เป็นชุด?',
  JumpFailed: 'กระโดดล้มเหลว',
  SelectCopyContent: 'เลือกเนื้อหาที่คัดลอก',
  CopyContent: 'คัดลอกเนื้อหา',
  SelectImportContent: 'เลือกเนื้อหาที่นำเข้า',
  ImportContent: 'การนำเข้าเนื้อหา',
  DifferenceOverwritesTheOriginalValue: 'ฟิลด์ที่แตกต่างกันเขียนทับค่าต้นฉบับ',
  DifferenceRetainsTheOriginalValue: 'ฟิลด์ที่แตกต่างกันเก็บค่าเดิม',
  RememberToChoose: 'จดจำทางเลือกของฉัน',
  TheImportedServiceNumberDoesNotExistProcedure: 'การนำเข้าล้มเหลวและหมายเลขธุรกิจที่นำเข้าไม่มีอยู่โปรดลองอีกครั้ง!',
  TheIDOfTheImportedServiceMustBeDifferentFromThatOfTheImportedService: 'การนำเข้าต้องไม่ตรงกับเลขธุรกิจที่นำเข้ามา',
  CopyNumber: 'จำนวนสำเนานี้',
  QuickSearchBusinessNo: 'ดึงข้อมูลได้อย่างรวดเร็ว: หมายเลขธุรกิจ',
  QuickSearchChineseName: 'ดึงข้อมูลด่วน: ชื่อภาษาจีน',
  FinancialDateOfASingleExpense: 'กำหนดวันที่ทางการเงินที่คุณต้องการแก้ไขค่าธรรมเนียมครั้งเดียว?',
  ExpenseFinancialDateModifiedSuccessfully: 'ค่าธรรมเนียม วันที่ทางการเงิน แก้ไขสำเร็จ',
  ModifyTheFinancialDate: 'แน่ใจหรือไม่ว่าคุณต้องการแก้ไขวันที่ทางการเงิน',
  FinancialDateModifiedSuccessfully: 'แก้ไขวันที่ทางการเงินสำเร็จ',
  ApprovalDateIsEarlierThanBusinessDate: 'วันที่ตรวจสอบน้อยกว่าวันที่ทำธุรกิจ จะดำเนินการต่อหรือไม่',
  AreYouSureToReviewTheseLists: 'แน่ใจเหรอว่าจะตรวจสอบรายการเหล่านี้',
  ThisBusinessIsNotApproved: 'ธุรกิจนี้ไม่ใช่สถานะ [{0}] การตรวจสอบไม่ได้รับอนุญาตโปรดตรวจสอบ!',
  ThisBusinessIsNotApproved2: 'ธุรกิจนี้ไม่ใช่สถานะ [{0}] และไม่สามารถถอนได้ โปรดตรวจสอบ!',
  TheDocumentChangeSubmission: 'แน่ใจหรือว่าต้องการถอนการยื่นแก้ไข',
  AllowOrderChange: 'แน่ใจนะว่าต้องการให้เปลี่ยนใบสั่ง?',
  AllowToChangeTheOrderSuccessfully: 'อนุญาตให้เปลี่ยนใบสั่งซื้อได้สำเร็จ',
  NoExpenseSelectedOrNotInApprovalStatus: 'ไม่มีการเลือกค่าธรรมเนียม หรือไม่ตรวจสอบสถานะ',
  ExpenseStatusUpdatedSuccessfully: 'อัพเดทสถานะค่าธรรมเนียมสำเร็จ',
  BusinessHasGeneratedVouchers: 'ธุรกิจได้สร้างบัตรกำนัล',
  UnableCancelAudit: 'ไม่สามารถยกเลิกการทบทวนสิทธิ์ได้',
  BusinessNumberWithGeneratedVouchers: 'หมายเลขธุรกิจที่มีบัตรกำนัลที่สร้างขึ้น:',
  AreYouSureYouWantToCancelTheApproval: 'แน่ใจนะว่าต้องการยกเลิกการตรวจสอบ?',
  LCLTicketsCannotBeReviewedSeparately: 'ตั๋วขนาดเล็ก LCL ไม่สามารถตรวจสอบแยกต่างหากได้ โปรดตรวจสอบตั๋วหลัก',
  ItIsLocked: 'ถูกล็อคและไม่สามารถพิมพ์ได้ติดต่อผู้บังคับบัญชาระดับสูงเพื่อปลดล็อค!',
  PleaseSelectTheBusiness: 'โปรดเลือกธุรกิจที่ต้องการแก้ไขวันประกอบธุรกิจ',
  BusinessDateModifiedSuccessfully: 'การปรับเปลี่ยนวันที่ประกอบธุรกิจประสบความสำเร็จ',
  BatchApprovalFailed: 'การตรวจสอบแบทช์ล้มเหลว',
  PleaseSelectTheBusinessToPrint: 'โปรดเลือกธุรกิจที่คุณต้องการพิมพ์',
  NoInTheSelectedData: 'ข้อมูลที่เลือกมีธุรกิจที่ไม่ใช่สถานะ 【{0}】 การตรวจสอบไม่ได้รับอนุญาตโปรดตรวจสอบ!',
  TheApprovalDateIsEarlierThanTheBusinessDate: 'วันที่ตรวจสอบน้อยกว่าวันที่ทำธุรกิจ จะดำเนินการต่อหรือไม่',
  FailedToGetDetails: 'ล้มเหลวในการรับรายละเอียด',
  PleaseEnterTheBoxSealNumber: 'โปรดพิมพ์ตารางวิเคราะห์กำไรหลังจากป้อนหมายเลขซีลกล่อง',
  AfterPrintingTheProfitAnalysisStatement: 'หลังจากพิมพ์ตารางวิเคราะห์กำไรแล้ว ธุรกิจนี้จะส่งผลสอบทานทางการเงินและไม่สามารถเปลี่ยนแปลงได้อีกต่อไป จะดำเนินการต่อหรือไม่',
  PleaseEnterTheApprovalDate: 'โปรดป้อนวันที่ตรวจสอบ',
  PleaseSelectARecordToView: 'โปรดเลือกระเบียนเพื่อดู',
  ContractExpireCannotCreated: 'สัญญาของหน่วยงานที่ได้รับมอบหมายนี้หมดอายุและไม่สามารถสร้างธุรกิจได้อีก',
  CheckBusinessStatus: 'การดำเนินการล้มเหลวโปรดตรวจสอบสถานะที่สอดคล้องกับธุรกิจว่าปกติหรือไม่',
  CheckCustomsSaved: 'กรุณาบันทึกข้อมูลประกาศศุลกากรก่อนแล้วอัพโหลดข้อมูลประกาศศุลกากร!',
  SelectCustomsBroker: 'กรุณาเลือกตัวแทนออกของ',
  SelectCustomsBrokerPlatFormProvider: 'คุณไม่ได้อยู่ในหุ้นส่วนกำหนดค่า "ผู้ให้บริการแพลตฟอร์ม" ให้กับตัวแทนออกของที่เลือกไว้ในปัจจุบันและไม่สามารถส่งได้',
  SelectCustomsSonoLobFiles: 'หมายเลขใบขนสินค้า" ตัวแทนออกของ เอกสารใบขนสินค้า ประเภทธุรกิจ ต้องไม่ว่างเปล่า กรุณาตรวจสอบข้อมูล',
  VesselAndvVoyageFlightisEmpty: 'ชื่อเรือเดินทางว่างเปล่าโปรดถามว่าคุณแน่ใจที่จะส่ง',
  customsInfoIsAlredySend: 'ใบประกาศศุลกากรนี้ถูกส่งไปแล้วรองรับการส่งชั่วคราวหนึ่งครั้งหากต้องการแก้ไขโปรดติดต่อตัวแทนออกของที่เกี่ยวข้อง',
  DocumentEditedTips: 'คุณไม่ใช่เอกสารของตั๋วและไม่สามารถแก้ไขได้',
  CustomerTipMessage: '【{0}】 ไม่ใช่หน่วยที่ได้รับมอบหมายโปรดเลือกใหม่!',
  PortOfLoadingPortCannotBeNull: 'พอร์ตของการโหลดไม่สามารถว่างเปล่า',
  PromissoryNoteIsAFormalBusiness: 'ตั๋วสัญญาใช้เงินเป็นธุรกิจอย่างเป็นทางการ!',
  CannotBeConvertedToFormalBusinessInBatch: 'มีข้อมูลว่าแหล่งที่มาของธุรกิจคือ "ธุรกิจของตนเองภายในผู้เช่า" ซึ่งไม่สามารถประมวลผลเป็นกลุ่มเพื่อเปลี่ยนเป็นธุรกิจอย่างเป็นทางการได้',
  whetherToTransferSmallTicketToFormalBusinessAtTheSameTime: 'มีการโอนสลากใบเล็กไปทำธุรกิจอย่างเป็นทางการพร้อมกันหรือไม่',
  transferSmallTicketToFormalJobAtTheSameTime: 'ตั๋วใบเล็กโอนกิจการอย่างเป็นทางการพร้อมกัน',
  onlyTheMasterTicketIsTransferredToFormalJob: 'บัตรหลักเพื่อธุรกิจทางการเท่านั้น',
  pleaseTransferTheCorrespondingMasterTicketToFormalJobFirst: 'กรุณาโอนตั๋วหลักไปยังธุรกิจอย่างเป็นทางการก่อน!',
  BusinessCannotBeOperatedTogether: 'ธุรกิจปกติไม่สามารถทำงานร่วมกับธุรกิจที่ได้รับมอบหมายโปรดเลือกใหม่!',
  PleaseEnterTheWarehouseNumber: 'ดึงข้อมูลได้อย่างรวดเร็ว: หมายเลขสถานะขาเข้า',
  BookingSeal: 'บทการจองห้องพัก',
  CheckSplitCharges: 'ค่าธรรมเนียมได้ทำการแยกโปรดลบค่าธรรมเนียมการแยกก่อน',
  mutualChargeSynchronizationSuccess: 'การซิงค์ค่าธรรมเนียมข้ามค่าคอมมิชชั่นสำเร็จ!',
  mutualChargeSynchronizationFault: 'การซิงค์ค่าธรรมเนียมข้ามค่าคอมมิชชั่นล้มเหลว!',
  confirmQuit: 'แน่ใจเหรอว่าเลิก?',
  SelectMBL: 'หมายเลขใบตราส่งสินค้า (Bill Sign - MB/L NO)',
  SelectMBLSI: 'หมายเลขหลัก (การดำเนินการนำเข้า - หมายเลขหลัก) ไม่สามารถว่างเปล่าได้',
  SelectMBLAE: 'หมายเลขหลัก (หมายเลขพื้นฐาน - หมายเลขหลัก) ไม่สามารถว่างได้',
  SelectMBLAI: 'หมายเลขหลัก (การดำเนินการทางอากาศ - หมายเลขหลัก) ไม่สามารถเว้นว่างได้',
  SelectLob: 'กรุณาเลือกประเภทของธุรกิจ',
  SelectPreCustomsDate: 'โปรดเลือกวันที่ปิดคาดการณ์',
  SelectHarborDistrictSe: 'เขตมินาโตะ (ลงชื่อจองห้องโดยสาร - เขตมินาโตะ) ไม่สามารถเว้นว่างได้',
  SelectHarborDistrictSi: 'เขตท่าเรือ (การดำเนินการนำเข้า - เขตท่าเรือ) ไม่สามารถเว้นว่างได้',
  DestinationPlaceNotNull: 'สถานที่จัดส่ง (การดำเนินการนำเข้า - สถานที่จัดส่ง) ไม่สามารถว่างเปล่า!',
  AirportPortNotNull: 'ท่าเรือสนามบินไม่สามารถว่างได้',
  ExpectedDateOfArrivalNotNull: 'วันที่คาดว่าจะมาถึง (การดำเนินการนำเข้า - วันที่มาถึง) ไม่สามารถว่างเปล่า!',
  SelectCustomsFiles: 'กรุณาเลือกข้อมูลพิธีการศุลกากร',
  CustomsHasBeanSend: 'ประกาศศุลกากรนี้ถูกส่งไปแล้วรองรับการส่งชั่วคราวหนึ่งครั้งหากต้องการแก้ไขโปรดติดต่อตัวแทนศุลกากรที่เกี่ยวข้อง',
  FileSizeExceeds4MBYouCannotUploadPleaseSendEmailSe: 'ไฟล์เดียวไม่เกิน 20 เมตรโปรดส่งอีเมลออฟไลน์ไปที่ xh08@thecustoms.com.cn กล่องจดหมาย',
  PleaseUploadFileSeaExport: 'โปรดอัปโหลดเอกสารเช่นหนังสือมอบอำนาจประกาศศุลกากรข้อมูลห้องโดยสารร่างประกาศศุลกากรส่งออกและองค์ประกอบของการประกาศสินค้าใบแจ้งหนี้รายการกล่องและอื่น ๆ',
  PleaseUploadFileSeaImport: 'โปรดอัปโหลดเอกสารเช่นหนังสือมอบอำนาจการประกาศศุลกากรใบตราส่งสินค้าทางทะเล FCL ข้อมูลใบรับสินค้าหรือสำเนาใบแจ้งหนี้รายการกล่องสัญญาใบรับรองแหล่งกำเนิดสินค้าองค์ประกอบการประกาศสินค้า ฯลฯ',
  PleaseUploadFileAirExport: 'โปรดอัปโหลดเอกสารเช่นใบมอบอำนาจประกาศศุลกากรใบนำส่งสินค้าใบหญ้าใบประกาศศุลกากรส่งออก ฯลฯ',
  PleaseUploadFileAirImport: 'โปรดอัปโหลดเอกสารเช่นหนังสือมอบอำนาจประกาศศุลกากร, หนังสือแจ้งการมาถึง, ใบตราส่งสินค้าทางอากาศ, ใบแจ้งหนี้, รายการกล่อง, สัญญา, ใบรับรองแหล่งกำเนิดสินค้า, องค์ประกอบของการประกาศสินค้า ฯลฯ',
  SuccessfulCustoms: 'ประกาศศุลกากรสำเร็จ!',
  FaildCustoms: 'คำขอประกาศศุลกากรล้มเหลวโปรดติดต่อผู้ดูแลระบบ!',
  AsyncReceivableChargesToImportJob: 'ค่าใช้จ่ายของลูกหนี้ทั้งหมดจะประสานไปยังธุรกิจนำเข้า ยืนยันจะดำเนินการต่อหรือไม่',
  AsyncPayableChargesToImportJob: 'ค่าใช้จ่ายที่ต้องชำระทั้งหมดจะประสานไปยังธุรกิจนำเข้า,ยืนยันจะดำเนินการต่อหรือไม่',
  escnm2: 'ฝ่ายชำระค่าธรรมเนียมไม่สามารถเว้นว่างได้',
  SelectMoreTwoRow: 'โปรดเลือกอย่างน้อยสองข้อมูลเพื่อรวมกัน!',
  OnlySplitMasterJob: 'สามารถแยกตั๋วหลักเท่านั้น!',
  SplitJobTip: 'โปรดติ๊กตั๋วหลักที่ประเภทการสะกดทั้งหมดเป็น Buyer Console FCL และสถานะทางธุรกิจเป็นบวกเพื่อแยก!',
  CombinationJobSelectMasterTip: 'คุณแน่ใจหรือไม่ที่จะรวมธุรกิจต่อไปนี้เข้าด้วยกันโปรดเลือก One Vote Business เป็นตั๋วหลัก?',
  CombinationJobForFcl: 'ประเภทแพ็กเกจทั้งหมดคือ FCL และ Buyer Console FCL',
  CombinationJobForJobState: 'สถานะธุรกิจเป็นบวก',
  CombinationJobForCustomer: 'หน่วยที่ได้รับมอบหมายสอดคล้องกัน',
  CombinationJobForVessel: 'ชื่อเรือที่สอดคล้องกัน',
  CombinationJobForVesselVoyage: 'การเดินทางสอดคล้อง',
  CombinationJobForMaster: 'กรุณาเลือกบัตรหลัก!',
  CombinationJobTip: 'โปรดเลือกธุรกิจ {0} เพื่อดำเนินการ!',
  ValidateCombinationJobTip: 'ธุรกิจที่มีหมายเลข B / L {0} ถูกนำมาใช้แล้วโปรดคลิกที่ปุ่มยกเลิกเพื่อดำเนินการรวมกันอีกครั้ง!',
  OnlyJoinForCombinationJob: 'อนุญาตให้เข้าร่วมธุรกิจประเภท FCL และ Buyer Console FCL เท่านั้น!',
  TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue: 'การออกใบแจ้งหนี้ไม่สอดคล้องกันและจะดําเนินการต่อหรือไม่',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue2: 'ชื่อเรือของตั๋วโดยสารขนาดเล็กที่เลือกใหม่, เที่ยวบิน, ผู้ให้บริการ, ตัวแทนการจอง, ตัวแทนท่าเรือปลายทาง, ETD、ETA、 ข้อมูลคลังสินค้า หมายเลขสัญญาของบริษัทเรือไม่ตรงกับตั๋วหลัก ระบบจะแก้ไขสลากเล็ก จะดำเนินการต่อหรือไม่',
  HblNoMoreThanTwelve: 'หมายเลขย่อยต้องไม่เกิน 12 หลัก!',
  WriteOffPushSuccess: 'การผลักดันบันทึกการขายนิวเคลียร์ประสบความสำเร็จ!',
  WriteOffPushError: 'การผลักดันบันทึกการชำระเงินล้มเหลว!',
  CancelConfirmBill: 'ยืนยันสถานะการยกเลิกค่าธรรมเนียมพร้อมกันหรือไม่?',
  AreYouSureYouWantToDeleteTheSelectedFee: 'ยืนยันการลบค่าธรรมเนียมที่เลือกไว้หรือไม่?',
  JobOfClosingAccountTip: 'วันที่ธุรกิจไม่สามารถบันทึกได้โปรดบันทึกหลังจากปรับ!',
  ThePacketHasBeenSentAndWhetherToImportItAgain: 'เคยส่งเอกสารไปแล้วจะนำเข้าอีกหรือไม่',
  PleaseCheckAtLeastOnePieceOfData: 'กรุณาเลือกข้อมูลอย่างน้อยหนึ่งรายการ',
  NoHasViewRole: 'ไม่มีสิทธิ์ในการดูโปรดติดต่อผู้ดูแลระบบเพื่อกำหนดค่า!',
  NoHasViewBillingRole: 'ไม่มีสิทธิ์ในการตรวจสอบการเรียกเก็บเงินโปรดติดต่อผู้ดูแลระบบเพื่อกำหนดค่า!',
  NoHasViewBillingGroupRole: 'ไม่มีสิทธิ์ดูรายการบัญชีโปรดติดต่อผู้ดูแลระบบเพื่อกำหนดค่า!',
  checkSpecialChargeTips: 'บัตรกำนัลที่มีค่าธรรมเนียมพิเศษในบันทึกการขายไม่สามารถสร้างขึ้นโปรดเลือกอีกครั้ง!',
  CheckCustomJobTypeTips: 'โปรดเลือกประเภทธุรกิจที่กำหนดเองและบันทึกอีกครั้ง!',
  AMSCodeCannotBeNull: 'การกำหนดค่าพื้นฐาน AMSCompanyCode ไม่สามารถว่างเปล่า!',
  MblNoIsOverLength: '【MB/L NO】 ฟิลด์มากกว่า 16 บิต',
  AmsNoIsOverLength: '【AMS NO】 ฟิลด์มากกว่า 12 บิต',
  IsOverLengthTip: '{0} อักขระยาวเป็นพิเศษข้อมูลแต่ละบรรทัดต้องไม่เกิน {1} อักขระ',
  UnitTypeNotNull: 'ประเภท Unit ไม่สามารถว่างได้ โปรดป้อน',
  Shipper: 'จัดส่งโดย',
  Consignee: 'ผู้รับสินค้า',
  Notify: 'แจ้งโดย',
  SecondNotify: 'ประกาศฉบับที่ 2',
  SpecialCharacter: '{0} ฟิลด์มีตัวอักษรที่ผิดกฎหมายและไม่สามารถบันทึกได้!',
  TipsOnAutoSplittingCharge: 'โปรดป้อนราคารวมภาษีสำหรับค่าธรรมเนียมการแยกออนไลน์!',
  DeleteSmallTicketTips: 'คุณไม่มีสิทธิ์ลบตั๋วขนาดเล็ก!',
  SyncToSmallTicketSuccessTips: '{0} สถานะโหนดถูกซิงค์กับตั๋วขนาดเล็ก!',
  OperationTypeInUsed: '{0} {1} มีเงื่อนไขการจัดส่ง {2} ที่แสดงโดยค่าเริ่มต้นโปรดเลือกใหม่!',
  StartUpdatingTheBasicData: 'เริ่มต้นการอัพเดทข้อมูลพื้นฐาน',
  BasicDataUpdateSuccessfully: 'อัพเดทข้อมูลพื้นฐานสำเร็จ',
  BatchSubmitCheck: 'สามารถส่งรายการที่มีการดำเนินงานในเชิงบวกหรือการส่งล่วงหน้าเป็นกลุ่มเท่านั้น!',
  isExistHBLANDMBLTips: 'หมายเลขแยกย่อยภายใต้หมายเลขหลักเดียวไม่ได้รับอนุญาตให้ทำซ้ำโปรดป้อนหมายเลขแยกย่อยอีกครั้ง!',
  operateTypeUpdateTips: 'เปลี่ยนโหมดการทำงาน ไม่ว่าจะเป็นการอัพเดตข้อมูลการรับส่ง MAWB',
  SettlingAgentInconsistent: 'ตัวแทนการตั้งถิ่นฐานไม่สอดคล้องกัน จะดำเนินการต่อหรือไม่',
  SettlingAgentInvoiceTitleInconsistent: 'ทั้งตัวแทนการชำระบัญชีและการเรียกเก็บเงินไม่สอดคล้องกัน จะดําเนินการต่อหรือไม่',
  ChargeEmpty: 'ค่าธรรมเนียมว่างเปล่า!',
  NoChargeForTheSettlementOfPrint: 'ไม่มีวัตถุการชำระเงินค่าธรรมเนียมที่ตรงตามเงื่อนไขการพิมพ์',
  PleaseEnterTheCreationDate: 'โปรดป้อนวันที่สร้าง',
  SelectDate: 'เลือกวันที่',
  DefaultCurrency: 'สกุลเงินปริยาย',
  EDISUBMISSIONCenter: 'ศูนย์รับ-ส่ง EDI',
  EDICenter: 'ศูนย์ EDI',
  MessagePreview: 'ตัวอย่างหนังสือพิมพ์',
  MessageDesign: 'การออกแบบหนังสือพิมพ์',
  ReceiverCodeCannotBeEmpty: 'รหัสผู้รับต้องไม่ว่างเปล่า',
  SelectEDIType: 'เลือกประเภท EDI',
  NotConfigured: 'ไม่มีการกำหนดค่า',
  SelectSendingChannel: 'เลือกช่องทางการส่ง',
  SelectFileNature: 'เลือกคุณสมบัติของแฟ้ม',
  SelectFileTemplate: 'เลือกแม่แบบแฟ้ม',
  SelectedBusiness: 'ธุรกิจที่เลือก:',
  BackToEDICenter: 'กลับไปที่ศูนย์ EDI',
  Design: 'การออกแบบ',
  SendAll: 'ส่งทั้งหมด',
  Tips: 'เคล็ดลับ:',
  UsedInTemplateDesign: 'ใช้ในการออกแบบเทมเพลต',
  Check: 'ทำการตรวจสอบ',
  SentSuccessfully: 'ส่งสำเร็จ!!',
  TemplateSavedSuccessfully: 'เทมเพลตการบันทึกสำเร็จ',
  OtherDocuments: 'เอกสารอื่นๆ',
  ClickUpload: 'คลิกเพื่ออัพโหลด',
  UnsupportedFileType: 'ประเภทไฟล์ที่ไม่รองรับ',
  TheSizeExceedsTheLimit: 'ขนาดไฟล์เกินขีดจำกัด',
  UploadFailed2: 'อัปโหลดล้มเหลว',
  PleaseSelectABusinessNumber: 'กรุณาเลือกหมายเลขธุรกิจ',
  TheExceeds20MBAndUploaded: '1 ไฟล์มีปริมาณมากกว่า 20 MB และไม่สามารถอัปโหลดได้',
  UploadPleaseContactTheAdministrator: 'อัปโหลดไม่สำเร็จ โปรดติดต่อผู้ดูแลระบบ',
  FailedPleaseRefreshAndAgain: 'การรับข้อมูลล้มเหลวโปรดลองอีกครั้งหลังจากรีเฟรช',
  ExternalImportedDataNonEditable: 'ข้อมูลที่นำเข้าจากภายนอกไม่สามารถแก้ไขได้',
  ExternalDataCannotBeDeleted: 'ข้อมูลนำเข้าจากภายนอกไม่สามารถลบได้',
  RequestSucceededExporting: 'คำขอสำเร็จกำลังส่งออก!',
  Main: 'หลัก',
  PleaseEnterTheWarehousingNumber: 'โปรดป้อนหมายเลขสถานะขาเข้า!',
  PleaseEnterTheWarehouseName: 'กรุณาใส่ชื่อคลังสินค้า!',
  PleaseEnterTheWarehouseInDate: 'โปรดเลือกเวลาเข้าคลังสินค้า!',
  PleaseMaintainWeighDetail: 'โปรดรักษารายละเอียดการชั่งน้ำหนัก (จริง) ของสินค้าก่อน!',
  PleaseEnterComments: 'ผลลัพธ์ของรายการนิวเคลียร์ไม่ผ่านโปรดกรอกความคิดเห็นในการประมวลผล!',
  PleaseSelectTheClosingWeight: 'กรุณาเลือกน้ำหนักการปิดผนึก!',
  SureToSaveLabeling: 'ยังไม่ได้ชั่งน้ำหนัก,ยืนยันว่าจะบันทึกข้อมูลการติดฉลากหรือไม่',
  PleaseLengthWidthPieces: 'โปรดป้อนขนาดในรูปแบบที่ถูกต้อง: L * W * H * จำนวนชิ้น!',
  PleaseTheNumberOfPieces: 'กรุณาใส่จำนวนชิ้น!',
  WarehouseNumberAlreadyExistsContinue: 'มีหมายเลข Position อยู่แล้วว่าจะดำเนินการต่อหรือไม่',
  SavedSuccessfully: 'บันทึกความสำเร็จ!',
  ChecklistSuccessfully: 'อัปเดตสถานะ Nuclear Single สำเร็จแล้ว!',
  NoSynchronizationContent: 'ไม่มีการซิงค์เนื้อหาในขณะนี้',
  ThereSynchronizationSpecialGoodsSynchronize: 'ข้อมูลบรรจุภัณฑ์มีกล่องที่เชื่อมโยงกับสินค้าพิเศษหลังจากการซิงค์สินค้าพิเศษจำเป็นต้องเชื่อมโยงใหม่หรือยืนยันการซิงโครไนซ์?',
  SynchronizationSucceeded: 'ซิงค์สำเร็จ',
  SynchronizationFail: 'ซิงค์ล้มเหลว',
  ThisJobIsNotWorkingCanNotBeEdited2: 'ระบุว่าธุรกิจไม่ใช่สถานะการทำงานเชิงบวกและไม่สามารถทำการซิงโครไนซ์ได้',
  ASameBoxTypeExists: 'มีบันทึกของกล่องชนิดเดียวกันอยู่แล้ว!',
  IfToRefreshTheContainers: 'จำนวนกล่องมีการเปลี่ยนแปลง รีเฟรชค่าธรรมเนียมเดิมตามจำนวนกล่องหรือไม่?',
  BusinessCannotBeEmpty: 'ธุรกิจไม่สามารถว่างเปล่า!',
  ViewChargebackFile: 'ดูเอกสารการคืนเงิน',
  SelectDepartment: 'เลือกแผนก',
  PleaseSelectADepartment: 'กรุณาเลือกแผนก!',
  ReceiptSucceeded: 'การตอบกลับประสบความสำเร็จ',
  ReceiptError: 'การตอบกลับผิดพลาด',
  SubmittedForDeletion: 'ส่งลบและแก้ไขแล้ว',
  ModificationFailed: 'การแก้ไขล้มเหลว',
  EDIStatusChangeRecord: 'บันทึกการเปลี่ยนแปลงสถานะ EDI',
  FeedbackNode: 'โหนดข้อเสนอแนะ',
  YouTheLinkAddressDirectly: 'คัดลอกที่อยู่เชื่อมโยงโดยตรงสามารถจับคู่',
  HistoricalAnomaly: 'ความผิดปกติทางประวัติศาสตร์',
  TimeOfOccurrence: 'เวลาเกิดขึ้น',
  VerificationOfEstimatedProfitMargin: 'การตรวจสอบอัตรากำไรโดยประมาณ',
  EstimatedIncome: 'รายได้โดยประมาณ',
  EquivalentToRMB: 'เป็น CNY',
  EstimatedCost: 'ค่าใช้จ่ายโดยประมาณ',
  EstimatedProfit: 'กำไรโดยประมาณ:',
  EstimatedProfitMargin: 'อัตรากำไรโดยประมาณ:',
  EstimatedRemarks: 'หมายเหตุโดยประมาณ:',
  EstimatedMustBeFilledIn: 'หมายเหตุโดยประมาณต้องกรอก',
  Sunday: 'วันอาทิตย์',
  Monday: 'วันจันทร์',
  Tuesday: 'วันอังคาร',
  Wednesday: 'วันพุธ',
  Thursday: 'วันพฤหัสบดี',
  Friday: 'วันศุกร์',
  Saturday: 'วันเสาร์',
  SelectFileType: 'เลือกประเภทไฟล์',
  FileInformation: 'ข้อมูลเอกสาร',
  Thumbnail: 'ภาพตัวอย่าง',
  DownloadPhotos: 'ดาวน์โหลดรูปภาพ',
  UploadComplete: 'อัพโหลดเสร็จแล้ว!',
  UploadFailedSigh: 'อัปโหลดล้มเหลว!',
  HelloNNPleaseCheck: 'สวัสดีค่ะ กรุณาตรวจสอบ',
  WarehousingNo: 'หมายเลขสถานะขาเข้า -',
  WarehousingNoColon: 'หมายเลขรายการคือ:',
  PhotosNthankYouN: 'รูปถ่าย \#n\#n ขอบคุณ \#n\#n',
  SendingSucceeded: 'ส่งเรียบร้อยแล้ว!',
  SendingFailed: 'ส่งล้มเหลว!',
  PleaseTheFileToDownload: 'โปรดเลือกไฟล์ที่ต้องการดาวน์โหลด',
  WaybillNo: 'หมายเลขใบนำส่งคือ',
  ConfirmSending: 'ระบุส่ง',
  ReturnToModify: 'กลับไปแก้ไข',
  ChannelName: 'ชื่อช่อง',
  PleaseSelectASendingChannel: 'โปรดเลือกช่องทางการส่ง!',
  FailedToGetTemplate: 'การรับเทมเพลตล้มเหลว',
  TheDocumentOfTheContinue: 'เลือกเที่ยวบินชื่อเรือของตั๋วขนาดเล็กใหม่, บริษัท เรือ, หมายเลขเดี่ยวหลัก, ตัวแทนการแลกเปลี่ยนตั๋ว, วันที่ออกเดินทาง, วันที่มาถึงโดยประมาณ, วันที่มาถึงจริง, คลังสินค้า, วิธีการจัดจำหน่ายหลักและเงื่อนไขการขนส่งสินค้าหลักไม่สอดคล้องกับตั๋วหลัก; หรือ Small Ticket ศุลกากรว่างเปล่า \#r\#n ระบบจะแก้ไขตั๋วขนาดเล็ก จะดำเนินการต่อหรือไม่',
  PleaseSelectACodingRule: 'โปรดเลือกกฎการเข้ารหัส',
  ApplicationForRelease: 'ใบสมัคร สำหรับการวางห้องโดยสาร',
  ApplyForShipperCode: 'สมัคร SHIPPER CODE',
  NoDataSelected: 'ข้อมูลยังไม่ได้รับการตรวจสอบ!',
  InvalidFee: 'ค่าธรรมเนียมไม่ถูกต้อง!',
  ReceivingMethod: 'วิธีการรับ:',
  CellPhoneNumber: 'หมายเลขโทรศัพท์มือถือ:',
  NoteDoesNotAffectPartner: 'หมายเหตุ: ข้อมูลที่แก้ไขในหน้านี้จะไม่ส่งผลกระทบต่อการกำหนดค่าเดิมของพันธมิตร',
  emptySopNodeWarning: 'โหนดผลักดันว่างเปล่าจะไม่สามารถผลักดันข้อความได้อย่างถูกต้อง',
  AsynchronousLocking: 'แผ่นล็อคแบบอะซิงโครนัสอยู่ในพื้นหลังซึ่งสามารถไปที่มุมขวาบน (ข้อความ) เพื่อดูผลลัพธ์ในภายหลัง',
  AsynchronousJobAccountVerify: 'การประมวลผลแบบอะซิงโครนัสในพื้นหลังซึ่งสามารถไปที่มุมขวาบน (ข้อความ) เพื่อดูผลลัพธ์ในภายหลัง',
  RepeatClick: 'พื้นหลังกำลังทำงานแบบล็อคเดียวอย่าคลิกซ้ำ',
  RepeatClickJobAccountVerify: 'พื้นหลังกำลังทำการตรวจสอบอย่าคลิกซ้ำ',
  RepeatClickJobAccountVerify2: 'Back Office กำลังทำการยกเลิกการตรวจสอบอย่าคลิกซ้ำ',
  AddFromPartner: 'เพิ่มจากพาร์ทเนอร์',
  AddManually: 'เพิ่มด้วยตนเอง',
  ReceivingMode: 'วิธีการรับ',
  PushNodeCannotBeEmpty: 'โหนดผลักดันไม่สามารถว่างเปล่า!',
  PushBeEmptyPleaseCheck: 'โหนดผลักดันไม่สามารถว่างเปล่าโปรดตรวจสอบ:',
  DetailedNumberOfCheckedGoods: 'จำนวนชิ้นรายละเอียดของสินค้าที่ถูกเลือก',
  NumberAssociatedPackingInformationPieces: 'ข้อมูล Cartoning ที่เกี่ยวข้อง จำนวนชิ้น',
  DetailedWeightOfGoodsChecked: 'รายละเอียดน้ำหนักของสินค้าที่ติ๊ก',
  AssociatedPackingInformationWeight: 'ข้อมูล Cartoning ที่เกี่ยวข้อง น้ำหนัก',
  DetailedVolumeOfGoodsChecked: 'ปริมาตรของสินค้าที่ติ๊ก',
  AssociatedPackingInformationVolume: 'ข้อมูล Cartoning ที่เกี่ยวข้อง ปริมาณ',
  CopyShippingMarkAndName: 'คัดลอกจากชื่อเครื่องหมายการจัดส่งที่ได้รับมอบหมาย',
  OperationCategory: 'หมวดหมู่การดำเนินงาน',
  PleaseEnterTheBusinessNumber: 'กรุณากรอกหมายเลขธุรกิจ',
  NonExistent: 'ไม่มีตัวตน',
  ContainerTip: 'กรณีนี้มีความสัมพันธ์กับค่าธรรมเนียมแล้ว โปรดยกเลิกการเชื่อมโยงก่อนแล้วจึงแก้ไขหมายเลขกล่อง',
  UploadCustomsDeclarationFile: 'อัปโหลดเอกสารประกาศศุลกากร',
  UploadChargebackFile: 'อัปโหลดไฟล์การคืนเงิน',
  RevenueTypeCannotBeBlank: '【ประเภทรายรับและรายจ่าย】 ไม่สามารถว่างเปล่า!',
  SettlementCompanyCannotBeBlank: '【หน่วยการชำระเงิน】 ไม่สามารถว่างเปล่า!',
  IncorrectFormatOnlyIntegerSupported: 'รูปแบบข้อมูลอัตราภาษีไม่ถูกต้องและรองรับเฉพาะจำนวนเต็ม!',
  domesticForeignCannotBeEmpty: '【ทั้งในและต่างประเทศ】 ไม่สามารถว่างเปล่า!',
  ImportResults: 'นำเข้าผลลัพธ์',
  AllSuccess: 'ความสำเร็จทั้งหมด',
  AllFailed: 'ล้มเหลวทั้งหมด',
  PartialFailurePartialSuccess: 'ล้มเหลวบางส่วน ประสบความสำเร็จบางส่วน',
  OddNumbers: 'หมายเลขเดี่ยว',
  PleaseTheSameBusinessOperate: 'โปรดเลือกธุรกิจประเภทเดียวกันเพื่อดำเนินการ!',
  OperationError: 'การดำเนินการผิดพลาด',
  NewBusiness: 'ธุรกิจใหม่',
  ThePleaseRefreshAndAgain: 'ระบบไม่ว่างโปรดรีเฟรชและลองอีกครั้ง',
  SubmittersRemarks: 'หมายเหตุผู้เขียน',
  PleaseFillInTheRemarks: 'กรุณากรอกหมายเหตุ',
  YouAreNotTheSubmitter: 'ไม่ใช่ผู้บังคับบัญชาที่เหนือกว่าของผู้เขียนไม่สามารถดำเนินธุรกิจนี้ได้!',
  PleaseFillInTheRemarksSigh: 'กรุณากรอกข้อมูลในหมายเหตุ!',
  PleaseEnterRemarks: 'กรุณากรอกข้อมูลหมายเหตุ!',
  TheTheCurrentOperationMaintenance: 'การดำเนินงานปัจจุบันไม่มีการบำรุงรักษาผู้บังคับบัญชาระดับสูงโปรดบำรุงรักษาก่อนที่จะส่งธุรกิจนี้!',
  FailedForApprovalPleaseAgain: 'ส่งการตรวจสอบหัวหน้างานล้มเหลว โปรดรีเฟรชให้ลองอีกครั้ง!',
  SubmittedSupervisorForApprovalSuccessfully: 'ส่งให้ผู้บังคับบัญชาตรวจสอบความสำเร็จ',
  ApprovedPass: 'การตรวจสอบตกลง!',
  ApprovalRejected: 'การตรวจสอบถูกปฏิเสธ!',
  Problem: 'คำถาม',
  Synchronized: 'ซิงค์แล้ว',
  NotSynchronized: 'ไม่ได้ซิงค์',
  YouToEditTheAdministrator: 'คุณไม่มีสิทธิ์แก้ไขข้อมูล โปรดติดต่อผู้ดูแลระบบ',
  SentOut: 'ส่งไปแล้ว!',
  DefaultPSettlementID: 'รหัสวัตถุเจ้าหนี้คงที่ปริยาย',
  IsAREmpty: 'วัตถุที่รับโดยปริยายว่างอยู่หรือไม่',
  IsAPEmpty: 'วัตถุเจ้าหนี้ปริยายว่างเปล่าหรือไม่',
  TheFormCannotBeEmpty: 'ประกาศศุลกากรไม่สามารถว่างเปล่า!',
  ReminderOfTheCustomsData: 'คำเตือน: กรุณาคลิกที่ OK เพื่อบันทึกข้อมูลที่จำเป็นในการประกาศศุลกากรก่อนที่จะอัพโหลดข้อมูล',
  ReminderOfTheCustomsPrint: 'คำเตือน: ข้อมูลต่อไปนี้จะไม่ผลักดันตัวแทนศุลกากร แต่เพียงผู้เดียวสำหรับการพิมพ์แหล่งข้อมูลเอกสาร',
  ObtainActualBusinessData: 'รับธุรกิจจริง',
  TheToBeViewedAnyone: 'ไฟล์ไม่อนุญาตให้ใครดูหรือดาวน์โหลด',
  YouPermissionToViewDownload: 'คุณไม่มีสิทธิ์ที่จะดูหรือดาวน์โหลด',
  File: 'แฟ้ม',
  PleaseInTheSubmissionNotes: 'กรุณากรอกข้อมูลในการส่งหมายเหตุ',
  ContainsInvoicesThatCannotBeModified: 'มีใบแจ้งหนี้ที่ไม่สามารถแก้ไขได้',
  RemarksReviewedBy: 'หมายเหตุจากผู้ตรวจสอบ',
  numberingRuleCannotBeEmpty: '【กฎหมายเลข】 ไม่สามารถว่างเปล่า!',
  PortAreaDataComparison: 'การเปรียบเทียบข้อมูลในเขตท่าเรือ',
  ImportMode: 'วิธีการนำเข้า',
  Keep: 'รักษาไว้',
  Explain: 'คำอธิบาย:',
  BlackIsTheInputData: 'สีดำ สำหรับข้อมูลขาเข้า',
  BlueThePortAreaData: 'สีน้ำเงินสำหรับข้อมูลเขตท่าเรือ',
  GrayIsPreEnteredData: 'สีเทาเป็นข้อมูลที่ป้อนไว้ล่วงหน้า',
  UpdatedToPortAreaData: 'อัปเดตเป็นข้อมูลเขตท่าเรือ',
  lclCompareHarbourTips1: '1. เขียนทับทั้งหมดโดยค่าเริ่มต้น ("ข้อมูลของเขตท่าเรือ" ครอบคลุมข้อมูล "รายการระบบ" ทั้งหมด) ไม่ติ๊กเพื่อรักษาข้อมูลระบบข้อมูลของเขตท่าเรือจะไม่ครอบคลุม; ยกเลิกการติ๊กทั้งหมดจากนั้นข้อมูลระบบเดิมจะถูกเก็บไว้',
  lclCompareHarbourTips2: '2. สีแดงหมายถึงข้อมูลที่ไม่ตรงกันระหว่าง "ข้อมูลระบบ" และ "ข้อมูลเขตท่าเรือ"',
  lclCompareHarbourTips3: 'โปรดยืนยันข้อมูลการบรรจุที่ถูกต้องโดยเร็วที่สุดมันจะส่งผลกระทบต่อ SOP ที่ตามมาเช่นเดียวกับกล่องข้อมูลการเตือนภัยล่วงหน้าผลักดันการแสดงผล',
  UpdatedData: 'อัพเดทข้อมูล',
  compareHarbourTips1: '1. การเขียนทับทั้งหมดโดยค่าเริ่มต้น (ข้อมูลในพื้นที่ท่าเรือครอบคลุมข้อมูลในระบบป้อนข้อมูลทั้งหมด)',
  compareHarbourTips2: '2. คลิกที่หมายเลขกล่องเพื่อสลับเพื่อดูข้อมูลสีแดงหมายถึงข้อมูลที่ไม่สอดคล้องกับ "ข้อมูลระบบ" และ "ข้อมูลเขตท่าเรือ"',
  compareHarbourTips3: '3. ใน 【อื่นๆ】 ไม่ทำเครื่องหมายแล้ว "ข้อมูลระบบ" เก็บข้อมูลกล่องเดิมไม่เปลี่ยนแปลง "ข้อมูลเขตท่าเรือ" จะไม่เพิ่มข้อมูลการบรรจุกล่อง; ไม่ทำเครื่องหมายภายใน 【หมายเลขกล่อง】 ที่สอดคล้องกันแล้ว "ข้อมูลระบบ" จะถูกเก็บไว้; \#n ยกเลิกการติ๊กทั้งหมดจากนั้นข้อมูลระบบเดิมจะถูกเก็บไว้',
  compareHarbourTips4: 'โปรดยืนยันข้อมูลการบรรจุที่ถูกต้องโดยเร็วที่สุดมันจะส่งผลกระทบต่อ SOP ที่ตามมาเช่นเดียวกับกล่องข้อมูลการเตือนภัยล่วงหน้าผลักดันการแสดงผล',
  SystemEntry: 'รายการระบบ',
  PortAreaData: 'ข้อมูลเขตท่าเรือ',
  ImportDescriptions: 'ประเภทการนำเข้ามีการแก้ไขสำหรับระบบตามลำดับตามหมายเลขกล่องประเภทกล่องประเภทกล่องช่วยให้คุณจับคู่กับข้อมูลที่สอดคล้องกับเขตท่าเรือ \#n ประเภทนำเข้าที่เพิ่มเข้ามาใหม่ไม่พบข้อมูลที่สอดคล้องกับข้อมูลของเขตท่าเรือสำหรับระบบ \#n ประเภทการนำเข้าคือการถือครองข้อมูลที่ป้อนสำหรับคุณไม่ตรงกับข้อมูลพอร์ตโซนนั่นคือข้อมูลที่ป้อนต้นฉบับของคุณ',
  WhenTheBoxIsIdentifiedAsABox: 'เมื่อสินค้ากล่องถูกทำเครื่องหมายเป็นกล่องหมายเลขศุลกากรจะไม่ปรากฏขึ้นข้อมูลของชิ้นส่วนของขนเป็นผลรวมของสินค้า',
  ClickEnteredDataPleaseOperation: 'คลิก 【อัปเดตเป็นข้อมูลเขตท่าเรือ】 ระบบจะอัปเดตข้อมูลที่ป้อนโดยระบบเป็นข้อมูลพื้นที่ท่าเรือตามข้อมูลที่ถูกทำเครื่องหมายในขณะที่สีตัวอักษรจะกลายเป็นสีดำโปรดยืนยันข้อมูลพื้นที่ท่าเรือว่าถูกต้องก่อนที่จะดำเนินการ',
  Determine: 'ระบุ',
  Cancel2: 'การยกเลิก',
  PleaseAtLeastOneRecord: 'กรุณาเลือกอย่างน้อยหนึ่งระเบียน!',
  Hello: 'สวัสดี',
  EnclosedPleaseFind: 'กรุณาตรวจสอบ',
  PhotosOf: 'รูปภาพของ',
  ThankYou: 'ขอบคุณ',
  TheAndFreightTermsBlank: 'เลือกเที่ยวบินชื่อเรือของตั๋วขนาดเล็กใหม่, บริษัท เรือ, หมายเลขเดี่ยวหลัก, ตัวแทนการแลกเปลี่ยนตั๋ว, วันที่ออกเดินทาง, วันที่มาถึงโดยประมาณ, วันที่มาถึงจริง, คลังสินค้า, วิธีการจัดจำหน่ายหลักและเงื่อนไขการขนส่งสินค้าหลักไม่สอดคล้องกับตั๋วหลัก; หรือ Small Ticket ศุลกากรว่างเปล่า',
  TheModifyTheSmallContinue: 'ระบบจะแก้ไขสลากเล็ก จะดำเนินการต่อหรือไม่',
  SaveFailedSigh: 'บันทึกล้มเหลว!',
  CellPhoneNumber2: 'หมายเลขโทรศัพท์มือถือ',
  NoSopNodeMatched: 'ไม่ตรงกับโหนดของธุรกิจปัจจุบัน โปรดเลือกอีกครั้ง',
  NameCannotBeEmpty: 'ชื่อไม่สามารถว่าง!',
  PleaseSelectARecord2: 'กรุณาเลือกบันทึก',
  ChangePassword: 'แก้ไขรหัสผ่าน',
  OriginalPassword: 'รหัสผ่านเดิม',
  NewPassword: 'รหัสผ่านใหม่',
  ConfirmPassword: 'ยืนยันรหัสผ่าน',
  ModificationPleaseLogInAgain: 'แก้ไขสำเร็จกรุณาเข้าสู่ระบบอีกครั้ง',
  TheEnteredTwiceAreInconsistent: 'รหัสผ่านที่ป้อนทั้งสองครั้งไม่สอดคล้องกัน',
  DearUser: 'เรียนผู้ใช้:',
  ItSystemInOrderMode: 'ตรวจสอบพบว่าโหมดเบราเซอร์ปัจจุบันของคุณเป็นโหมดที่รองรับ ซึ่งจะส่งผลต่อความเร็วในการทำงานของระบบ CargoWare และเพื่อเพิ่มความเร็วในการทำงานและประสิทธิภาพในการทำงานของระบบ โปรดเปลี่ยนโหมดความเร็วสูงสุด',
  TheShownInTheBelow: 'การดำเนินการที่เฉพาะเจาะจงแสดงในภาพด้านล่าง:',
  ToSwitchTutorialsSee: 'การสลับการสอนโปรดดูที่:',
  GotIt: 'รู้แล้ว',
  FullScreen: 'เต็มหน้าจอ',
  EarlyWarningReminder: 'เตือนภัยล่วงหน้า',
  AnnouncementMessage: 'ข้อความประกาศ',
  Cancellation: 'ออกจากระบบ',
  FlagshipEdition: 'สุดยอด',
  BasicEdition: 'รุ่นพื้นฐาน',
  TrialCustomers: 'ทดลองใช้ลูกค้า',
  FormalCustomer: 'ลูกค้าประจำ',
  SystemAdministrator: 'ผู้ดูแลระบบ',
  RefreshCacheMethod: 'รีเฟรชวิธีการแคช',
  AfterTheCorrespondingCacheData: 'หลังจากดูแลรักษาข้อมูลพื้นฐานแล้ว โปรดอัปเดตแคชที่เกี่ยวข้องเพื่อรับข้อมูลล่าสุด',
  ViewCacheRefreshMethod: 'ดูวิธีการรีเฟรชแคช',
  PleaseExitTheEditingModule: 'โปรดบันทึกข้อมูลที่เปลี่ยนแปลงไว้ก่อนหรือออกจากสถานะการแก้ไขแล้วปิดโมดูล',
  SessionPleaseLogInAgain: 'หมดเวลาการสนทนา กรุณาเข้าสู่ระบบอีกครั้ง',
  EDITemplateExceptionDownloadFailed: 'แม่แบบ edi ผิดปกติการดาวน์โหลดล้มเหลว ...',
  One: 'หนึ่ง',
  Two: 'สอง',
  Three: 'สาม',
  Four: 'สี่',
  Five: 'ห้า',
  Six: 'หก',
  Just: 'เพียงแค่',
  MinutesAgo: 'นาทีที่แล้ว',
  HoursAgo: 'ชั่วโมงที่ผ่านมา',
  OneDayAgo: '1 วันก่อน',
  LastWeek: 'สัปดาห์ที่ผ่านมา',
  LastMonth: 'เดือนล่าสุด',
  LastThreeMonths: 'ในช่วง 3 เดือนที่ผ่านมา',
  PleaseSelectDataFirst: 'โปรดเลือกข้อมูลก่อน',
  SelfBooking: 'จองห้องโดยสารด้วยตนเอง',
  CommissionedBooking: 'การจองห้องโดยสาร',
  CustomerSelfBooking: 'ลูกค้าที่จองห้องโดยสารเอง',
  OwnContractPrice: 'ราคาโดยประมาณของตัวเอง',
  CustomerOffer: 'ลูกค้าประมาณราคา',
  OverseasAgentContractPrice: 'ราคาตัวแทนในต่างประเทศ',
  UncommittedPrice: 'ไม่มีราคา',
  PeerAgreementPrice: 'ราคาโดยประมาณเพื่อน',
  BuyerLCL: 'ซื้อ LCL',
  InnerPacking: 'บรรจุภายในกล่อง,',
  DoorPointPacking: 'ประตูจุดบรรจุกล่อง,',
  SelfPullingAndSelfSending: 'ตนเองดึงตนเอง,',
  DeclareAtCustoms: 'ประกาศศุลกากร',
  Fumigation: 'การรมควัน,',
  CommodityInspection: 'การตรวจสอบสินค้า,',
  BookingSpace: 'จองห้องพัก',
  SetSpell: 'ชุดสะกด',
  PersonalBelongings: 'ของใช้ส่วนตัว',
  OneMasterAndManyPoints: 'หนึ่งมาสเตอร์หลายจุด',
  OneMasterAndOneMinute: 'หนึ่งมาสเตอร์หนึ่งคะแนน',
  UnknownType: 'ไม่ทราบประเภท',
  Marked: 'ทำเครื่องหมายแล้ว',
  Unmark: 'ไม่ทำเครื่องหมาย',
  PendingOrder: 'การสั่งซื้อ',
  OrderPlaced: 'สั่งซื้อแล้ว',
  ReceivedOrder: 'รายการที่ได้รับ',
  NotIssued: 'ยังไม่ได้ออก',
  Issued: 'ออก',
  Retrieved: 'เรียกคืนแล้ว',
  Accepted: 'ได้รับแล้ว',
  Claimed: 'อ้างสิทธิ์',
  ChangeOrder: 'แก้ไขในแผ่น',
  ApprovedBusinessCannotBeEdited: 'ธุรกิจที่ตรวจสอบแล้วไม่สามารถแก้ไขได้',
  OrderAlreadyApproved: 'คำสั่งซื้อ {0} ได้รับการอนุมัติแล้ว',
  YouPermissionToEditNotes: 'ท่านไม่มีสิทธิ์แก้ไขแคชเชียร์เช็ค',
  EnglishNameOfHBLConsignee: 'ชื่อภาษาอังกฤษของผู้รับ HBL',
  EnglishNameOfHBLShipper: 'ชื่อภาษาอังกฤษของผู้จัดส่ง HBL',
  AgentNetworkCustomerService: 'ตัวแทนฝ่ายบริการลูกค้าเครือข่าย',
  ReImportAfterModification: 'นำเข้าใหม่หลังจากแก้ไขได้',
  DownloadFailedData: 'ดาวน์โหลดข้อมูลล้มเหลว',
  TheCaseOfMultipleFirst: 'การขยายระยะเวลาไม่แนะนำให้ใช้ในกรณีที่มีหลายตัวเลือกโปรดตรวจสอบก่อนว่ามีติ๊กซ้ำซ้อน!',
  InvalidNumberEntered: 'ป้อนตัวเลขไม่ถูกต้อง!',
  TheOrThePartnerSigned: 'ลูกค้ารายนี้ได้เซ็นรับรองหรือหุ้นส่วนรายนี้ได้เซ็นรับรองแล้ว!',
  FirstDateCannotBeBlank: 'วันที่ติดต่อครั้งแรกไม่สามารถว่าง!',
  PleaseInTheTelephoneNumber: 'กรุณากรอกเบอร์โทรศัพท์!',
  PleaseRemoveTheTicketFirst: 'กรุณาถอดบัตรใบเล็กออกก่อน',
  ExpenseHasBeenEntered: 'รายการค่าธรรมเนียม',
  ConsolidationHasBeenDone: 'ทำมาแล้วและสั่งซื้อ',
  Save: 'บันทึกหรือไม่',
  PleaseEnterCurrencyExchangeRate: 'กรุณาใส่อัตราแลกเปลี่ยนสกุลเงิน',
  FailedOpenSalesQueryDetails: 'รายละเอียดการสอบถามการขายล้มเหลวในการเปิด!',
  pleaseEnterTemplateName: 'โปรดป้อนชื่อแม่แบบ',
  blank: 'ว่างเปล่า',
  PartnersBeenAddedToBlacklist: 'หุ้นส่วนถูกขึ้นบัญชีดำ!',
  ThisCustomerRiskyCustomerOperateOrdersWithCaution: 'โปรดระมัดระวังในการสร{0}เนินการคำสั่งสำหรับลูกค้าความเสี่ยง',
  AlreadyExistsOverwriteOriginalScheme: 'มีชื่อโครงร่างอยู่แล้ว คุณต้องการเขียนทับโครงร่างเดิมหรือไม่?',
  NoDataToSave: 'ไม่มีข้อมูลที่จะบันทึก',
  ColumnSettings: 'การตั้งค่าคอลัมน์',
  CurrentPage: 'หน้าปัจจุบัน',
  CurrentSelection: 'เลือกปัจจุบัน',
  NoModificationAllowedAfterBusinessSubmission: 'ไม่อนุญาตให้แก้ไขเพิ่มเติมหลังจากส่งธุรกิจแล้ว โปรดตรวจสอบว่ามีการอัพโหลดเอกสารที่เกี่ยวข้องก่อนส่งหรือไม่',
  AboutToUploadFiles: 'อัปโหลดไฟล์เร็ว ๆ นี้',
  SuccessfullyUploaded: 'อัปโหลดสำเร็จ',
  RetrievalOfAssignedPermissions: 'เรียกคืนสิทธิ์ที่ได้รับมอบหมาย',
  UploadResults: 'อัพโหลดผลลัพธ์',
  OnlyFilesFormatCanUploaded: 'สามารถอัพโหลดไฟล์ในรูปแบบ {0} เท่านั้น',
  VolumeAbnormalAndCannotUploaded: 'ปริมาณไฟล์ผิดปกติและไม่สามารถอัปโหลดได้',
  VolumeExceeds5mAndCannotUploaded: 'ปริมาณไฟล์มากกว่า 5M ไม่สามารถอัปโหลดได้',
  VolumeExceeds20mAndCannotUploaded: 'ปริมาณไฟล์มากกว่า 20 เมตรไม่สามารถอัปโหลดได้',
  PlaceOfDeliverySeaport: 'สถานที่จัดส่ง (ท่าเรือ)',
  PlaceOfDeliveryAirport: 'สถานที่จัดส่ง (ว่างเปล่า)',
  SailingDay: 'วันออกเรือ',
  BusinessCreationDate: 'วันสร้างธุรกิจ',
  DeliveryStation: 'สถานีจัดส่ง',
  NoDocumentsDeclaringOrNonSpermWhaleUsers: 'ยังไม่ได้สอบถามถึงเอกสาร และอาจอยู่ระหว่างการสำแดง หรือไม่ใช่ผู้ใช้วาฬสเปิร์ม',
  HasContainerNoOrSealNoForSameEqTypeAndEqSize: 'ชนิดกล่องนี้เชื่อมโยงข้อมูลการปิดผนึกกล่องคุณต้องการเปลี่ยนข้อมูลการบรรจุหีบห่อหน้าป้ายประเภทกล่องแบบซิงโครนัสหรือไม่?',
  SeaEqAsyncToContainerTip: 'ป้อนข้อมูลการปิดผนึกกล่องที่เกี่ยวข้องโปรดลบข้อมูลการปิดผนึกกล่องหน้ากล่องก่อน!',
  TheSynchronizedFileCannotBeEdited: 'แฟ้มที่ถูกซิงค์ไม่สามารถแก้ไขได้',
  TheSynchronizedFileIsNotDeleted: 'ไฟล์ที่ซิงค์ไม่สามารถลบได้',
  CurrentBusinessStatusCannotBeSynchronized: 'สถานะธุรกิจปัจจุบันไม่สามารถประสานกันได้',
  TheSynchronizedExpensesCannotBeDeleted: 'ค่าธรรมเนียมที่ถูกซิงค์ไม่สามารถลบได้ โปรดยกเลิกการซิงค์ค่าธรรมเนียมก่อน',
  CurrentlyThereIsNoSynchronizationCosts: 'ไม่มีค่าธรรมเนียมการซิงค์ในปัจจุบัน',
  ThereAreCurrentlyNoCancellableCharges: 'ไม่มีค่าธรรมเนียมการยกเลิกในปัจจุบัน',
  NoCurrentChargesCanBeCancelled: 'ไม่มีค่าธรรมเนียมการซิงค์ที่ยกเลิกได้ในปัจจุบัน',
  ChargeItemChangeTip: 'ชื่อค่าธรรมเนียมนี้ ข้อมูลการชำระค่าเริ่มต้นไม่สอดคล้องกับค่าธรรมเนียมปัจจุบัน จะมีการปรับปรุงหรือไม่?',
  SubscriptionInformation: 'ตั้งค่า (สาขา) บริษัท ที่คุณต้องการรับข้อมูลการสมัครสมาชิก',
  SetUpThePartners: 'ตั้งค่าพันธมิตรที่คุณต้องการสมัครสมาชิก',
  PleaseSelectAInformation: 'กรุณาเลือกข้อมูลราคาจัดส่ง',
  ThisRateHasExpired: 'ค่าจัดส่งนี้หมดอายุแล้ว!',
  ExternalUsersCannotEdit: 'ผู้ใช้ภายนอกไม่สามารถแก้ไขได้ โปรดไปที่หน้าผู้ใช้อีคอมเมิร์ซของพันธมิตร',
  CommunicationConfirmation: 'วันที่ออกเดินทางที่ตรงตามข้อกำหนดของเวลาไม่สามารถหาได้ในช่วงระยะเวลาที่ถูกต้องของราคาการขนส่ง โปรดสื่อสารกับผู้จองเพื่อยืนยัน!',
  CombineTips: 'ไม่สามารถเลือกตั๋วหลักสำหรับการรวมกันได้!',
  RepeatMblForSave: 'หมายเลขหลักซ้ำกัน,ยืนยันการเก็บหรือไม่',
  SystemAlert: 'ระบบแจ้งเตือน',
  NotRepeatOperation: 'มีการเปลี่ยนแปลงสถานะห้ามดำเนินการซ้ำ',
  FeesHaveBeenUsedForEditUnit: 'มีค่าใช้จ่ายที่ใช้รหัสหน่วยและไม่สามารถแก้ไขได้!',
  TheChargingUnitIsUsedByAnExistingChargePlanForEditUnit: 'แผนการเรียกเก็บเงินได้ถูกนำมาใช้กับรหัสหน่วยเรียกเก็บเงินนี้และไม่สามารถแก้ไขได้!',
  ApplyChangeChargeNotThrough: 'แล้ว {0} ไม่สามารถ {1} โปรดติ๊กอีกครั้ง',
  KingdeeNotExist: 'ข้อมูลไม่จำเป็นต้องซิงค์หรือระบบผีเสื้อทองไม่มีอยู่',
  ByAdjustmentDate: 'ตามวันที่ปรับ',
  ByBusinessDate: 'ตามวันที่ประกอบธุรกิจ',
  PleaseEnterTheFileType: 'โปรดป้อนประเภทไฟล์',
  NotExportToImportBusiness: 'คำสั่งนี้ไม่ใช่การส่งออกไปยังธุรกิจนำเข้าไม่สามารถประสาน!',
  JobNotOperateStatus: 'เดี่ยวนี้ไม่ได้เป็นบวกสถานะการทำงานไม่สามารถซิงค์!',
  JobShutOut: 'รายการนี้ถูกยกเลิกและไม่สามารถซิงค์ได้!',
  ChargeSyncSuccess: 'การประสานค่าใช้จ่ายสำเร็จ!',
  NoSynchronizedFees: 'ไม่มีค่าธรรมเนียมการซิงค์!',
  SaveColumnSettingsSameTime: 'บันทึกการตั้งค่าคอลัมน์การแสดงผลปัจจุบันในเวลาเดียวกัน',
  SaveScheme: 'แผนการบันทึก',
  ReceivableCharge: 'ลูกหนี้ (ค่าธรรมเนียม)',
  PayableCharge: 'จ่าย (ค่าธรรมเนียม)',
  TruckingNotExist: 'ทำกล่องข้อมูลไม่มีอยู่!',
  SaveDisplayColumns: 'บันทึกคอลัมน์การแสดงผล',
  NoPermissionToAddExpense: 'ไม่มีสิทธิ์เพิ่มค่าธรรมเนียม',
  NoPayableAddPermissionCannotImported: 'คุณไม่มีสิทธิ์ชำระค่าธรรมเนียมเพิ่มและไม่มีค่าธรรมเนียมการนำเข้า',
  NoPayableAddPermissionOnlyImportReceivable: 'คุณไม่มีสิทธิ์ชำระค่าธรรมเนียม นำเข้าเฉพาะค่าธรรมเนียมที่เรียกเก็บเท่านั้น',
  NoReceivableAddPermissionCannotImported: 'คุณไม่ได้รับสิทธิ์เพิ่มค่าธรรมเนียมลูกหนี้และไม่มีค่าธรรมเนียมการนำเข้า',
  NoReceivableAddPermissionOnlyImportPayable: 'คุณไม่มีสิทธิ์เพิ่มค่าธรรมเนียมลูกหนี้ นำเข้าเฉพาะค่าธรรมเนียมที่ต้องชำระ',
  OnlyRejectedBusinessesCanDelete: 'สามารถลบธุรกิจที่ถูกปฏิเสธได้เท่านั้น',
  OnlyRejectedBusinessesCanDeleteIgnoreOther: 'ทำได้เพียงลบธุรกิจที่ถูกปฏิเสธ และธุรกิจอื่นๆ ที่ปล่อยปละละเลย',
  SuccessfullySubmittedXBusiness: 'ส่งรายการธุรกิจ{num}เรียบร้อยแล้ว',
  SuccessfullySubmittedXBusinessOtherIgnore: 'ส่งรายการ {num}business เรียบร้อยแล้ว ส่วนที่เหลือสถานะก่อนการพิจารณาคดีไม่เป็นไปตามเงื่อนไขการส่ง',
  SuccessfullyRevokedXBusiness: 'การถอนธุรกิจรายการ {num} สำเร็จแล้ว',
  SuccessfullyRevokedXBusinessOtherIgnore: 'การถอนธุรกิจ {num} สำเร็จแล้ว ส่วนที่เหลือสถานะก่อนการพิจารณาคดีไม่เป็นไปตามเงื่อนไขการถอน',
  SuccessfullyConvertRealXBusiness: 'เปลี่ยนรูปแบบธุรกิจอย่างเป็นทางการเรียบร้อยแล้ว {num}',
  SuccessfullyConvertRealXBusinessOtherIgnore: 'ประสบความสำเร็จในการโอนย้ายธุรกิจอย่างเป็นทางการ {num}, ส่วนที่เหลือสถานะก่อนการพิจารณาคดีของธุรกิจไม่เป็นไปตามเงื่อนไขการโอนย้ายธุรกิจอย่างเป็นทางการ',
  ChargeSyncJobStateCheckFail: 'ค่าธรรมเนียมซิงค์สถานะธุรกิจ Checksuck ไม่ผ่าน',
  HaveChargeNotAllocatedAndtoContinue: 'มีค่าใช้จ่ายที่ไม่ได้แบ่งโปรดยืนยันว่าจะดำเนินการประสานค่าใช้จ่ายหรือไม่',
  PartnerAlreadyExistPleaseSelectOfficialCustomer: 'พันธมิตรมีอยู่แล้ว กรุณาเลือกระหว่างลูกค้าประจำ',
  PartnerHasMaintainedUndeToContinue: 'พันธมิตรนี้ได้รับการบำรุงรักษาภายใต้ 【{officeCode}】 คุณต้องการสร้างต่อไปหรือไม่?',
  fileManagement: 'การจัดการไฟล์',
  FilterValue: 'ค่าการกรอง',
  PriceAndNumIsNull: 'ราคาต่อหน่วย ปริมาณ ว่างเปล่า จะดำเนินการต่อหรือไม่',
  SyncContainerSealNoToBillOfLading: 'อัปเดต BL ข้อมูลการบรรจุหีบห่อ หมายเลขซีลกล่อง',
  AssociatedBillOfLadingCannotDelete: 'ใบตราส่งสินค้าที่เกี่ยวข้องไม่สามารถลบได้',
  AssociatedBillOfLadingCannotRemove: 'ใบตราส่งสินค้าที่เกี่ยวข้องไม่สามารถถอดออกได้',
  SettlementObjectAccountPeriod: 'ระยะเวลาการชำระบัญชีวัตถุ',
  InvoiceHeaderDifferent: 'การออกใบแจ้งหนี้ไม่สอดคล้องกันและจะดําเนินการต่อหรือไม่',
  Agreement: 'สอดคล้องกัน',
  NotAgreement: 'ไม่สอดคล้องกัน',
  AllocationNature: 'ลักษณะการแบ่ง',
  VirtualAllocation: 'การแบ่งปันเสมือนจริง',
  ActualSplit: 'แยกจริง',
  ShareTypeTip: 'สอดคล้องกัน: ประเภทการแบ่งของค่าธรรมเนียมทั้งหมดสอดคล้องกัน, แก้ไขประเภทการแบ่งของค่าธรรมเนียมหนึ่งรายการ, ค่าธรรมเนียมอื่น ๆ ทั้งหมดสอดคล้องกัน\#nไม่สอดคล้องกัน: ประเภทการแบ่งของค่าธรรมเนียมอาจไม่สอดคล้องกัน, เมื่อเปลี่ยนประเภทการแบ่งจะเปลี่ยนเฉพาะประเภทการแบ่งของค่าธรรมเนียมปัจจุบันเท่านั้น',
  VirtualAllocationAndActualSplitTip: 'การแบ่งปันเสมือน: ในใบสั่งซื้อหลักเพื่อทำการเรียกเก็บเงินการออกใบแจ้งหนี้การประยุกต์ใช้การชำระเงินการตัดบัญชีและการตั้งถิ่นฐานอื่น ๆ \# ค่าธรรมเนียมการแบ่งปันไปยังตั๋วขนาดเล็กเป็นเสมือนและสามารถดูได้เท่านั้นไม่มีการตั้งถิ่นฐานที่สำคัญ \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
  ActualSplitWarn: 'หมายเหตุ: หลังจากแยกจริงแล้วไม่เก็บค่าใช้จ่ายเดิมสำหรับคำสั่งหลักและไม่สามารถเรียกคืนได้โปรดดำเนินการด้วยความระมัดระวัง!',
  CannotActualSplitTip: 'ค่าใช้จ่ายของใบเรียกเก็บเงินหลักสร้างใบแจ้งหนี้การชำระเงินใบสมัครตัดบัญชีและการดำเนินการตั้งถิ่นฐานอื่น ๆ ไม่สามารถแยกค่าใช้จ่ายเป็นตั๋วขนาดเล็ก!',
  SharedChargeTotal: 'ค่าธรรมเนียมการแบ่งปัน ยอดรวม',
  DataHadUpdated: 'ข้อมูลได้รับการแก้ไขโปรดลองอีกครั้งหลังจากสอบถามอีกครั้ง',
  OpenSOPPanelNeedDoubleClick: 'หากต้องการเปิดแผง SOP คุณสามารถดับเบิลคลิกที่สถานะทางธุรกิจเพื่อเรียกคืนอีกครั้ง',
  Operator: 'พนักงานปฏิบัติการ',
  HaveInHand: 'กำลังดำเนินการ',
  Exception: 'ความผิดปกติ',
  TerminalCompany: 'บริษัท ท่าเทียบเรือ',
  TerminalLocation: 'บริษัท ท่าเทียบเรือ',
  DeliveryAddress: 'ที่อยู่รับสินค้า',
  TerminalAddress: 'ที่อยู่รับสินค้า',
  TcDeliveryAddress: 'ข้อมูลที่อยู่ของ บริษัท ท่าเรือในการรับสินค้า',
  ResultLogUploadFaild: 'ผลลัพธ์การบันทึกอัปโหลดการจัดเก็บเมฆล้มเหลวโปรดลองอีกครั้ง!',
  ConfigureDisplayColumns: 'กำหนดค่าคอลัมน์การแสดงผล',
  AllNames: 'ชื่อทั้งหมด',
  SelectedColumns: 'คอลัมน์ที่เลือก',
  NoPermissionViewSecondaryTable: 'คุณไม่มีสิทธิ์ตรวจสอบข้อมูลตารางรอง!',
  NoPermissionSetSecondaryTableColumns: 'คุณไม่มีสิทธิ์ที่จะตั้งค่าตารางระดับที่สองเพื่อแสดงคอลัมน์!',
  UpdateNoticeDetails: 'ประกาศการอัปเดต 【เนื้อหารายละเอียด】',
  DontRemindMeAgain: 'ไม่มีการแจ้งเตือนครั้งต่อไป',
  NewInnerContractNo: 'สร้างใหม่ประมาณภายใน',
  EditInnerContractNo: 'การปรับเปลี่ยนพันธสัญญาภายใน',
  AreYouSureToCancelThisData: 'ยืนยันจะเพิกถอนข้อมูลบทความนี้หรือไม่',
  HasBeenUsedAndCannotEditContractNo: 'ใช้แล้วไม่สามารถแก้ไขเลขหมายนัดได้',
  HasBeenUsedAndCannotBeDeleted: 'ใช้แล้วไม่สามารถลบได้',
  ApplicableRoute: 'เส้นทางที่เกี่ยวข้อง',
  IsEnable: 'ไม่ว่าจะเป็นการเปิดใช้งาน',
  ContractNoUseState: 'ประมาณ สถานะการใช้งาน',
  NotUse: 'ไม่ได้ใช้',
  Occupies: 'การครอบครอง',
  DataLoadingFailed: 'การโหลดข้อมูลล้มเหลว...',
  ExportExcel: 'ส่งออก Excel',
  ExportExcel2: 'ส่งออก EXCEL',
  ExportPDF: 'ส่งออกไฟล์ PDF',
  ExportWord: 'ส่งออกเวิร์ด',
  ExportPPT: 'ส่งออก PPT',
  NoDataIsCurrentlySelected: 'ข้อมูลปัจจุบันยังไม่ได้ถูกเลือก',
  SelectAll: 'เลือกทั้งหมด',
  CustomerSelfIssue: 'ใบสั่งซื้อจากลูกค้าเอง',
  Clear: 'ล้าง',
  QuickOfLadingNumberCustomsNumber: 'ดึงข้อมูลได้อย่างรวดเร็ว: หมายเลขธุรกิจ / หมายเลข B / L / หมายเลขปิด',
  QuickMnemonicabbreviationChineseAndEnglishNames: 'ดึงข้อมูลได้อย่างรวดเร็ว: รหัสช่วยจำ / ชื่อย่อ / ชื่ออังกฤษกลาง',
  InvoiceNumber: '/ หมายเลขใบแจ้งหนี้',
  BusinessNumber: '/ หมายเลขธุรกิจ',
  BillingNumber: '/ หมายเลขบิล',
  PaymentApplicationNumber: '/ หมายเลขคำขอชำระเงิน',
  VerificationNumber: '/ หมายเลขพินนิวเคลียร์',
  ReconciliationNumber: '/ หมายเลขใบแจ้งยอดบัญชี',
  ActualPaymentAndReceiptNumber: '/ หมายเลขรับชำระเงินจริง',
  DeliveryOrderNumber: '/ ใส่หมายเลขเดียว',
  ProgramNumber: '/ หมายเลขโครงการ',
  QuickSearch: 'ดึงข้อมูลได้อย่างรวดเร็ว',
  SearchBeRemovedNotFound: 'ไม่พบรายการที่ต้องการลบ',
  Error3: 'ข้อผิดพลาด',
  AdvancedSchemeLoadingFailed01: 'ล้มเหลวในการโหลดแพกเกจการกำหนดค่าแบบสอบถามขั้นสูง 01=:',
  TheFoundPleaseSelectScheme: 'ไม่พบแพ็กเกจ กรุณาเลือกแพ็กเกจอื่น',
  AreYouWantToDelete: 'แน่ใจนะว่าต้องการลบ?',
  Tip: 'เคล็ดลับ',
  DeleteSchemeFailed: 'การลบรูปแบบล้มเหลว:',
  N1Exceeds4MBCannotUploaded: '1 ไฟล์มีปริมาณมากกว่า 4MB และไม่สามารถอัปโหลดได้',
  N1Exceeds20MBCannotUploaded: '1 ไฟล์มีปริมาณมากกว่า 20 MB และไม่สามารถอัปโหลดได้',
  DeleteFileFailed: 'การลบแฟ้มล้มเหลว!',
  Edit: 'บรรณาธิการ',
  SelectFile: 'เลือกไฟล์',
  DeleteFile: 'ลบไฟล์',
  Upload: 'อัพโหลด',
  UploadFile: 'อัปโหลดไฟล์',
  FileName: 'ชื่อแฟ้ม',
  FileType: 'ประเภทไฟล์',
  FileSize: 'ขนาดไฟล์',
  Uploader: 'อัพโหลดโดย',
  UploadTime: 'เวลาอัพโหลด',
  UploadProgress: 'อัพโหลดความคืบหน้า',
  Uploading2: 'อัพโหลด...',
  WaitingForUpload: 'รอการอัปโหลด',
  DocumentCategory: 'ประเภทเอกสาร',
  PlatformCustomerService: 'ฝ่ายบริการลูกค้าแพลตฟอร์ม',
  Yes: 'ใช่',
  No: 'ไม่',
  Confirm: 'ยืนยัน',
  SaveColumnStatus: 'บันทึกสถานะคอลัมน์',
  ResetColumnStatus: 'รีเซ็ตสถานะคอลัมน์',
  SaveColumnStatusSuccess: 'บันทึกสถานะคอลัมน์สำเร็จ',
  SaveColumnStatusFailed: 'การบันทึกสถานะคอลัมน์ล้มเหลว',
  ResetColumnStatusSuccess: 'รีเซ็ตสถานะคอลัมน์สำเร็จ',
  ChatWindow: 'หน้าต่างแชท',
  Internal: 'ภายใน',
  Communication: 'การสื่อสาร',
  InternalCommunication: 'การสื่อสารภายใน',
  ExternalCommunication: 'การสื่อสารภายนอก',
  Customer: 'ลูกค้า',
  Reset: 'รีเซ็ต',
  Search: 'ค้นหา',
  CurrentlySelectedItem: 'ตัวเลือกปัจจุบัน:',
  Port: 'ท่าเรือ',
  State: 'รัฐ',
  FileAbnormalCannotBeUploaded: 'ปริมาณไฟล์ผิดปกติและไม่สามารถอัปโหลดได้',
  File20MCannotBeUploaded: 'ปริมาณไฟล์มากกว่า 20 เมตรไม่สามารถอัปโหลดได้',
  UploadSuccessful: 'อัปโหลดสำเร็จ',
  ImportFile: 'นำเข้าไฟล์',
  PrintTemplate: 'แม่แบบการพิมพ์:',
  Code: 'รหัส',
  ChineseName: 'ชื่อภาษาจีน',
  EnglishName: 'ชื่อภาษาอังกฤษ',
  Country: 'ประเทศ',
  Region: 'ภูมิภาค',
  Name2: 'ชื่อ-นามสกุล',
  StartDate: 'วันที่เริ่มต้น',
  To: 'ถึง',
  EndDate: 'วันที่สิ้นสุด',
  CurrentAuthorizations: 'การอนุญาตที่ครอบครองอยู่ในปัจจุบัน',
  Refresh: 'รีเฟรช',
  User: 'ผู้ใช้:',
  Authorization: 'การอนุญาต',
  Time: 'เวลา:',
  AuthorizationUseHistory: 'ประวัติการใช้งานที่ได้รับอนุญาต:',
  AuthorizationFailed: 'การอนุญาตล้มเหลว',
  SendTest: 'ส่งการทดสอบ',
  CurrentPersonalAuthorizationList: 'รายชื่อบุคคลที่ได้รับอนุญาตในปัจจุบัน',
  SendTo: 'ส่งถึง:',
  Confirm2: 'ระบุ',
  Cancel: 'การยกเลิก',
  Close: 'ปิด',
  Open: 'เปิด',
  AuthorizationItemDescription: 'คำอธิบายรายการที่ได้รับอนุญาต',
  AuthorizationItem: 'รายการที่ได้รับอนุญาต',
  AuthorizationStatus: 'สถานะการอนุญาต',
  NotSet: 'ยังไม่ได้ตั้งค่า',
  StatusChangeTime: 'เวลาเปลี่ยนสถานะ',
  Operation: 'การดำเนินงาน',
  PleaseAddProductDescriptionHere: 'กรุณาเพิ่มคำอธิบายผลิตภัณฑ์ที่นี่',
  WeChatMessagePush: 'WeChat ข้อความ Push',
  MarqueeSwitch: 'สวิตช์ไฟ Running Horse',
  PleaseInEmailPasswordauthorizationCode: 'กรุณากรอกรหัสผ่านกล่องจดหมาย / รหัสการอนุญาต!',
  PleaseFillInRecipientEmail: 'กรุณากรอกข้อมูลในกล่องจดหมายรับ!',
  EmailSettingsTestEmail: 'การตั้งค่ากล่องจดหมาย - จดหมายทดสอบ',
  SendSuccessfully: 'ส่งเรียบร้อยแล้ว',
  PaymentUponReceipt: 'ดูแผ่นวางจำหน่าย',
  All: 'ทั้งหมด',
  Unread: 'ยังไม่ได้อ่าน',
  Read: 'อ่านแล้ว',
  MMDDDayHHMm: 'MM เดือน DD Day HH: mm',
  AssignSales: 'การกระจายการขาย',
  ReleaseSales: 'ปล่อยขาย',
  ReviewSales: 'ตรวจสอบการขาย',
  SuccessfullyGrabCustomer: 'คว้าความสำเร็จของลูกค้า',
  GrabCustomerFailed: 'การแย่งลูกค้าล้มเหลว',
  ScheduleReminder: 'การแจ้งเตือนกำหนดการ',
  CustomerExpirationReminder: 'การแจ้งเตือนวันหมดอายุของลูกค้า',
  BusinessReviewReminder: 'การแจ้งเตือนการตรวจสอบธุรกิจ',
  CustomsDeclarationReminder: 'ประกาศเตือนศุลกากร',
  AbnormalHandlingOfBox: 'การจัดการความผิดปกติของกล่อง',
  DeparturePickUpContainerWarning: 'ตู้เตือนผู้โดยสารขาออก',
  BoxArrivingAtFactoryWarning: 'กรณีไปยังโรงงานเตือนภัย',
  BoxLeavingFactoryWarning: 'กรณีออกจากโรงงานเตือนภัย',
  CustomsReleaseWarning: 'คำเตือนเกี่ยวกับการปล่อยศุลกากร',
  TerminalReleaseWarning: 'คำเตือนการปล่อยท่าเรือ',
  BoardingWarning: 'คำเตือนการขึ้นเรือ',
  DepartureWarning: 'เตือนภัยขาออก',
  ArrivalWarning: 'คำเตือนขาเข้า',
  ReturningBoxWarning: 'เตือนภัยล่วงหน้า',
  SystemArrearsReminder: 'ระบบแจ้งเตือนการค้างชำระ',
  ChangeReviewAndApprovalReminder: 'การแจ้งเตือนการอนุมัติการตรวจสอบค่าธรรมเนียมการเปลี่ยนแปลง',
  DefaultMessage: 'จดหมายปริยาย',
  Message: 'ข้อความระบบ',
  SelectTemplate: 'เลือกแม่แบบ',
  PleaseSelectTheExportTemplate: 'โปรดเลือกเทมเพลตการส่งออก',
  Upload0UploadFailure0: 'อัปโหลดสำเร็จ: {0} รายการ, อัปโหลดล้มเหลว: {1} รายการ',
  SuccessfulFailure0ConfirmSave: 'อัปโหลดสำเร็จ: {0} รายการ, ล้มเหลว: {1} รายการ, ยืนยันคุณต้องการบันทึกหรือไม่?',
  Only0FormatCanUploaded: 'สามารถอัพโหลดไฟล์ในรูปแบบ {0} เท่านั้น',
  YouToOpenTheModule: 'คุณไม่มีสิทธิ์ที่จะเปิดโมดูล 【{0}】',
  Upload0UploadFailed0: 'อัปโหลดสำเร็จ: {0} รายการ, อัปโหลดล้มเหลว: {1} รายการ',
  All2: '(ทั้งหมด)',
  NumberOfPiecescommissionactual: 'จำนวนชิ้น (คณะกรรมการ / ความจริง)',
  LetterOfCreditTerms: 'เงื่อนไข L / C',
  N4InsuranceCompletion: '4 ทำประกันเสร็จสมบูรณ์',
  N2Inquiry: '2 สอบถามรายละเอียดเพิ่มเติม',
  SensitiveWords: 'แถบคำที่ละเอียดอ่อน',
  FreightRateDetails: 'รายละเอียดค่าจัดส่ง',
  Manufacturer: 'ผู้ผลิต',
  ShipName: 'ชื่อเรือ:',
  IsItCorrect: 'ถูกต้องหรือไม่',
  BoxReturnedFromTheArea: 'ข้อมูลกล่องส่งกลับจากท่าเรือ:',
  CurrentlyStatusAndCannotDeleted: 'ขณะนี้อยู่ระหว่างแก้ไขไม่สามารถลบได้',
  ChineseAbbreviationOfTheCompany: 'ชื่อย่อของ บริษัท ในภาษาจีน:',
  TheTheCompanyCannotEmpty: 'ชื่อย่อภาษาอังกฤษของ บริษัท ไม่สามารถเว้นว่างได้',
  Voyage: 'การเดินทาง:',
  ShippingSchedule: 'ระยะเวลาเรือ:',
  PortOfDepartureUpdate: 'อัปเดตพอร์ตการจัดส่ง',
  DestinationPortUpdate: 'อัปเดตพอร์ตปลายทาง',
  ChatInside: 'การสื่อสารภายใน',
  ChatByClient: 'การสื่อสารภายนอก',
  DoubleClickToSelectState: 'คลิกสองครั้งที่กล่องข้อความเพื่อเลือกแบบสอบถามสถานะ',
  StateQuery: 'สอบถามสถานะ',
  EdiStateQuery: 'สอบถามสถานะ EDI',
  BookingEdiSendType: 'ช่องจอง EDI',
  BookingEdiSendTime: 'จองเวลา EDI',
  imConnecting: 'กำลังพยายามเชื่อมต่ออยู่',
  imConnectFailed: 'การเชื่อมต่อเซสชันล้มเหลว โปรดเปิดใหม่หลังจากปิด',
  SwitchBranchAndOpenModuleTipAllEdit: 'โปรดบันทึกข้อมูลและปิดโมดูลที่เปิดอยู่ก่อนที่จะสลับสาขาตอนนี้เปิด {0} โมดูลจะปิดโมดูลทั้งหมดหรือไม่?',
  SwitchBranchAndOpenModuleTipNotEdit: 'โปรดปิดโมดูลที่เปิดอยู่แล้วก่อนที่จะเปลี่ยนสาขาและตอนนี้กำลังเปิด {0} โมดูลจะปิดทั้งหมดหรือไม่?',
  SwitchBranchAndOpenModuleTipPartEdit: 'โปรดบันทึกข้อมูลและปิดโมดูลก่อนที่จะเปลี่ยนสาขาปัจจุบันโมดูลที่เปิด {0} ไม่ได้บันทึกและปิดจะปิดทั้งหมดหรือไม่?',
  PrintRecordsOverLimitTip: 'จำนวนระเบียนที่พิมพ์เกินกว่าขีด จำกัด บนของระบบจะส่งออกโดยตรงหรือไม่?',
  PrintRecordsOver100Tip: 'จำนวนระเบียนที่พิมพ์มากกว่า 100 รายการอาจใช้เวลาในการโหลดนานกว่าจะส่งออกโดยตรงหรือไม่?',
  ContinuePreview: 'แสดงตัวอย่างต่อไป',
  NotSupported: 'ไม่รองรับการแสดงผลข้อมูลหลายช่วงชั่วคราว {0}',
  PleaseFillInCorrectly: 'กรุณากรอกข้อมูลหลายขั้นตอนให้ถูกต้องและไม่อนุญาตให้ว่างตรงกลาง',
  DoNotEmpty: 'ห้ามล้างข้อมูลหนึ่งช่วง',
  AirlineReplacement: 'สายการบิน 1 เที่ยวบินมีการเปลี่ยนแปลง โดยจะทำการล้างข้อมูลสนามบินของท่าอากาศยานต้นทาง (สนามบิน, เวลาเข้าจริง, เวลาเช็คอินจริง, เวลาออกเดินทางโดยประมาณ, เวลาออกเดินทางจริง) และนำข้อมูลกลับมาใช้ใหม่',
  AirlineReplacement1: '1. สายการบินที่แก้ไขแล้วไม่ได้อยู่ในรายชื่อสายการบินที่รองรับการสมัครสมาชิกจะไม่สามารถรับข้อมูลได้',
  AirlineReplacement2: '2. มีการเปลี่ยนแปลงสายการบิน 1 เที่ยวบิน และจะทำการล้างข้อมูลสนามบินของท่าอากาศยานต้นทาง (สนามบิน เวลาเข้าจริง เวลาเข้าจริง เวลาออกเดินทางโดยประมาณ เวลาออกเดินทางจริง)',
  AirlineReplacementLast: 'สายการบินสุดท้ายมีการเปลี่ยนแปลงข้อมูลที่สนามบินปลายทาง (เวลาโดยประมาณ, เวลามาถึงจริง, เวลารับบัตรจริง, เวลาขนถ่ายจริง, เวลาแจ้งเตือนการมาถึงจริง, เวลารับของจริง) และข้อมูลจะถูกลบอีกครั้ง',
  AirlineReplacementLast2: '2. สายการบินปลายทางมีการเปลี่ยนแปลงข้อมูลท่าอากาศยานปลายทาง (เวลาโดยประมาณ, เวลามาถึงจริง, เวลารับบัตรจริง, เวลาขนถ่ายจริง, เวลาแจ้งการมาถึงจริง, เวลารับของจริง)',
  ViewShippingTracking: 'ในกรณีที่มีสายการบินที่แตกต่างกันหลายเที่ยวบินโปรดตรวจสอบข้อมูล 【ติดตามการจัดส่งสินค้า】 หน้า',
  IntermediateAirline: 'สายการบินที่แก้ไขแล้วไม่ได้อยู่ในรายชื่อสายการบินที่รองรับการสมัครสมาชิกจะไม่สามารถรับข้อมูลเที่ยวบินที่สองได้',
  ExportingPleaseWait: 'กำลังส่งออกไฟล์ โปรดรอสักครู่',
  ExportTakePlaceInBackground: 'คุณสามารถออกจากหน้าและการส่งออกจะเกิดขึ้นในพื้นหลัง',
  CompletionDownloadMessageReminderInRightCorner: 'กรุณาไปที่มุมขวาบนเมื่อคุณเสร็จสิ้น"การแจ้งเตือนข้อความ"ดาวน์โหลดใน {0}',
  FileExportCompletionReminder: 'การแจ้งเตือนการส่งออกไฟล์เสร็จสมบูรณ์',
  SyncPartnerToFinanceCodeReminder: 'การแจ้งเตือนเสร็จสิ้นการนำเข้ารหัสลูกค้า',
  NoNewPermissionsForFees: 'ไม่มีสิทธิ์เพิ่มค่าธรรมเนียม',
  NoPayChargesImport: 'คุณไม่ได้รับสิทธิ์เพิ่มค่าธรรมเนียมลูกหนี้และไม่มีค่าธรรมเนียมการนำเข้า',
  NoCostChargesImport: 'คุณไม่มีสิทธิ์ชำระค่าธรรมเนียมเพิ่มและไม่มีค่าธรรมเนียมการนำเข้า',
  OnlyCostChargesImport: 'คุณไม่มีสิทธิ์เพิ่มค่าธรรมเนียมลูกหนี้ นำเข้าเฉพาะค่าธรรมเนียมที่ต้องชำระ',
  OnlyPayChargesImport: 'คุณไม่มีสิทธิ์ชำระค่าธรรมเนียม นำเข้าเฉพาะค่าธรรมเนียมที่เรียกเก็บเท่านั้น',
  ConfirmDeleteN: 'ยืนยันการลบระเบียน {0} นี้หรือไม่?',
  AffiliatedBranchStyle: 'รูปแบบสาขาที่เป็นของ',
  DisplayByOrganizationalStructure: 'แสดงตามสถาปัตยกรรมองค์กร',
  AllDisplay: 'แสดงทั้งหมด',
  FileView: 'การดูไฟล์',
  NotPermissionToEditFilesByOtherUsers: 'สิทธิ์ไม่เพียงพอ: ไม่มีสิทธิ์แก้ไขไฟล์ที่อัปโหลดโดยผู้ใช้รายอื่น',
  NotMatchingTheCostOfTheProjectCanBeDelete: 'ไม่มีรายการค่าใช้จ่ายที่ตรงกันที่จะลบ',
  ThisPartnerDoesNotSupportEnterReceivableFees: 'พันธมิตรนี้ไม่สนับสนุนค่าธรรมเนียมการรับเข้า',
  ThisPartnerDoesNotSupportEnterPayableFees: 'พันธมิตรนี้ไม่สนับสนุนค่าใช้จ่ายที่ต้องชำระในรายการ',
  Can_Changed: 'เปลี่ยนแผ่น',
  Customer_Service: 'ฝ่ายบริการลูกค้า',
  Documentation_Department: 'แผนกเอกสาร',
  Countries_Regions_Destination: 'ปลายทาง ประเทศ / ภูมิภาค',
  CargoDocAndContainerQWTNotSame: 'ข้อมูลการบรรจุ B / L ไม่สอดคล้องกับข้อมูลการบรรจุธุรกิจ!',
  Some_Items_Have_Expired: 'รายการค่าธรรมเนียมบางส่วนล้มเหลวการคัดลอกล้มเหลว',
  SentDestinationPortAgentTip: 'เวลาถูกส่งจดหมายพอร์ตผ่านฟังก์ชันการส่งเพียงคลิกเดียว',
  SendFileVerification: 'ส่งการตรวจสอบไฟล์',
  SendFileVerificationSuccessTip: 'การยืนยันเอกสารสำเร็จโปรดคลิก 【ขั้นตอนต่อไป】 เพื่อดำเนินการต่อข้อความหรือ 【ขั้นตอนต่อไป】',
  SendFileVerificationExceptionTip: 'ข้อยกเว้นในการตรวจสอบไฟล์ กรุณาแตะที่ 【ขั้นตอนต่อไป】 เพื่อดำเนินการต่อข้อความ หรือ 【ขั้นตอนต่อไป】',
  Validating: 'ตรวจสอบสถานะ',
  MasterCheckExist: 'การตรวจสอบตั๋วหลัก: มี {0} หรือไม่',
  SmallCheckExist: 'การตรวจสอบตั๋วขนาดเล็ก: มี {0} หรือไม่',
  EmailAttachments: 'เอกสารแนบจดหมาย',
  DeleteAttachTip: 'แน่ใจนะว่าคุณต้องการลบสิ่งที่แนบมานี้?',
  LocalEmailSentSuccess: 'กล่องจดหมายภายในเครื่องส่งสำเร็จหรือไม่',
  LocalEmailTooLarge: 'เนื้อหาของข้อความมีขนาดใหญ่เกินไปที่จะข้ามไปยังกล่องจดหมายท้องถิ่น!',
  Lack: 'ขาดหายไป',
  FileDragArea: 'ลากไฟล์เพื่ออัปโหลดในพื้นที่นี้',
  EnterKeyword: 'ป้อนคำหลัก',
  ClearSelectedItems: 'ล้างตัวเลือก',
  ManifestFileNumBox: 'จำนวนไฟล์ MANIFEST เท่ากับจำนวนกล่อง',
  ManifestFileNumNotEqualBox: '【ปริมาณกล่อง】: {0} / 【MAINFIEST】 จำนวนไฟล์: {1}, MANIFEST ไฟล์และปริมาณกล่องไม่สอดคล้องกัน',
  TheSelectedDataIsIgnoredSuccessfully: 'ข้อมูลที่เลือก ไม่สนใจความสำเร็จ',
  SelectedDataHasBeenBatchProcessedSuccessfully: 'ข้อมูลที่เลือก ยกเลิกการเพิกเฉยต่อความสำเร็จ',
  ThereAreNoNegligibleCosts: 'ไม่มีค่าธรรมเนียม',
  ThereAreNoFeesThatCanBeEliminated: 'ไม่มีค่าธรรมเนียมการยกเลิก',
  OnlyUnRead: 'ดูเพียงที่ยังไม่ได้อ่าน',
  AllMarksRead: 'อ่านแท็กทั้งหมด',
  MessageConfig: 'การตั้งค่าข้อความ',
  SaleProductCodeCannotBeNull: 'สินค้าที่สามารถขายได้ต้องไม่ว่างเปล่า',
  FullOrInsideCannotBeNull: 'ตลอดการเดินทาง / ภายในประเทศไม่สามารถว่างได้',
  NotNullForMapping: 'ป้ายหน้าพื้นฐาน "[ผลิตภัณฑ์ที่ขายได้] และ [ทั้งหมด/ในประเทศ] ฟิลด์ไม่สามารถว่างเปล่า" โปรดป้อนก่อนที่จะเลือกค่าธรรมเนียม',
  DifferentJobOrBusinessFieldValues: 'มีตำแหน่งงานหรือค่าฟิลด์ธุรกิจที่แตกต่างกันหลายตำแหน่งรวมอยู่ในธุรกิจที่เลือกและเมื่อไม่ได้ตั้งค่าโพสต์และค่าฟิลด์เดิมจะยังคงอยู่',
  PreserveOriginalValue: 'รักษาต้นฉบับ',
  SelectSynchronizedFields: 'เลือกฟิลด์ซิงค์',
  SynchronizedFields: 'ฟิลด์ซิงค์',
  RunSuccess: 'ความสำเร็จในการดำเนินงาน',
  RunFail: 'ทำงานล้มเหลว',
  PleaseUpload: 'ค่าเดิมว่างเปล่าโปรดอัปโหลดไฟล์',
  CodeTip: '1, ภาษารหัสที่นี่: javascript' +
    '\n2, ชื่อวัตถุต้นฉบับที่จะประมวลผลเริ่มต้นคือ: ผลลัพธ์ (เนื้อหาทั้งหมดของผลลัพธ์คือวัตถุ JSON ของค่าต้นฉบับ)' +
    '\n3 เพื่อให้ได้องค์ประกอบแรกคุณสามารถใช้: result [0]. (องค์ประกอบนับจากลำดับที่ 0)' +
    '\n4 เพื่อให้ได้ค่าของช่องข้อมูลที่ระบุคุณสามารถใช้: result[0].text.data[\'包装\']' +
    '\n5 เพื่อปรับเปลี่ยนค่าของแพคเกจคุณสามารถใช้: result[0].text.data[\'包装\'] =\'PPK\'' +
    '\n6 เพื่อแทนที่ทั้งหมดในแพคเกจ"P"มูลค่าที่สามารถใช้: result[0].text.data[\'包装\'] =result[0].text.data[\'包装\'].replaceAll(\'P\',\'B\');',
  BlIsIssued: 'ออกใบแจ้งหนี้แล้ว',
  NoVirtualHBLTip: 'ธุรกิจนี้ไม่มีใบสั่งแบ่งรูปแบบโปรดติ๊กแบ่งรูปแบบก่อนดำเนินการ',
  NoVirtualHBLAuthTip: 'ไม่มีสิทธิ์ในการลงนามในหน้านี้โปรดติดต่อผู้ดูแลระบบเพื่อใช้หลังจากกำหนดค่าแบบฟอร์มแยกสิทธิ์!',
  FieldValueCannotBeNull: '{0} ไม่สามารถว่างได้',
  ImportFailedFileNameNotMatch: 'นำเข้าล้มเหลว ชื่อแฟ้มไม่ได้เริ่มต้นด้วย ISF5 หรือ ISF10',
  ISF5File: 'ลายฉลุ ISF5',
  ISF10File: 'ISF10 ลายฉลุ',
  BookingLabel: 'การจองห้องโดยสาร',
  BatchPurchasePriceLock: 'โปรดเลือกธุรกิจที่ไม่มีการล็อคราคาซื้อเพื่อดำเนินการ',
  BatchPurchasePriceUnLock: 'โปรดเลือกธุรกิจที่ราคาซื้อถูกล็อคเพื่อดำเนินการ',
  BatchSellingPriceUnLock: 'โปรดเลือกธุรกิจที่มีการล็อกราคาขายเพื่อดำเนินการ',
  BatchSellingPriceLock: 'โปรดเลือกธุรกิจที่ไม่มีการล็อกราคาขายเพื่อดำเนินการ',
  NotPermissionToViewFiles: 'มีแฟ้ม {0} ที่ดูโดยไม่มีสิทธิ์และไม่สามารถส่งข้อความได้',
  ContainerTotalNeedEqual: 'ตู้คอนเทนเนอร์ 【จำนวนชิ้นบรรจุด้านนอก】 【จำนวนชิ้นบรรจุด้านนอก】 【จำนวนชิ้นบรรจุด้านนอก】 【จำนวนชิ้นบรรจุด้านนอก】',
  PackingAddNotRepeat: 'เพิ่มข้อมูลบรรจุภัณฑ์ที่เลือกไว้ อย่าเพิ่มซ้ำ',
  selectRequirement: 'คลิกสองครั้งเพื่อเลือกข้อกำหนดการดำเนินการ',
  DataGroup: 'การจัดกลุ่มข้อมูล',
  CloseRefreshNeedMannulUpdate: 'เมื่อปิดการรีเฟรชอัตโนมัติจำเป็นต้องทำการอัปเดตข้อมูลโดยแตะที่มนุษย์ 【รีเฟรช】',
  RefreshRule: 'รีเฟรชกฎ:',
  NodeRecord: 'บันทึกโหนด:',
  HomePageNotRefreshData: 'ไม่รีเฟรชข้อมูลโดยอัตโนมัติเมื่อเข้าสู่หน้าแรก',
  DisplayLastClickNode: 'แสดงโหนดของการคลิกครั้งสุดท้าย',
  RetainQueryCondition: 'และรักษาเงื่อนไขการสืบค้นของโหนดนี้',
  N0VerificationPassed: '【{0}】 การตรวจสอบ ผ่าน',
  ConsigneeCompanyName: 'ชื่อธุรกิจผู้รับ',
  TaskBoard: 'Kanban ภารกิจ:',
  AlertNode: 'โหนดเตือนภัยล่วงหน้า:',
  DoOfQueryResultsTemplates: 'ไม่แสดงตามจำนวนผลการค้นหารีเซ็ตเงื่อนไขการค้นหาเมื่อเปลี่ยนแม่แบบ',
  SendPortAgentByNumber: 'ส่งตัวแทนปลายทาง-ตามหมายเลขตู้',
  SendAgentByCaseNumber: 'ส่งตัวแทนประจำชุด-ตามหมายเลขตู้',
  SetOrderAgency: 'ตัวแทนประจำชุด',
  LastSentTime: 'เวลาส่งครั้งล่าสุด',
  ShippingCompanyCannotBeModifiedBylclMasterUuid: 'ไม่อนุญาตให้แก้ไขบริษัทเรือ เมื่อ Master LCL ไม่ว่าง',
  ShippingCompanyCannotBeModifiedByCharge: 'ไม่อนุญาตให้แก้ไขบริษัทเรือ เนื่องจากมีค่าใช้จ่ายที่เกี่ยวข้อง',
  ShippingCompanyNotExist: 'ไม่พบบริษัทเรือ',
  AirCompanyCannotBeModifiedBylclMasterUuid: 'ไม่อนุญาตให้แก้ไขสายการบิน เมื่อ Master LCL ไม่ว่าง',
  AirCompanyCannotBeModifiedByCharge: 'ไม่อนุญาตให้แก้ไขสายการบิน เนื่องจากมีค่าใช้จ่ายที่เกี่ยวข้อง',
  AirCompanyNotExist: 'ไม่พบสายการบิน',
  SeToSiCannotBeUpdatedToShippingCompany: 'ไม่อนุญาตให้แก้ไขบริษัทเรือสำหรับงานข้ามเทนแนท Export เป็น Import',
  BusinessOperationsCannotBeModified: 'มีตำแหน่งสินค้าที่เกี่ยวข้องกับสถานะธุรกิจ "ตรวจสอบแล้ว", "ส่งแล้ว", "ส่งล่วงหน้า" หรือ "กำลังส่ง" ไม่สามารถแก้ไขผ่านการเปลี่ยนเรือแบบกลุ่มได้ ต้องแก้ไขแต่ละรายการแยกกัน',
  UpdateVoyageInfoMessage: 'อัปเดตข้อมูลเที่ยวเรือ ซึ่งจะอัปเดตข้อมูลที่เกี่ยวข้องในการดำเนินการส่งออกทางทะเลด้วย ระบบจะส่งอีเมลแจ้งเตือนหลังจากยืนยัน:',
  updateBatchTips: 'อัปเดตข้อมูลเที่ยวบินจะอัปเดตข้อมูลที่เกี่ยวข้องในการดำเนินงานส่งออกทางทะเลพร้อมกัน ยืนยันหรือไม่?',
  batchUpdateShipSuccess: 'การโอนเรือแบบกลุ่มสำเร็จแล้ว',
  Russian: 'ภาษารัสเซีย',
  Vietnamese: 'ภาษาเวียดนาม',
  Thai: 'ภาษาไทย',
  SelectTransshipmentStatusErrorPrompt: 'รองรับการแก้ไขเป็นชุดสำหรับธุรกิจการดำเนินงานในเชิงบวกเท่านั้น',
  NoAccessPermission: 'ไม่มีสิทธิ์เข้าถึง'
}
